<template>
            <div class="flex-1 flex flex-col overflow-hidden" style="background:var(--surface);" v-if="currentView === 'webmail'">
                <!-- Webmail Header -->
                <div style="flex-shrink:0;display:flex;flex-direction:column;border-bottom:1px solid var(--gray-200);background:var(--surface);">
                    <!-- Row 1: title + main actions -->
                    <div class="webmail-header-row" style="display:flex;align-items:center;justify-content:space-between;padding:0.5rem 1rem;gap:0.5rem;min-height:48px;flex-wrap:wrap;">
                        <div class="flex items-center gap-3" style="min-width:0;flex-shrink:1;">
                            <button class="topbar-hamburger" @click="toggleMobileSidebar()" aria-label="開啟選單">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                            </button>
                            <div class="page-title" style="margin:0;">我的信箱</div>
                            <button @click="switchWebmailTab('mail')" :class="webmailTab === 'mail' ? 'active' : ''" class="tab-item">郵件</button>
                            <button @click="switchWebmailTab('calendar')" :class="webmailTab === 'calendar' ? 'active' : ''" class="tab-item">行事曆</button>
                            <button @click="switchWebmailTab('settings'); fetchMailSignature()" :class="webmailTab === 'settings' ? 'active' : ''" class="tab-item">⚙️ 設定</button>
                            <span style="font-size:0.875rem;color:var(--gray-500);" v-if="webmailTab === 'mail'">({{ currentFolder }})</span>
                            <span style="font-size:0.875rem;color:var(--gray-500);" v-else-if="webmailTab === 'calendar'">({{ formatWebmailMonthLabel(webmailCalendarMonth) }})</span>
                        </div>
                        <div v-if="hasValidMailSession && webmailTab === 'mail'" class="webmail-header-actions" style="display:flex;align-items:center;gap:0.375rem;flex-shrink:0;overflow-x:auto;">
                            <button @click="fetchMessages(currentFolder)" class="btn btn-ghost btn-sm" title="重新整理">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                            </button>
                            <button @click="scanImportInvoicesInCurrentFolder(false, $event)" :disabled="webmailInvoiceScanLoading"
                                class="btn btn-ghost btn-sm" title="掃描未讀信件並匯入發票附件">
                                <span v-if="webmailInvoiceScanLoading" class="spinner" style="width:14px;height:14px;border-width:2px;"></span>
                                <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                發票掃描
                            </button>
                            <button @click="toggleAutoInvoiceScan($event)" class="btn btn-ghost btn-sm"
                                :class="webmailAutoScanInvoices ? 'btn-success' : ''"
                                :title="webmailAutoScanInvoices ? '停用自動掃描' : '啟用自動掃描'">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                自動<span v-if="webmailAutoScanLastImportedCount" class="badge badge-success" style="margin-left:4px;">+{{ webmailAutoScanLastImportedCount }}</span>
                            </button>
                            <button @click="openComposeModal" class="btn btn-primary btn-sm">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                                撰寫郵件
                            </button>
                            <button @click="openMarketingContent()" class="btn btn-sm" style="background:linear-gradient(to right,#ec4899,#f43f5e);color:#fff;border:none;">AI 行銷</button>
                            <button @click="showAiDraftModal = true" class="btn btn-primary btn-sm">AI 智能撰寫</button>
                        </div>
                    </div>
                    <!-- Row 2: batch actions — only shown when messages are selected -->
                    <div v-if="hasValidMailSession && webmailTab === 'mail' && selectedMessageIds.length > 0"
                        style="display:flex;align-items:center;gap:0.375rem;padding:0.375rem 1rem;border-top:1px solid var(--gray-100);background:var(--brand-50,#eef2ff);">
                        <span style="font-size:0.8125rem;color:var(--brand-600,#4f46e5);font-weight:600;margin-right:0.25rem;">已選 {{ selectedMessageIds.length }} 封</span>
                        <button @click="batchAnalyzeCustomerBackground" class="btn btn-success btn-sm">批次背景情報分析</button>
                        <button @click="batchSetSelectedMessagesSeen(true)" :disabled="webmailBatchSeenLoading" class="btn btn-dark btn-sm">
                            <span v-if="webmailBatchSeenLoading" class="spinner" style="width:12px;height:12px;border-width:2px;"></span>
                            標記已讀
                        </button>
                        <button @click="batchSetSelectedMessagesSeen(false)" :disabled="webmailBatchSeenLoading" class="btn btn-dark btn-sm">
                            <span v-if="webmailBatchSeenLoading" class="spinner" style="width:12px;height:12px;border-width:2px;"></span>
                            標記未讀
                        </button>
                        <button @click="batchImportInvoicesFromSelectedMessages(false, $event)" :disabled="webmailBatchInvoiceImportLoading" class="btn btn-success btn-sm">
                            <span v-if="webmailBatchInvoiceImportLoading" class="spinner" style="width:12px;height:12px;border-width:2px;"></span>
                            批次匯入發票
                        </button>
                        <button @click="batchMoveSelectedMessages" :disabled="webmailBatchMoveLoading || webmailBatchDeleteLoading" class="btn btn-primary btn-sm">
                            <span v-if="webmailBatchMoveLoading" class="spinner" style="width:12px;height:12px;border-width:2px;"></span>
                            批次移動
                        </button>
                        <button @click="batchDeleteSelectedMessages" :disabled="webmailBatchDeleteLoading || webmailBatchMoveLoading" class="btn btn-danger btn-sm">
                            <span v-if="webmailBatchDeleteLoading" class="spinner" style="width:12px;height:12px;border-width:2px;"></span>
                            批次刪除
                        </button>
                        <button @click="selectedMessageIds = []" class="btn btn-ghost btn-sm" style="margin-left:auto;">取消選取</button>
                    </div>
                </div>
                <div v-if="webmailLastError" style="padding:0.5rem 1.5rem;background:var(--color-danger-bg,#fff5f5);color:var(--color-danger);border-bottom:1px solid var(--gray-200);font-size:0.875rem;display:flex;align-items:flex-start;justify-content:space-between;gap:0.75rem;">
                    <div style="white-space:pre-wrap;word-break:break-word;">{{ webmailLastError }}</div>
                    <button type="button" class="btn btn-danger btn-xs shrink-0" @click="webmailLastError = ''">清除</button>
                </div>

                <!-- Webmail Login (if no password) -->
                <div v-if="!hasValidMailSession && !hasStoredMailPassword" class="flex-1 empty-state" style="background:var(--gray-100);">
                    <div class="card" style="padding:2rem;width:26rem;">
                        <div style="text-align:center;margin-bottom:1rem;">
                            <div class="card-title" style="margin-bottom:0.25rem;">🔐 進入信箱</div>
                            <div style="font-size:0.8rem;color:var(--gray-500);">帳號：{{ currentUser?.email || '' }}</div>
                        </div>
                        <form @submit.prevent="setMailPassword" class="space-y-3">
                            <input type="text" :value="currentUser?.email" autocomplete="username" style="display:none;" readonly>
                            <input v-model="mailPasswordInput" type="password" class="input" placeholder="IMAP 郵件密碼" required autofocus autocomplete="current-password">
                            <label style="display:flex;align-items:center;gap:0.5rem;font-size:0.8rem;color:var(--gray-600);cursor:pointer;">
                                <input type="checkbox" v-model="mailRememberPassword" style="width:14px;height:14px;">
                                記住密碼（重新整理後仍有效）
                            </label>
                            <button type="submit" class="btn btn-primary w-full">進入信箱</button>
                        </form>
                    </div>
                </div>
                <div v-else-if="!hasValidMailSession && hasStoredMailPassword" class="flex-1 empty-state" style="background:var(--gray-100);">
                    <div class="card" style="padding:2rem;width:24rem;text-align:center;">
                        <div class="card-title" style="margin-bottom:0.5rem;">正在登入信箱…</div>
                        <div style="font-size:0.875rem;color:var(--gray-500);">若登入失敗，會自動要求重新輸入密碼</div>
                        <div style="margin-top:1rem;">
                            <button type="button" @click="resetMailAuth()" class="btn btn-secondary">重新輸入密碼</button>
                        </div>
                    </div>
                </div>

                <!-- Webmail Content -->
                <div v-else class="flex-1 flex overflow-hidden">

                    <!-- Settings Panel -->
                    <div v-if="webmailTab === 'settings'" class="flex-1 overflow-y-auto p-6" style="background:var(--gray-50);">
                        <div class="max-w-2xl mx-auto space-y-6">

                            <!-- 郵件簽名 -->
                            <div class="card p-6">
                                <div class="card-title mb-4">郵件簽名</div>

                                <div v-if="mailSignature.loading" class="empty-state py-8">
                                    <span class="spinner"></span><p>載入中...</p>
                                </div>
                                <div v-else class="space-y-4">
                                    <label style="display:flex;align-items:center;gap:0.75rem;font-size:0.875rem;font-weight:600;color:var(--gray-700);cursor:pointer;">
                                        <input type="checkbox" v-model="mailSignature.enabled" style="width:16px;height:16px;">
                                        啟用郵件簽名（寄信時自動附上）
                                    </label>

                                    <div v-if="mailSignature.enabled">
                                        <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.375rem;">純文字簽名</label>
                                        <textarea v-model="mailSignature.signature_text" class="input" placeholder="例如：&#10;王小明  |  業務主任&#10;公司名稱&#10;Tel: 02-1234-5678" style="height:7rem;resize:vertical;"></textarea>
                                    </div>

                                    <div v-if="mailSignature.enabled">
                                        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:0.375rem;">
                                            <label style="font-size:0.75rem;font-weight:600;color:var(--gray-600);">HTML 簽名（選填，HTML 郵件使用）</label>
                                            <button @click="sigGenModal.open = true" class="btn btn-outline btn-sm" style="font-size:0.7rem;padding:0.2rem 0.6rem;">✨ AI 生成</button>
                                        </div>
                                        <textarea v-model="mailSignature.signature_html" class="input font-mono text-xs" placeholder="<p>王小明 | 業務主任</p>" style="height:6rem;resize:vertical;"></textarea>
                                    </div>

                                    <!-- AI 簽名生成 Modal -->
                                    <div v-if="sigGenModal.open" style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;" @click.self="sigGenModal.open = false">
                                        <div style="background:var(--surface);border-radius:var(--radius-xl);box-shadow:var(--shadow-xl);width:100%;max-width:420px;padding:1.5rem;">
                                            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:1rem;">
                                                <h3 style="font-size:1rem;font-weight:700;color:var(--gray-900);">✨ AI 生成 HTML 簽名</h3>
                                                <button @click="sigGenModal.open = false" style="color:var(--gray-400);font-size:1.25rem;line-height:1;">&times;</button>
                                            </div>
                                            <div style="display:grid;gap:0.75rem;">
                                                <div>
                                                    <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.25rem;">姓名 *</label>
                                                    <input v-model="sigGenModal.name" class="input w-full" placeholder="王小明" />
                                                </div>
                                                <div>
                                                    <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.25rem;">職稱</label>
                                                    <input v-model="sigGenModal.title" class="input w-full" placeholder="業務主任" />
                                                </div>
                                                <div>
                                                    <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.25rem;">公司</label>
                                                    <input v-model="sigGenModal.company" class="input w-full" placeholder="範例科技有限公司" />
                                                </div>
                                                <div style="display:grid;grid-template-columns:1fr 1fr;gap:0.5rem;">
                                                    <div>
                                                        <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.25rem;">電話</label>
                                                        <input v-model="sigGenModal.phone" class="input w-full" placeholder="02-1234-5678" />
                                                    </div>
                                                    <div>
                                                        <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.25rem;">網站</label>
                                                        <input v-model="sigGenModal.website" class="input w-full" placeholder="www.example.com" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.25rem;">風格</label>
                                                    <select v-model="sigGenModal.style" class="input w-full">
                                                        <option value="modern">現代簡潔</option>
                                                        <option value="classic">傳統正式</option>
                                                        <option value="colorful">彩色活潑</option>
                                                    </select>
                                                </div>
                                                <div v-if="sigGenModal.error" style="color:var(--color-danger);font-size:0.8rem;">{{ sigGenModal.error }}</div>
                                                <div style="display:flex;gap:0.5rem;justify-content:flex-end;margin-top:0.25rem;">
                                                    <button @click="sigGenModal.open = false" class="btn btn-outline btn-sm">取消</button>
                                                    <button @click="generateSignatureWithAI" :disabled="sigGenModal.loading || !sigGenModal.name" class="btn btn-primary btn-sm">
                                                        <span v-if="sigGenModal.loading" class="spinner spinner-sm"></span>
                                                        {{ sigGenModal.loading ? '生成中...' : '✨ 生成' }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="mailSignature.enabled">
                                        <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.375rem;">簽名 Logo（選填）</label>
                                        <div class="flex items-center gap-3">
                                            <img v-if="mailSignature.logoUrl" :src="mailSignature.logoUrl" style="height:48px;border:1px solid var(--border);border-radius:var(--radius-md);" alt="Logo">
                                            <label class="btn btn-outline btn-sm cursor-pointer">
                                                <input type="file" accept="image/*" class="hidden" @change="e => uploadSignatureLogo(e.target.files[0])">
                                                上傳 Logo
                                            </label>
                                            <button v-if="mailSignature.logoUrl" @click="deleteSignatureLogo" class="btn btn-outline btn-sm" style="color:var(--color-danger);border-color:#fca5a5;">移除 Logo</button>
                                        </div>
                                    </div>

                                    <div class="flex justify-end">
                                        <button @click="saveMailSignature" :disabled="mailSignature.saving" class="btn btn-primary">
                                            <span v-if="mailSignature.saving" class="spinner spinner-sm"></span>
                                            {{ mailSignature.saving ? '儲存中...' : '儲存簽名設定' }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- 修改信箱密碼 -->
                            <div class="card p-6">
                                <div class="card-title mb-4">修改信箱密碼（IMAP）</div>
                                <form class="space-y-3" @submit.prevent="changeUserPassword">
                                    <div>
                                        <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.375rem;">目前密碼</label>
                                        <input v-model="changePasswordForm.current_password" type="password" class="input" placeholder="目前的 IMAP 密碼" autocomplete="current-password">
                                    </div>
                                    <div>
                                        <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.375rem;">新密碼</label>
                                        <input v-model="changePasswordForm.new_password" type="password" class="input" placeholder="至少 8 字元" autocomplete="new-password">
                                    </div>
                                    <div>
                                        <label style="display:block;font-size:0.75rem;font-weight:600;color:var(--gray-600);margin-bottom:0.375rem;">確認新密碼</label>
                                        <input v-model="changePasswordForm.confirm_password" type="password" class="input" placeholder="再次輸入新密碼" autocomplete="new-password">
                                    </div>
                                    <div v-if="changePasswordError" class="text-sm" style="color:var(--color-danger);">{{ changePasswordError }}</div>
                                    <div v-if="changePasswordSuccess" class="text-sm" style="color:var(--color-success);">{{ changePasswordSuccess }}</div>
                                    <div class="flex justify-end">
                                        <button type="submit" :disabled="changePasswordLoading" class="btn btn-primary">
                                            <span v-if="changePasswordLoading" class="spinner spinner-sm"></span>
                                            {{ changePasswordLoading ? '更新中...' : '更新密碼' }}
                                        </button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>

                    <template v-if="webmailTab === 'mail'">
                    <!-- Message List & Content -->
                    <div class="flex-1 flex flex-col min-w-0" style="background:var(--surface);">
                        <div v-if="!currentMessage" class="flex flex-col h-full">
                            <!-- Standard Message List -->
                            <template v-if="currentFolder !== 'Unreplied'">
                                <!-- Search Bar -->
                                <div style="padding:0.5rem 0.75rem;border-bottom:1px solid var(--gray-200);background:var(--surface);display:flex;gap:0.5rem;">
                                    <div class="flex-1 relative">
                                        <span style="position:absolute;left:0.75rem;top:50%;transform:translateY(-50%);color:var(--gray-400);">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                                        </span>
                                        <input v-model="mailSearchQuery" @keyup.enter="fetchMessages(currentFolder, 1)"
                                            type="text" placeholder="搜尋主旨或寄件者..." class="input" style="padding-left:2.25rem;">
                                    </div>
                                    <button @click="fetchMessages(currentFolder, 1)" class="btn btn-secondary btn-sm">搜尋</button>
                                </div>

                                <!-- List -->
                                <div class="flex-1 overflow-y-auto">
                                    <div v-if="loadingMessages" class="empty-state h-full">
                                        <span class="spinner"></span><p>載入郵件中...</p>
                                    </div>
                                    <table v-else class="data-table">
                                        <thead style="position:sticky;top:0;z-index:10;">
                                            <tr>
                                                <th style="width:2.5rem;">
                                                    <input type="checkbox" :checked="selectAllMessages" @change="toggleSelectAllMessages">
                                                </th>
                                                <th style="width:25%;">寄件者</th>
                                                <th>主旨</th>
                                                <th style="width:8rem;">時間</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="safeMessages.length === 0">
                                                <td colspan="4" style="text-align:center;padding:2rem;color:var(--gray-500);">
                                                    此資料夾沒有郵件
                                                </td>
                                            </tr>
                                            <tr v-for="(msg, idx) in safeMessages" :key="msg.id !== undefined && msg.id !== null ? msg.id : ('msg-' + idx)"
                                                @click="onMailMessageRowClick(msg.id, $event)"
                                                title="點擊：查看郵件；Shift+點擊：切換已讀/未讀"
                                                class="cursor-pointer"
                                                :style="msg.is_read ? '' : 'background:#eff6ff;box-shadow:inset 3px 0 0 #3b82f6;'">
                                                <td>
                                                    <input type="checkbox" :checked="isSelectedMessage(msg.id)" @click.stop="toggleMessageSelection(msg.id)">
                                                </td>
                                                <td class="truncate max-w-xs">
                                                    <div class="flex items-center gap-1.5">
                                                        <span v-if="!msg.is_read" style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#3b82f6;flex-shrink:0;"></span>
                                                        <span :style="!msg.is_read ? 'font-weight:700;color:#1e3a5f;' : 'color:var(--gray-600);'" class="truncate">{{ msg.from }}</span>
                                                    </div>
                                                </td>
                                                <td class="max-w-md">
                                                    <div class="flex items-center gap-2 min-w-0">
                                                        <span class="truncate" :style="!msg.is_read ? 'font-weight:700;color:#1e3a5f;' : ''">{{ msg.subject }}</span>
                                                        <span v-if="rspamdBadgeForMessage(msg)" class="badge shrink-0"
                                                            :class="rspamdBadgeForMessage(msg).cls">{{ rspamdBadgeForMessage(msg).text }}</span>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap" :style="!msg.is_read ? 'font-weight:700;color:#1e3a5f;font-size:0.8125rem;' : 'color:var(--gray-500);font-size:0.8125rem;'">{{ msg.date }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Pagination -->
                                <div style="padding:0.5rem 0.75rem;border-top:1px solid var(--gray-200);background:var(--gray-50);display:flex;justify-content:space-between;align-items:center;font-size:0.875rem;"
                                    v-if="safeMessages.length > 0">
                                    <span style="color:var(--gray-500);">顯示 {{ (mailPage - 1) * mailLimit + 1 }} - {{ Math.min(mailPage * mailLimit, mailTotal) }} 筆，共 {{ mailTotal }} 筆</span>
                                    <div class="flex gap-2">
                                        <button @click="fetchMessages(currentFolder, mailPage - 1)" :disabled="mailPage === 1" class="btn btn-secondary btn-xs">上一頁</button>
                                        <button @click="fetchMessages(currentFolder, mailPage + 1)" :disabled="mailPage * mailLimit >= mailTotal" class="btn btn-secondary btn-xs">下一頁</button>
                                    </div>
                                </div>
                            </template>

                            <!-- Unreplied List -->
                            <div v-else class="flex-1 flex flex-col h-full" style="background:var(--gray-50);">
                                <div class="card-header">
                                    <div class="flex items-center gap-2">
                                        <div class="card-title">待跟進郵件</div>
                                        <span class="badge badge-warning">未回覆 &gt; 14 天</span>
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <label class="flex items-center gap-2" style="font-size:0.875rem;color:var(--gray-700);">
                                            <input type="checkbox" :checked="selectAllUnreplied" @change="toggleSelectAllUnreplied">
                                            全選
                                        </label>
                                        <button @click="fetchUnrepliedMessages" class="btn btn-ghost btn-sm" title="重新整理">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                                        </button>
                                        <button @click="batchAnalyzeUnrepliedCustomerBackground"
                                            :disabled="selectedUnrepliedIds.length === 0"
                                            class="btn btn-success btn-sm">
                                            批次背景情報分析
                                            <span v-if="selectedUnrepliedIds.length" class="badge badge-default" style="margin-left:4px;">{{ selectedUnrepliedIds.length }}</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="flex-1 overflow-y-auto p-4">
                                    <div v-if="unrepliedLoading" class="empty-state h-full">
                                        <span class="spinner"></span><p>正在掃描未回覆郵件...</p>
                                    </div>
                                    <div v-else-if="unrepliedMessages.length === 0" class="empty-state h-full">
                                        <p style="font-size:1.125rem;">太棒了！沒有需要跟進的郵件。</p>
                                    </div>
                                    <div v-else class="space-y-3 max-w-4xl mx-auto">
                                        <div v-for="msg in unrepliedMessages" :key="msg.message_id"
                                            class="card flex justify-between items-center" style="padding:1rem;">
                                            <div class="flex items-center gap-3 flex-1 min-w-0 pr-4">
                                                <input type="checkbox"
                                                    :checked="isSelectedUnreplied(msg.id)"
                                                    @click.stop="toggleUnrepliedSelection(msg.id)"
                                                    class="w-4 h-4">
                                                <div class="flex items-center gap-2 mb-1">
                                                    <span class="truncate" style="font-weight:700;color:var(--gray-800);">{{ msg.subject || '(無主旨)' }}</span>
                                                </div>
                                                <div class="flex items-center gap-4" style="font-size:0.875rem;color:var(--gray-500);">
                                                    <span>收件人: <span style="font-weight:500;color:var(--gray-700);">{{ msg.to }}</span></span>
                                                    <span>寄出時間: {{ msg.date }}</span>
                                                </div>
                                            </div>
                                            <button @click="followUpUnreplied(msg.id)" class="btn btn-warning btn-sm">
                                                立即跟進
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Message View -->
                        <div v-else class="flex-1 flex flex-col h-full">
                            <div class="border-b p-4 shadow-sm flex-shrink-0 z-20 relative" style="background:var(--surface);">
                                <div class="flex justify-between items-center mb-3">
                                    <button @click="currentMessage = null"
                                        class="btn btn-ghost btn-sm">
                                        ← 返回列表
                                    </button>
                                    <div class="flex flex-col gap-2 items-end">
                                        <div class="flex gap-2 flex-wrap justify-end">
                                            <!-- Consolidated AI Assistant Menu -->
                                            <div class="relative group">
                                                <button type="button" @click.prevent.stop="aiAssistantMenuOpen = !aiAssistantMenuOpen"
                                                    class="btn btn-primary btn-sm" style="background:linear-gradient(to right,#7c3aed,#2563eb);font-weight:700;">
                                                    ✨ AI 智能助手 ▼
                                                </button>
                                                <div class="absolute right-0 mt-1 w-56 border overflow-hidden" style="background:var(--surface);border-radius:var(--radius-lg);box-shadow:var(--shadow-xl);z-index:50;"
                                                    :class="aiAssistantMenuOpen ? 'block' : 'hidden group-hover:block'">
                                                    <div>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; openMarketingContent()"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            📣 AI 行銷 (Marketing)
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; generateCustomerBackground()"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            🏢 AI客戶背景情報分析
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; openCustomerBackgroundList()"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            📋 AI客戶背景情報列表
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; generateLeadScore()"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            🎯 業務分析 (Lead Score)
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; extractOpportunityFromCurrentMessage()"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            🧾 商機抽取 (Opportunity)
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; prepareFollowup()"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            🏃 智慧跟進 (Follow-up)
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; generateSmartSummary()"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            📝 郵件摘要 (Summary)
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; showAiReplyModal = true"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            ↩️ 智慧回覆 (Reply)
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; showAiTranslateModal = true"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2 border-b" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            🌐 郵件翻譯 (Translate)
                                                        </button>
                                                        <button type="button" @click.prevent.stop="aiAssistantMenuOpen = false; generateSmartEvent()"
                                                            class="w-full text-left px-4 py-2 text-sm flex items-center gap-2" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                            📅 提取行事曆事件
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <button @click="replyEmail"
                                                class="btn btn-secondary btn-xs border">
                                                <span>↩️</span> 回覆
                                            </button>
                                            <button @click="forwardEmail"
                                                class="btn btn-secondary btn-xs border">
                                                <span>↪️</span> 轉寄
                                            </button>
                                            <button @click="showAiTranslateModal = true"
                                                class="btn btn-xs border"
                                                style="background:#eff6ff;color:#1d4ed8;border-color:#bfdbfe;">
                                                🌐 翻譯
                                            </button>
                                        </div>

                                        <div class="flex gap-2 flex-wrap justify-end">
                                            <button @click="learnRspamdFromCurrentMessage('spam')"
                                                class="btn btn-danger btn-sm">
                                                回報垃圾信
                                            </button>
                                            <button @click="learnRspamdFromCurrentMessage('ham')"
                                                class="btn btn-success btn-sm">
                                                回報正常信
                                            </button>
                                            <button v-if="isSuperAdmin" @click="quickAllowSender(extractEmail(currentMessage.from || ''))"
                                                :disabled="senderMapsLoading"
                                                class="btn btn-success btn-sm">
                                                白名單寄件者
                                            </button>
                                            <button v-if="isSuperAdmin" @click="quickBlockSender(extractEmail(currentMessage.from || ''))"
                                                :disabled="senderMapsLoading"
                                                class="btn btn-warning btn-sm">
                                                黑名單寄件者
                                            </button>
                                            <button v-if="isSuperAdmin" @click="quickAllowDomainFromText(currentMessage.from || '')"
                                                :disabled="senderMapsLoading"
                                                class="btn btn-success btn-sm">
                                                白名單網域
                                            </button>
                                            <button v-if="isSuperAdmin" @click="quickBlockDomainFromText(currentMessage.from || '')"
                                                :disabled="senderMapsLoading"
                                                class="btn btn-warning btn-sm">
                                                黑名單網域
                                            </button>
                                            <button @click="scanRspamdFromCurrentMessage()"
                                                class="btn btn-secondary btn-sm">
                                                掃描分數
                                            </button>
                                            <div class="relative group">
                                                <button class="btn btn-secondary btn-xs">
                                                    📂 移動
                                                </button>
                                                <div class="absolute right-0 mt-1 w-32 border hidden group-hover:block" style="background:var(--surface);border-radius:var(--radius-lg);box-shadow:var(--shadow-lg);z-index:10;">
                                                    <button @click="moveEmail('INBOX')" v-if="currentFolder !== 'INBOX'"
                                                        class="block w-full text-left px-4 py-2 text-sm" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">收件匣</button>
                                                    <button @click="moveEmail('Trash')" v-if="currentFolder !== 'Trash'"
                                                        class="block w-full text-left px-4 py-2 text-sm" style="color:var(--color-danger);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">垃圾桶</button>
                                                    <button @click="moveEmail('Junk')" v-if="currentFolder !== 'Junk'"
                                                        class="block w-full text-left px-4 py-2 text-sm" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">垃圾信</button>
                                                    <button @click="moveEmail('Archive')" v-if="currentFolder !== 'Archive'"
                                                        class="block w-full text-left px-4 py-2 text-sm" style="color:var(--gray-700);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">封存</button>
                                                </div>
                                            </div>
                                            <button @click="deleteEmail" class="btn btn-danger btn-sm">
                                                🗑️ 刪除
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="rspamdScanDetailsForCurrentMessage"
                                    class="mt-2 p-2 border rounded text-xs" style="background:var(--brand-50,#eef2ff);border-color:var(--brand-100,#e0e7ff);color:var(--gray-900);">
                                    <div class="flex flex-wrap gap-x-4 gap-y-1">
                                        <div><span style="color:var(--brand-600,#4f46e5);">Rspamd</span> <span style="font-weight:600;">{{ rspamdScanDetailsForCurrentMessage.action || '-' }}</span></div>
                                        <div><span style="color:var(--brand-600,#4f46e5);">Score</span> <span style="font-weight:600;">{{ rspamdScanDetailsForCurrentMessage.scoreDisplay }}</span></div>
                                    </div>
                                    <div v-if="rspamdScanDetailsForCurrentMessage.symbols && rspamdScanDetailsForCurrentMessage.symbols.length" class="mt-1">
                                        <span style="color:var(--brand-600,#4f46e5);">Top</span>
                                        <span v-for="(s, idx) in (rspamdScanDetailsForCurrentMessage.symbols || []).slice(0, 5)" :key="s.name">
                                            {{ idx ? ' · ' : ' ' }}{{ s.name }}({{ s.score }})
                                        </span>
                                    </div>
                                </div>
                                <div v-if="rspamdLearnResultForCurrentMessage"
                                    class="mt-2 p-2 border rounded text-xs" style="background:var(--gray-50);color:var(--gray-800);">
                                    <span style="color:var(--gray-600);">Rspamd 訓練回應</span>
                                    <span style="font-weight:600;margin-left:0.25rem;">{{ rspamdLearnResultForCurrentMessage?.result?.status_code || 'OK' }}</span>
                                </div>
                                <h3 style="font-size:1.25rem;font-weight:700;color:var(--gray-800);margin-bottom:0.5rem;">{{ currentMessage.subject }}</h3>
                                <div class="flex justify-between items-start" style="font-size:0.875rem;">
                                    <div style="color:var(--gray-600);">
                                        <div class="mb-1"><span style="font-weight:700;color:var(--gray-700);">寄件者:</span> {{ currentMessage.from }}</div>
                                        <div><span style="font-weight:700;color:var(--gray-700);">收件者:</span> {{ currentMessage.to }}</div>
                                    </div>
                                    <div style="color:var(--gray-500);">{{ currentMessage.date }}</div>
                                </div>
                            </div>
                            <div class="flex-1 overflow-y-auto p-6" style="background:var(--surface);">
                                <div v-if="loadingContent" class="empty-state h-full">
                                    <span class="spinner"></span>
                                </div>
                                <div v-else>
                                    <!-- AI Toolbar Removed (Moved to Consolidated Menu) -->


                                    <div v-if="currentMessage.attachments && currentMessage.attachments.length"
                                        class="mb-4 pb-4 border-b">
                                        <h3 style="font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">附件 ({{ currentMessage.attachments.length }})</h3>
                                        <div class="mb-2 flex items-center gap-2">
                                            <button v-if="invoiceCandidates().length"
                                                @click="importAllInvoiceAttachments(false, $event)"
                                                :disabled="invoiceImportingAllAttachments || invoiceImportingAttachmentKey"
                                                title="批次辨識發票附件（Shift+點擊：辨識後標記原信已讀）"
                                                class="btn btn-success btn-xs">
                                                {{ invoiceImportingAllAttachments ? '批次辨識中…' : ('辨識全部發票附件 (' + invoiceCandidates().length + ')') }}
                                            </button>
                                        </div>
                                        <div class="flex flex-wrap gap-2">
                                            <div v-for="(att, idx) in currentMessage.attachments" :key="idx"
                                                class="flex items-center gap-2 border rounded p-2" style="font-size:0.875rem;background:var(--gray-50);">
                                                <span>📎</span>
                                                <span style="font-weight:500;color:var(--gray-800);">{{ att.filename }}</span>
                                                <span style="font-size:0.75rem;color:var(--gray-500);">({{ (att.size / 1024).toFixed(1) }} KB)</span>
                                                <button @click="downloadAttachment(att.filename)" class="btn btn-secondary btn-xs" style="margin-left:0.5rem;">下載</button>
                                                <button v-if="isInvoiceAttachment(att) && invoiceImportedInfo(att)"
                                                    @click="openInvoiceFromImportedAttachment(att)"
                                                    :disabled="invoiceImportingAttachmentKey === invoiceAttachmentKey(att)"
                                                    title="已辨識（點擊開啟發票）"
                                                    class="btn btn-success btn-xs" style="margin-left:0.5rem;">
                                                    {{ invoiceImportingAttachmentKey === invoiceAttachmentKey(att) ? '辨識中…' : '已辨識✓' }}
                                                </button>
                                                <button v-else-if="isInvoiceAttachment(att)"
                                                    @click="importInvoiceFromAttachment(att, false, $event)"
                                                    :disabled="invoiceImportingAttachmentKey === invoiceAttachmentKey(att) || !!invoiceImportedInfo(att)"
                                                    title="辨識此附件（Shift+點擊：辨識後標記原信已讀）"
                                                    class="btn btn-success btn-xs" style="margin-left:0.5rem;">
                                                    {{ invoiceImportingAttachmentKey === invoiceAttachmentKey(att) ? '辨識中…' : '辨識發票' }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- PGP 加密偵測 -->
                                    <div v-if="currentMessage.body && currentMessage.body.includes('BEGIN PGP MESSAGE')"
                                        class="mb-3 p-3 rounded-lg flex items-center gap-3"
                                        style="background:var(--brand-50);border:1px solid var(--brand-200);">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color:var(--brand-600);flex-shrink:0;"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                        <div class="flex-1 text-sm" style="color:var(--brand-700);">此郵件以 <strong>PGP 加密</strong>，需要您的私鑰才能讀取內容。</div>
                                        <button class="btn btn-primary btn-sm" @click="openPgpDecrypt(currentMessage.body)">解密郵件</button>
                                    </div>
                                    <div class="prose max-w-none" v-html="currentMessage.body"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- PGP 解密 Modal -->
                <div v-if="pgpDecryptModal" class="modal-overlay" @click.self="pgpDecryptModal=false">
                    <div class="modal-box space-y-4" style="max-width:540px;">
                        <div class="font-semibold text-base" style="color:var(--gray-800);">PGP 解密</div>
                        <div v-if="pgpDecrypted" class="space-y-2">
                            <div class="text-xs font-semibold" style="color:var(--color-success);">解密成功</div>
                            <pre class="text-sm p-3 rounded-lg overflow-auto max-h-64" style="background:var(--gray-50);border:1px solid var(--border);white-space:pre-wrap;word-break:break-word;">{{ pgpDecrypted }}</pre>
                            <button class="btn btn-ghost btn-sm" @click="pgpDecryptModal=false">關閉</button>
                        </div>
                        <template v-else>
                            <div>
                                <label class="block text-sm font-medium mb-1.5" style="color:var(--gray-700);">貼入您的 PGP 私鑰</label>
                                <textarea v-model="pgpPrivKeyInput" class="input w-full font-mono text-xs" rows="6"
                                    placeholder="-----BEGIN PGP PRIVATE KEY BLOCK-----&#10;...&#10;-----END PGP PRIVATE KEY BLOCK-----"></textarea>
                            </div>
                            <div>
                                <label class="block text-sm font-medium mb-1.5" style="color:var(--gray-700);">私鑰密碼（若有設定）</label>
                                <input v-model="pgpPassphrase" type="password" class="input w-full" placeholder="留空表示無密碼" autocomplete="new-password">
                            </div>
                            <div v-if="pgpDecryptError" class="text-sm p-3 rounded-lg" style="background:var(--color-danger-bg);color:var(--color-danger);">{{ pgpDecryptError }}</div>
                            <div class="flex justify-end gap-2">
                                <button class="btn btn-ghost" @click="pgpDecryptModal=false">取消</button>
                                <button class="btn btn-primary" @click="doDecrypt" :disabled="pgpDecryptLoading">
                                    {{ pgpDecryptLoading ? '解密中…' : '解密' }}
                                </button>
                            </div>
                        </template>
                    </div>
                </div>

                <template v-if="webmailTab === 'calendar'">
                    <div class="flex-1 flex flex-col min-w-0" style="background:var(--surface);">
                        <div class="border-b p-4 flex items-center justify-between" style="background:var(--surface);">
                            <div class="flex items-center gap-2">
                                <button @click="changeWebmailMonth(-1)"
                                    class="btn btn-secondary btn-xs border">‹</button>
                                <input v-model="webmailCalendarMonth" type="month"
                                    class="input"
                                    @change="fetchWebmailCalendarMonthEvents" />
                                <button @click="changeWebmailMonth(1)"
                                    class="btn btn-secondary btn-xs border">›</button>
                            </div>
                            <button @click="openWebmailMeetingModal()"
                                class="btn btn-primary text-sm font-bold">建立會議</button>
                        </div>
                        <div v-if="webmailCalendarLoading" class="flex-1 empty-state">
                            <span class="spinner"></span><p>載入中...</p>
                        </div>
                        <div v-else class="flex-1 overflow-y-auto p-4" style="background:var(--gray-50);">
                            <div class="grid grid-cols-7 gap-2 mb-2" style="font-size:0.75rem;color:var(--gray-500);">
                                <div class="text-center">一</div>
                                <div class="text-center">二</div>
                                <div class="text-center">三</div>
                                <div class="text-center">四</div>
                                <div class="text-center">五</div>
                                <div class="text-center">六</div>
                                <div class="text-center">日</div>
                            </div>
                            <div class="grid grid-cols-7 gap-2">
                                <div v-for="d in webmailCalendarGridDays" :key="d.date"
                                    @click="openWebmailMeetingModal(d.inMonth ? d.date : null)"
                                    class="border rounded p-2 cursor-pointer" style="height:6rem;background:var(--surface);" onmouseover="this.style.background='var(--brand-50,#eef2ff)'" onmouseout="this.style.background='var(--surface)'">
                                    <div class="flex justify-between items-center">
                                        <div :style="d.inMonth ? 'color:var(--gray-900);font-weight:700;' : 'color:var(--gray-400);'">
                                            {{ d.day }}
                                        </div>
                                        <div v-if="d.count" class="badge badge-default" style="font-size:0.625rem;">
                                            {{ d.count }}
                                        </div>
                                    </div>
                                    <div class="mt-1 space-y-1">
                                        <div v-for="(ev, idx) in safeArr(d?.preview)" :key="keyById(ev, 'preview', idx)" class="truncate" style="font-size:0.75rem;color:var(--gray-700);">
                                            {{ ev.title || '(無主旨)' }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 card overflow-hidden">
                                <div class="card-header">
                                    <div class="card-title">事件清單</div>
                                    <div style="font-size:0.75rem;color:var(--gray-500);">共 {{ webmailCalendarEvents.length }} 筆</div>
                                </div>
                                <table class="data-table">
                                    <thead>
                                        <tr>
                                            <th style="width:10rem;">時間</th>
                                            <th>標題</th>
                                            <th>地點</th>
                                            <th style="width:10rem;"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(e, idx) in safeArr(webmailCalendarEvents)" :key="keyById(e, 'wmcal', idx)">
                                            <td class="whitespace-nowrap" style="color:var(--gray-700);">{{ formatCalendarTime(e.start_at) }}</td>
                                            <td style="color:var(--gray-800);">{{ e.title || '(無主旨)' }}</td>
                                            <td style="color:var(--gray-600);">{{ e.location || '—' }}</td>
                                            <td style="text-align:right;">
                                                <button @click.stop="openWebmailMeetingModalById(e.id)" class="btn btn-ghost btn-xs" style="margin-right:0.5rem;">編輯</button>
                                                <button @click.stop="downloadCalendarIcs(e.id)" class="btn btn-ghost btn-xs" style="margin-right:0.5rem;">ICS</button>
                                                <button @click.stop="deleteWebmailCalendarEvent(e.id)" class="btn btn-ghost btn-xs" style="color:var(--color-danger);">刪除</button>
                                            </td>
                                        </tr>
                                        <tr v-if="safeArr(webmailCalendarEvents).length === 0">
                                            <td colspan="4" style="padding:1.5rem;text-align:center;color:var(--gray-500);">本月沒有事件</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <div v-if="showWebmailMeetingModal" class="modal-overlay">
                <div class="modal-box w-full max-w-2xl">
                    <div class="modal-header">
                        <h3 class="modal-title">{{ webmailMeetingForm?.id ? '編輯會議 / 行事曆事件' : '建立會議 / 行事曆事件' }}</h3>
                        <button @click="closeWebmailMeetingModal" class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="modal-body space-y-4">
                        <div>
                            <label class="block text-sm font-bold mb-1">標題</label>
                            <input v-model="webmailMeetingForm.title" class="input" placeholder="例如：專案例會" />
                        </div>
                        <div class="grid grid-cols-2 gap-3">
                            <div>
                                <label class="block text-sm font-bold mb-1">開始</label>
                                <input v-model="webmailMeetingForm.start_time" type="datetime-local" step="60" class="input" />
                            </div>
                            <div>
                                <label class="block text-sm font-bold mb-1">結束</label>
                                <input v-model="webmailMeetingForm.end_time" type="datetime-local" step="60" class="input" />
                            </div>
                        </div>
                        <div class="grid grid-cols-2 gap-3">
                            <div>
                                <label class="block text-sm font-bold mb-1">地點</label>
                                <input v-model="webmailMeetingForm.location" class="input" placeholder="會議室 / Google Meet / Zoom" />
                            </div>
                            <div>
                                <label class="block text-sm font-bold mb-1">邀請名單（可含外部）</label>
                                <input v-model="webmailMeetingForm.attendees" class="input" placeholder="a@company.com, b@gmail.com" />
                            </div>
                        </div>
                        <div>
                            <label class="block text-sm font-bold mb-1">內容</label>
                            <textarea v-model="webmailMeetingForm.description" rows="4" class="input p-3" placeholder="議程 / 連結 / 備註"></textarea>
                        </div>
                        <div class="flex items-center gap-2">
                            <input id="sendInviteChk" type="checkbox" v-model="webmailMeetingForm.send_invite" class="w-4 h-4" />
                            <label for="sendInviteChk" style="font-size:0.875rem;font-weight:500;color:var(--gray-700);">寄出會議邀請（.ics）</label>
                        </div>
                        <div v-if="webmailMeetingForm.send_invite">
                            <label class="block text-sm font-bold mb-1">邀請信補充訊息（選填）</label>
                            <div class="flex items-center justify-between mb-1">
                                <span style="font-size:0.75rem;color:var(--gray-500);">可附上補充說明</span>
                                <button @click="aiInviteDraftForWebmail" :disabled="webmailMeetingSaving || webmailMeetingInviting"
                                    class="btn btn-ghost btn-xs">AI 產生邀請文案</button>
                            </div>
                            <textarea v-model="webmailMeetingForm.invite_message" rows="3" class="input p-3" placeholder="例如：請準時參加，會議連結如下..."></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="webmailMeetingForm?.id" @click="deleteWebmailMeetingFromModal" class="btn btn-outline" style="color:var(--color-danger);border-color:#fca5a5;">刪除</button>
                        <button @click="closeWebmailMeetingModal" class="btn btn-outline">取消</button>
                        <button @click="saveWebmailMeeting" :disabled="webmailMeetingSaving || webmailMeetingInviting" class="btn btn-primary">
                            <span v-if="webmailMeetingSaving || webmailMeetingInviting" class="spinner spinner-sm" style="margin-right:0.5rem;"></span>
                            {{ (webmailMeetingSaving || webmailMeetingInviting) ? '處理中...' : (webmailMeetingForm?.id ? '儲存' : '建立') }}
                        </button>
                    </div>
                </div>
            </div>
            <teleport to="body">
            <!-- Compose Modal — Redesigned v2 -->
            <div v-if="showComposeModal"
                class="modal-overlay" style="z-index:9999;"
                :style="composeMaximized ? 'align-items:stretch;padding:0;' : ''"
                @keydown.escape.stop="closeComposeWithConfirm">
                <div class="modal-box w-full"
                    :style="composeMaximized
                        ? 'max-width:100vw;width:100vw;height:100vh;max-height:100vh;border-radius:0;padding:0;overflow:hidden;display:flex;flex-direction:column;'
                        : 'max-width:52rem;padding:0;overflow:hidden;display:flex;flex-direction:column;max-height:92vh;'"
                    @keydown.ctrl.enter.stop.prevent="sendEmail">

                    <!-- Header -->
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:0.625rem 1rem;border-bottom:1px solid var(--gray-200);flex-shrink:0;background:var(--surface);">
                        <div class="flex items-center gap-3">
                            <h3 style="font-size:0.9375rem;font-weight:700;color:var(--gray-800);margin:0;">✉️ 撰寫新郵件</h3>
                            <span class="text-xs hidden md:inline" style="color:var(--gray-400);">Ctrl+Enter 傳送 · Esc 關閉</span>
                        </div>
                        <div style="display:flex;align-items:center;gap:0.25rem;">
                            <button @click="composeMaximized=!composeMaximized" class="btn btn-ghost btn-sm"
                                :title="composeMaximized ? '還原視窗' : '最大化'"
                                style="font-size:1rem;line-height:1;padding:0.25rem 0.5rem;">
                                {{ composeMaximized ? '⊡' : '⛶' }}
                            </button>
                            <button @click="closeComposeWithConfirm" class="btn btn-ghost btn-sm" title="關閉 (Esc)" style="font-size:1.25rem;line-height:1;">×</button>
                        </div>
                    </div>

                    <!-- Draft Restore Banner -->
                    <div v-if="composeDraftRestored" style="display:flex;align-items:center;justify-content:space-between;gap:0.75rem;padding:0.5rem 1rem;border-bottom:1px solid #fde68a;background:var(--color-warning-bg);flex-shrink:0;">
                        <span style="font-size:0.8125rem;color:#92400e;">⚠️ 已還原上次未送出的草稿</span>
                        <button @click="discardComposeDraft" class="btn btn-xs btn-outline" style="border-color:#d97706;color:#92400e;">捨棄草稿</button>
                    </div>

                    <!-- Fields Section -->
                    <div style="padding:0.5rem 1rem 0;flex-shrink:0;border-bottom:1px solid var(--gray-200);">
                        <!-- To -->
                        <div style="display:flex;align-items:flex-start;min-height:2.25rem;border-bottom:1px solid var(--gray-100);padding:0.25rem 0;">
                            <span style="font-size:0.6875rem;font-weight:700;color:var(--gray-400);width:3rem;padding-top:0.45rem;flex-shrink:0;text-align:right;padding-right:0.625rem;">收件人</span>
                            <div style="flex:1;display:flex;flex-wrap:wrap;gap:0.25rem;min-width:0;padding-top:0.2rem;">
                                <span v-for="(r, idx) in recipientsList('to')" :key="'to-'+idx"
                                    :class="['inline-flex items-center rounded-full px-2 py-0.5 text-xs border', isInvalidRecipientToken(r) ? 'token-invalid' : 'token-valid']">
                                    {{ r }}
                                    <button style="margin-left:0.25rem;opacity:0.6;" @click="removeRecipient('to', idx)">×</button>
                                </span>
                                <input id="compose-to-input" v-model="composeToInput"
                                    @keydown="onRecipientKeydown($event, 'to')"
                                    @keydown.enter.prevent="commitRecipient('to')"
                                    @blur="commitRecipient('to')"
                                    placeholder="Email，Enter 或逗號確認"
                                    style="flex:1;min-width:10rem;outline:none;font-size:0.875rem;background:transparent;border:none;padding:0.125rem 0.25rem;">
                            </div>
                            <div style="display:flex;align-items:center;gap:0.375rem;padding-top:0.375rem;flex-shrink:0;padding-left:0.5rem;">
                                <button type="button" v-if="!(showCcField||(composeForm.cc&&composeForm.cc.toString().trim()))"
                                    @click="showCcField=true;$nextTick(()=>{try{document.getElementById('compose-cc-input')?.focus()}catch(e){}})"
                                    style="font-size:0.75rem;color:var(--gray-400);padding:0.125rem 0.375rem;border:1px solid var(--gray-200);border-radius:9999px;background:transparent;cursor:pointer;">副本</button>
                                <button type="button" v-if="!(showBccField||(composeForm.bcc&&composeForm.bcc.toString().trim()))"
                                    @click="showBccField=true;$nextTick(()=>{try{document.getElementById('compose-bcc-input')?.focus()}catch(e){}})"
                                    style="font-size:0.75rem;color:var(--gray-400);padding:0.125rem 0.375rem;border:1px solid var(--gray-200);border-radius:9999px;background:transparent;cursor:pointer;">密件</button>
                                <button type="button" @click="openRecipientPicker('to')" class="btn btn-xs btn-ghost" title="通訊錄">📋</button>
                            </div>
                        </div>
                        <!-- CC -->
                        <div v-if="showCcField||(composeForm.cc&&composeForm.cc.toString().trim())"
                            style="display:flex;align-items:flex-start;min-height:2.25rem;border-bottom:1px solid var(--gray-100);padding:0.25rem 0;">
                            <span style="font-size:0.6875rem;font-weight:700;color:var(--gray-400);width:3rem;padding-top:0.45rem;flex-shrink:0;text-align:right;padding-right:0.625rem;">副本</span>
                            <div style="flex:1;display:flex;flex-wrap:wrap;gap:0.25rem;min-width:0;padding-top:0.2rem;">
                                <span v-for="(r, idx) in recipientsList('cc')" :key="'cc-'+idx"
                                    :class="['inline-flex items-center rounded-full px-2 py-0.5 text-xs border', isInvalidRecipientToken(r) ? 'token-invalid' : 'token-valid']">
                                    {{ r }}<button style="margin-left:0.25rem;opacity:0.6;" @click="removeRecipient('cc', idx)">×</button>
                                </span>
                                <input id="compose-cc-input" v-model="composeCcInput"
                                    @keydown="onRecipientKeydown($event,'cc')" @keydown.enter.prevent="commitRecipient('cc')" @blur="commitRecipient('cc')"
                                    placeholder="副本 Email"
                                    style="flex:1;min-width:10rem;outline:none;font-size:0.875rem;background:transparent;border:none;padding:0.125rem 0.25rem;">
                            </div>
                            <div style="display:flex;align-items:center;gap:0.375rem;padding-top:0.375rem;flex-shrink:0;padding-left:0.5rem;">
                                <button type="button" @click="openRecipientPicker('cc')" class="btn btn-xs btn-ghost" title="通訊錄">📋</button>
                                <button type="button" @click="composeForm.cc='';showCcField=false" style="font-size:0.75rem;color:var(--gray-400);cursor:pointer;">移除</button>
                            </div>
                        </div>
                        <!-- BCC -->
                        <div v-if="showBccField||(composeForm.bcc&&composeForm.bcc.toString().trim())"
                            style="display:flex;align-items:flex-start;min-height:2.25rem;border-bottom:1px solid var(--gray-100);padding:0.25rem 0;">
                            <span style="font-size:0.6875rem;font-weight:700;color:var(--gray-400);width:3rem;padding-top:0.45rem;flex-shrink:0;text-align:right;padding-right:0.625rem;">密件</span>
                            <div style="flex:1;display:flex;flex-wrap:wrap;gap:0.25rem;min-width:0;padding-top:0.2rem;">
                                <span v-for="(r, idx) in recipientsList('bcc')" :key="'bcc-'+idx"
                                    :class="['inline-flex items-center rounded-full px-2 py-0.5 text-xs border', isInvalidRecipientToken(r) ? 'token-invalid' : 'token-valid']">
                                    {{ r }}<button style="margin-left:0.25rem;opacity:0.6;" @click="removeRecipient('bcc', idx)">×</button>
                                </span>
                                <input id="compose-bcc-input" v-model="composeBccInput"
                                    @keydown="onRecipientKeydown($event,'bcc')" @keydown.enter.prevent="commitRecipient('bcc')" @blur="commitRecipient('bcc')"
                                    placeholder="密件副本 Email"
                                    style="flex:1;min-width:10rem;outline:none;font-size:0.875rem;background:transparent;border:none;padding:0.125rem 0.25rem;">
                            </div>
                            <div style="display:flex;align-items:center;gap:0.375rem;padding-top:0.375rem;flex-shrink:0;padding-left:0.5rem;">
                                <button type="button" @click="openRecipientPicker('bcc')" class="btn btn-xs btn-ghost" title="通訊錄">📋</button>
                                <button type="button" @click="composeForm.bcc='';showBccField=false" style="font-size:0.75rem;color:var(--gray-400);cursor:pointer;">移除</button>
                            </div>
                        </div>
                        <!-- Subject -->
                        <div style="display:flex;align-items:center;padding:0.25rem 0 0.375rem;gap:0.5rem;">
                            <span style="font-size:0.6875rem;font-weight:700;color:var(--gray-400);width:3rem;flex-shrink:0;text-align:right;padding-right:0.625rem;">主旨</span>
                            <input v-model="composeForm.subject" placeholder="電子郵件主旨..."
                                style="flex:1;outline:none;font-size:0.9375rem;font-weight:600;background:transparent;border:none;color:var(--gray-900);padding:0.25rem 0;">
                            <button @click="optimizeSubject" class="btn btn-xs btn-ghost shrink-0" title="AI 主旨 A/B 優化" style="color:var(--brand-600,#4f46e5);">🔮 優化</button>
                        </div>
                        <!-- Invalid Recipients -->
                        <div v-if="Array.isArray(composeInvalidRecipientTokens)&&composeInvalidRecipientTokens.length"
                            style="display:flex;align-items:center;justify-content:space-between;gap:0.75rem;padding:0.375rem 0.5rem;margin-bottom:0.375rem;border-radius:var(--radius-md);border:1px solid #fca5a5;background:var(--color-danger-bg);color:#991b1b;">
                            <span style="font-size:0.8125rem;font-weight:600;">⚠️ 偵測到無效收件者，請修正後再寄出</span>
                            <button type="button" class="btn btn-xs btn-outline" @click="removeInvalidRecipients" style="border-color:#fca5a5;">一鍵移除</button>
                        </div>
                    </div>

                    <!-- Editor + Slide-in Panels (flex:1, fills all remaining space) -->
                    <div style="flex:1;min-height:0;display:flex;flex-direction:column;">

                        <!-- Editor mode tabs (always visible) -->
                        <div style="display:flex;align-items:center;gap:0.25rem;padding:0.3rem 0.75rem;border-bottom:1px solid var(--gray-100);flex-shrink:0;background:var(--gray-50);flex-wrap:wrap;">
                            <button @click="switchComposeMode('rich')" :class="['btn btn-xs', composeEditorMode==='rich'?'btn-dark':'btn-ghost']">✏️ 富文本</button>
                            <button @click="switchComposeMode('text')" :class="['btn btn-xs', composeEditorMode==='text'?'btn-dark':'btn-ghost']">純文字</button>
                            <button @click="switchComposeMode('html_preview')" :class="['btn btn-xs', composeEditorMode==='html_preview'?'btn-dark':'btn-ghost']">👁 預覽</button>
                            <button @click="switchComposeMode('html_source')" :class="['btn btn-xs', composeEditorMode==='html_source'?'btn-dark':'btn-ghost']">🧩 HTML</button>
                        </div>

                        <!-- Rich text toolbar -->
                        <div v-if="composeEditorMode==='rich'"
                            style="display:flex;flex-wrap:wrap;align-items:center;gap:2px;padding:4px 8px;border-bottom:1px solid var(--gray-200);flex-shrink:0;background:#fafafa;">
                            <!-- Font family -->
                            <select @change="richSetFont"
                                style="height:26px;font-size:0.72rem;border:1px solid var(--gray-200);border-radius:4px;padding:0 4px;background:#fff;cursor:pointer;max-width:110px;">
                                <option value="">字體</option>
                                <option value="Arial">Arial</option>
                                <option value="Helvetica">Helvetica</option>
                                <option value="Times New Roman">Times New Roman</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Courier New">Courier New</option>
                                <option value="Verdana">Verdana</option>
                                <option value="Tahoma">Tahoma</option>
                                <option value="Noto Sans TC">Noto Sans TC</option>
                                <option value="Microsoft JhengHei">微軟正黑體</option>
                                <option value="PingFang TC">蘋方</option>
                            </select>
                            <!-- Font size -->
                            <select @change="richSetSize"
                                style="height:26px;font-size:0.72rem;border:1px solid var(--gray-200);border-radius:4px;padding:0 4px;background:#fff;cursor:pointer;width:68px;">
                                <option value="">大小</option>
                                <option value="1">8pt</option>
                                <option value="2">10pt</option>
                                <option value="3">12pt</option>
                                <option value="4">14pt</option>
                                <option value="5">18pt</option>
                                <option value="6">24pt</option>
                                <option value="7">36pt</option>
                            </select>
                            <span style="width:1px;height:18px;background:var(--gray-200);margin:0 2px;"></span>
                            <!-- B I U S -->
                            <button @click="richExec('bold')" title="粗體 (Ctrl+B)"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-weight:700;font-size:0.85rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">B</button>
                            <button @click="richExec('italic')" title="斜體 (Ctrl+I)"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-style:italic;font-size:0.85rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">I</button>
                            <button @click="richExec('underline')" title="底線 (Ctrl+U)"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;text-decoration:underline;font-size:0.85rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">U</button>
                            <button @click="richExec('strikeThrough')" title="刪除線"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;text-decoration:line-through;font-size:0.85rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">S</button>
                            <span style="width:1px;height:18px;background:var(--gray-200);margin:0 2px;"></span>
                            <!-- Text color -->
                            <label title="文字顏色" style="width:26px;height:26px;border:1px solid var(--gray-200);border-radius:4px;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:0.75rem;overflow:hidden;position:relative;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='#fff'">
                                A
                                <input type="color" value="#000000"
                                    @change="richSetForeColor"
                                    style="position:absolute;opacity:0;width:100%;height:100%;cursor:pointer;" />
                            </label>
                            <!-- Highlight color -->
                            <label title="螢光標記" style="width:26px;height:26px;border:1px solid var(--gray-200);border-radius:4px;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:0.72rem;overflow:hidden;position:relative;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='#fff'">
                                🖊
                                <input type="color" value="#ffff00"
                                    @change="richSetHilite"
                                    style="position:absolute;opacity:0;width:100%;height:100%;cursor:pointer;" />
                            </label>
                            <span style="width:1px;height:18px;background:var(--gray-200);margin:0 2px;"></span>
                            <!-- Align -->
                            <button @click="richExec('justifyLeft')" title="靠左"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.75rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">≡</button>
                            <button @click="richExec('justifyCenter')" title="置中"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.75rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">☰</button>
                            <button @click="richExec('justifyRight')" title="靠右"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.75rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">⠿</button>
                            <button @click="richExec('justifyFull')" title="兩端對齊"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.75rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">⠿</button>
                            <span style="width:1px;height:18px;background:var(--gray-200);margin:0 2px;"></span>
                            <!-- Lists + indent -->
                            <button @click="richExec('insertUnorderedList')" title="無序清單"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.8rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">•≡</button>
                            <button @click="richExec('insertOrderedList')" title="有序清單"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.8rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">1≡</button>
                            <button @click="richExec('indent')" title="增加縮排"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.85rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">→</button>
                            <button @click="richExec('outdent')" title="減少縮排"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.85rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">←</button>
                            <span style="width:1px;height:18px;background:var(--gray-200);margin:0 2px;"></span>
                            <!-- Link -->
                            <button @click="richInsertLink" title="插入連結"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.75rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">🔗</button>
                            <!-- Insert image -->
                            <button @click="triggerComposeImage" :title="composeImgUploading ? '圖片上傳中…' : '插入圖片（或直接貼上/拖曳）'" :disabled="composeImgUploading"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.8rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">{{ composeImgUploading ? '⏳' : '🖼' }}</button>
                            <input ref="composeImageInput" type="file" accept="image/*" class="hidden" @change="onComposeImagePick">
                            <!-- Clear format -->
                            <button @click="richExec('removeFormat')" title="清除格式"
                                style="width:26px;height:26px;border:1px solid transparent;border-radius:4px;background:none;cursor:pointer;font-size:0.75rem;"
                                onmouseover="this.style.background='var(--gray-100)'" onmouseout="this.style.background='none'">✕A</button>
                        </div>

                        <!-- Main editor (flex:1) -->
                        <!-- Rich text editor -->
                        <div v-if="composeEditorMode==='rich'"
                            id="richEditor"
                            contenteditable="true"
                            @input="composeForm.html_body = $event.target.innerHTML; composeForm.body = $event.target.innerText"
                            @blur="saveRichSel"
                            @paste="onComposePaste"
                            @dragover.prevent
                            @drop="e => { if (onComposeEditorDrop(e)) { e.preventDefault(); e.stopPropagation(); } }"
                            style="flex:1;min-height:5rem;overflow-y:auto;padding:0.75rem 1rem;font-size:0.9375rem;background:var(--surface);color:var(--gray-800);outline:none;line-height:1.6;word-break:break-word;"
                            :data-placeholder="'在此輸入郵件內容…'"
                        ></div>
                        <iframe v-else-if="composeEditorMode==='html_preview'&&composeForm.html_body&&composeForm.html_body.toString().trim()"
                            :srcdoc="composeForm.html_body"
                            sandbox="allow-same-origin"
                            style="flex:1;min-height:0;width:100%;border:none;background:#fff;"></iframe>
                        <textarea v-else-if="composeEditorMode==='html_source'&&composeForm.html_body&&composeForm.html_body.toString().trim()"
                            v-model="composeForm.html_body"
                            @input="composeForm.body=stripHtml(composeForm.html_body||'');if(!(composeForm.html_body&&composeForm.html_body.toString().trim()))composeEditorMode='text'"
                            placeholder="HTML 內容（將以 HTML 寄出）"
                            style="flex:1;min-height:5rem;resize:none;border:none;outline:none;padding:0.75rem 1rem;font-family:monospace;font-size:0.875rem;background:var(--surface);color:var(--gray-800);width:100%;box-sizing:border-box;"></textarea>
                        <textarea v-else
                            v-model="composeForm.body"
                            @input="composeForm.html_body='';composeEditorMode='text'"
                            placeholder="在此輸入郵件內容…"
                            style="flex:1;min-height:5rem;resize:none;border:none;outline:none;padding:0.75rem 1rem;font-size:0.9375rem;background:var(--surface);color:var(--gray-800);width:100%;box-sizing:border-box;"></textarea>


                        <!-- 🔍 知識庫 Panel -->
                        <div v-if="composeKbPanelOpen"
                            style="flex-shrink:0;border-top:2px solid var(--color-success,#10b981);background:var(--surface);">
                            <div @click="composeKbPanelCollapsed=!composeKbPanelCollapsed"
                                style="display:flex;align-items:center;justify-content:space-between;padding:0.4rem 1rem;background:var(--color-success-bg,#ecfdf5);border-bottom:1px solid var(--color-success-border,#6ee7b7);cursor:pointer;user-select:none;">
                                <div style="display:flex;align-items:center;gap:0.5rem;">
                                    <span style="font-size:0.75rem;color:var(--color-success,#10b981);">{{ composeKbPanelCollapsed ? '▶' : '▼' }}</span>
                                    <span style="font-size:0.8rem;font-weight:700;color:var(--color-success-dark,#065f46);">🔍 查詢知識庫</span>
                                    <span v-if="composeKbResult" style="font-size:0.65rem;padding:0.1rem 0.4rem;border-radius:9999px;background:var(--color-success,#10b981);color:#fff;font-weight:700;">有結果</span>
                                </div>
                                <button @click.stop="composeKbPanelOpen=false" style="font-size:1.1rem;line-height:1;color:var(--gray-500);background:none;border:none;cursor:pointer;padding:0 0.25rem;" title="關閉">×</button>
                            </div>
                            <div v-show="!composeKbPanelCollapsed" style="max-height:20rem;overflow-y:auto;padding:0.5rem 1rem;">
                                <!-- 查詢列 -->
                                <div style="display:flex;gap:0.5rem;margin-bottom:0.5rem;">
                                    <input v-model="composeKbQueryInput" @keyup.enter="queryComposeKnowledge"
                                        placeholder="例如：我們的價格規則？合約條款有哪些？"
                                        class="input text-xs" style="flex:1;">
                                    <button @click="queryComposeKnowledge" class="btn btn-xs btn-outline shrink-0"
                                        :disabled="composeKbLoading||!(composeKbQueryInput&&composeKbQueryInput.trim())">
                                        {{ composeKbLoading?'查詢中…':'查詢' }}
                                    </button>
                                </div>
                                <!-- 錯誤 -->
                                <div v-if="composeKbError" style="font-size:0.75rem;color:var(--color-danger);">{{ composeKbError }}</div>
                                <!-- 結果區 -->
                                <div v-else-if="composeKbResult">
                                    <!-- AI 回答 -->
                                    <div style="border:1px solid var(--gray-200);border-radius:var(--radius-md);padding:0.5rem 0.625rem;background:var(--gray-50);margin-bottom:0.5rem;">
                                        <div style="font-size:0.75rem;font-weight:700;color:var(--gray-700);margin-bottom:0.25rem;">AI 回答</div>
                                        <div style="font-size:0.75rem;color:var(--gray-800);white-space:pre-wrap;">{{ composeKbResult }}</div>
                                        <div style="display:flex;justify-content:flex-end;margin-top:0.375rem;">
                                            <button @click="insertKnowledgeAnswer" class="btn btn-xs btn-dark">插入到信內</button>
                                        </div>
                                    </div>
                                    <!-- 來源文件卡片 -->
                                    <div v-if="composeKbSources&&composeKbSources.length">
                                        <div style="font-size:0.6875rem;font-weight:700;color:var(--gray-600);margin-bottom:0.375rem;">
                                            📎 引用來源文件（{{ composeKbSources.length }} 份）
                                        </div>
                                        <div v-for="(s, idx) in composeKbSources" :key="'kb-src-'+idx"
                                            style="border:1px solid var(--gray-200);border-radius:var(--radius-md);margin-bottom:0.375rem;overflow:hidden;background:var(--surface);">
                                            <!-- 來源標題列 -->
                                            <div style="display:flex;align-items:center;gap:0.5rem;padding:0.375rem 0.625rem;background:var(--gray-50);border-bottom:1px solid var(--gray-100);">
                                                <span style="font-size:0.7rem;font-weight:700;color:var(--brand-600,#4f46e5);flex-shrink:0;">[{{ idx+1 }}]</span>
                                                <span class="truncate" style="font-size:0.75rem;font-weight:600;color:var(--gray-800);flex:1;" :title="s.source_name">
                                                    {{ s.source_name || ('文件 ' + (s.doc_id||'').slice(0,8)) }}
                                                </span>
                                                <span v-if="s.distance!=null" style="font-size:0.6rem;padding:0.1rem 0.4rem;border-radius:9999px;background:var(--gray-100);color:var(--gray-500);flex-shrink:0;">
                                                    相似度 {{ (1-s.distance).toFixed(2) }}
                                                </span>
                                                <!-- 操作按鈕 -->
                                                <div style="display:flex;gap:0.25rem;flex-shrink:0;">
                                                    <button @click="toggleKbSourceExpand(idx)"
                                                        class="btn btn-xs btn-ghost"
                                                        style="font-size:0.65rem;padding:0.1rem 0.4rem;">
                                                        {{ kbSourceExpandedIdx===idx ? '▲ 收起' : '▼ 預覽' }}
                                                    </button>
                                                    <button v-if="s.doc_id" @click="openKbDocFullPreview(s)"
                                                        class="btn btn-xs btn-outline"
                                                        style="font-size:0.65rem;padding:0.1rem 0.4rem;"
                                                        title="開啟完整文件內容">
                                                        全文
                                                    </button>
                                                    <button v-if="s.doc_id"
                                                        @click="downloadKbFile(s.doc_id, s.source_name)"
                                                        class="btn btn-xs btn-ghost"
                                                        style="font-size:0.65rem;padding:0.1rem 0.4rem;"
                                                        title="下載原始檔案">
                                                        ⬇ 下載
                                                    </button>
                                                    <button v-if="s.doc_id"
                                                        @click="attachKbFileToCompose(s.doc_id, s.source_name)"
                                                        class="btn btn-xs btn-outline"
                                                        style="font-size:0.65rem;padding:0.1rem 0.4rem;color:var(--brand-600,#4f46e5);border-color:var(--brand-300,#a5b4fc);"
                                                        title="加入為郵件附件">
                                                        📎 附件
                                                    </button>
                                                </div>
                                            </div>
                                            <!-- 展開的片段預覽 -->
                                            <div v-if="kbSourceExpandedIdx===idx && s.snippet"
                                                style="padding:0.4rem 0.625rem;font-size:0.7rem;color:var(--gray-700);white-space:pre-wrap;max-height:8rem;overflow-y:auto;border-top:1px solid var(--gray-100);line-height:1.5;">
                                                {{ s.snippet }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 📄 KB 全文預覽 Modal (teleport 到外層避免被截斷) -->
                        <teleport to="body">
                        <div v-if="kbDocPreviewModal.open"
                            class="modal-overlay" style="z-index:10001;"
                            @click.self="kbDocPreviewModal.open=false">
                            <div class="modal-box" style="max-width:48rem;max-height:85vh;display:flex;flex-direction:column;padding:0;overflow:hidden;">
                                <div style="display:flex;align-items:center;justify-content:space-between;padding:0.75rem 1rem;border-bottom:1px solid var(--border);flex-shrink:0;">
                                    <div>
                                        <div style="font-weight:700;font-size:0.9375rem;color:var(--gray-800);">📄 {{ kbDocPreviewModal.source_name }}</div>
                                        <div style="font-size:0.75rem;color:var(--gray-400);margin-top:0.125rem;">知識庫文件全文預覽</div>
                                    </div>
                                    <div style="display:flex;gap:0.5rem;align-items:center;">
                                        <button v-if="kbDocPreviewModal.doc_id"
                                            @click="downloadKbFile(kbDocPreviewModal.doc_id, kbDocPreviewModal.source_name)"
                                            class="btn btn-sm btn-outline">
                                            ⬇ 下載原始檔
                                        </button>
                                        <button @click="kbDocPreviewModal.open=false" class="btn btn-ghost btn-sm" style="font-size:1.25rem;line-height:1;">×</button>
                                    </div>
                                </div>
                                <div v-if="kbDocPreviewModal.loading" style="flex:1;display:flex;align-items:center;justify-content:center;color:var(--gray-400);">
                                    <span class="spinner" style="width:1.5rem;height:1.5rem;border-width:2px;margin-right:0.5rem;"></span> 載入中…
                                </div>
                                <div v-else-if="kbDocPreviewModal.error" style="flex:1;padding:1rem;color:var(--color-danger);font-size:0.875rem;">
                                    {{ kbDocPreviewModal.error }}
                                </div>
                                <div v-else style="flex:1;overflow-y:auto;padding:1rem 1.25rem;font-size:0.8125rem;color:var(--gray-800);white-space:pre-wrap;line-height:1.7;font-family:ui-monospace,monospace;">
                                    {{ kbDocPreviewModal.content }}
                                </div>
                            </div>
                        </div>
                        </teleport>


                        <!-- AI 回覆來源 (small strip) -->
                        <div v-if="composeAiReplySources&&composeAiReplySources.length"
                            style="flex-shrink:0;padding:0.3rem 1rem;border-top:1px solid var(--gray-100);background:var(--gray-50);">
                            <div style="font-size:0.7rem;font-weight:700;color:var(--gray-500);margin-bottom:0.15rem;">🤖 AI 回覆來源</div>
                            <div v-for="(s,idx) in composeAiReplySources" :key="'ai-reply-src-'+idx" class="truncate" style="font-size:0.6875rem;color:var(--gray-400);" :title="s?.snippet||''">
                                [{{ idx+1 }}] {{ s.source_name||('doc-'+(s.doc_id||'')) }}
                            </div>
                        </div>
                    </div>

                    <!-- Attachment Chips (only when files attached) -->
                    <div v-if="(composeForm.attachments||[]).length"
                        style="flex-shrink:0;padding:0.4rem 0.75rem;border-top:1px solid var(--gray-100);display:flex;flex-wrap:wrap;gap:0.4rem;max-height:7rem;overflow-y:auto;background:var(--gray-50);">
                        <div v-for="(file,idx) in (composeForm.attachments||[])" :key="'file-'+idx"
                            style="display:inline-flex;align-items:center;gap:0.35rem;border:1px solid var(--gray-200);border-radius:8px;font-size:0.75rem;padding:0.2rem 0.5rem 0.2rem 0.2rem;background:var(--surface);color:var(--gray-700);">
                            <img v-if="composeAttachmentPreviews[idx]" :src="composeAttachmentPreviews[idx]"
                                style="width:44px;height:44px;object-fit:cover;border-radius:5px;flex-shrink:0;cursor:zoom-in;"
                                @mouseenter="showHoverPreview(composeAttachmentPreviews[idx], $event)"
                                @mouseleave="hideHoverPreview()">
                            <span v-else style="width:44px;height:44px;display:flex;align-items:center;justify-content:center;font-size:1.5rem;background:var(--gray-100);border-radius:5px;flex-shrink:0;">📎</span>
                            <div style="display:flex;flex-direction:column;min-width:0;">
                                <span style="max-width:9rem;" class="truncate">{{ file.name }}</span>
                                <span style="color:var(--gray-400);font-size:0.6875rem;">{{ (file.size/1024).toFixed(1) }}KB</span>
                            </div>
                            <button @click="removeAttachment(idx)" style="opacity:0.5;margin-left:0.125rem;align-self:flex-start;">×</button>
                        </div>
                    </div>


                    <!-- Action Toolbar -->
                    <div style="flex-shrink:0;display:flex;align-items:center;gap:0.25rem;padding:0.3rem 0.75rem;border-top:1px solid var(--gray-200);background:var(--gray-50);">
                        <label class="btn btn-xs btn-ghost cursor-pointer"
                            title="上傳附件（可拖曳）"
                            @dragover.prevent="composeIsDraggingFile=true"
                            @dragleave.prevent="composeIsDraggingFile=false"
                            @drop.prevent="composeIsDraggingFile=false;handleAttachmentUpload($event)"
                            :style="composeIsDraggingFile?'border-color:var(--brand-400);background:var(--brand-50);':''">
                            <input type="file" multiple @change="handleAttachmentUpload" class="hidden">
                            📎 上傳
                        </label>

                        <button type="button"
                            @click="composeKbPanelOpen=!composeKbPanelOpen"
                            :class="['btn btn-xs', composeKbPanelOpen?'btn-success':'btn-ghost']"
                            title="查詢知識庫">
                            🔍 知識庫
                        </button>
                        <button @click="showAiRewriteModal=true" class="btn btn-ghost btn-xs" style="color:#7c3aed;" title="AI 潤飾文字">✨ 潤飾</button>
                        <span style="margin-left:auto;font-size:0.75rem;color:var(--gray-400);">
                            {{ (composeEditorMode==='html_source'?(composeForm.html_body||''):composeEditorMode==='rich'?(composeForm.body||''):(composeForm.body||'')).length }} 字元
                        </span>
                    </div>

                    <!-- Footer -->
                    <div style="display:flex;align-items:center;gap:0.5rem;padding:0.625rem 1rem;border-top:1px solid var(--gray-200);flex-shrink:0;background:var(--surface);">
                        <div style="display:flex;align-items:center;gap:0.375rem;margin-right:auto;font-size:0.75rem;color:var(--gray-500);">
                            <span v-if="safeArr(recipientsList('to')).length">
                                {{ safeArr(recipientsList('to')).length }} 位收件者
                                <span v-if="safeArr(recipientsList('cc')).length"> · Cc {{ safeArr(recipientsList('cc')).length }}</span>
                            </span>
                            <span v-if="(composeForm.attachments||[]).length>0">
                                <span v-if="safeArr(recipientsList('to')).length"> · </span>
                                {{ (composeForm.attachments||[]).length }} 個附件
                            </span>
                        </div>
                        <button @click="togglePgpEncrypt" class="btn btn-sm btn-outline"
                            :class="pgpEncryptEnabled?'btn-success':''"
                            :title="pgpEncryptEnabled?'PGP 加密已啟用（點擊停用）':'啟用 PGP 端對端加密'"
                            :disabled="!pgpRecipientKey&&!pgpEncryptEnabled">
                            🔑 {{ pgpEncryptEnabled?'PGP ✓':(pgpRecipientKey?'PGP 加密':'PGP') }}
                        </button>
                        <button @click="toggleSecureSendPanel" class="btn btn-sm btn-outline"
                            :class="secureSendEnabled?'btn-warning':''"
                            title="安全門戶傳送">
                            🔒 {{ secureSendEnabled?'安全 ✓':'安全傳送' }}
                        </button>
                        <button @click="closeComposeWithConfirm" class="btn btn-sm btn-outline">取消</button>
                        <button @click="sendEmail"
                            class="btn btn-sm btn-primary"
                            style="padding-left:1.5rem;padding-right:1.5rem;display:flex;align-items:center;gap:0.375rem;"
                            :disabled="sendingEmail">
                            <span v-if="sendingEmail" class="spinner spinner-sm"></span>
                            {{ sendingEmail?'傳送中…':(secureSendEnabled?'🔒 安全傳送':'📨 傳送') }}
                        </button>
                    </div>

                    <!-- 安全傳送設定面板 -->
                    <div v-if="secureSendEnabled&&showSecureSendPanel" style="border-top:1px solid var(--border);padding:1rem;background:var(--gray-50);flex-shrink:0;max-height:14rem;overflow-y:auto;">
                        <div style="display:flex;align-items:center;gap:0.5rem;margin-bottom:0.75rem;">
                            <span style="font-size:0.875rem;font-weight:700;color:var(--gray-800);">🔒 安全傳送設定</span>
                            <span style="font-size:0.75rem;padding:0.125rem 0.5rem;border-radius:9999px;background:var(--color-warning-bg,#fef3c7);color:#92400e;">收件人需通過身份驗證才能查閱</span>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                                <label class="block text-xs font-semibold mb-1" style="color:var(--gray-600);">查閱密碼 <span style="color:#ef4444">*</span></label>
                                <input v-model="secureSendOptions.mfa_password" type="password" class="input text-sm" placeholder="請設定密碼，再以電話或 LINE 告知收件人" autocomplete="off" />
                                <div style="font-size:0.7rem;color:#92400e;margin-top:3px;">請勿透過電子郵件傳送密碼</div>
                            </div>
                            <div>
                                <label class="block text-xs font-semibold mb-1" style="color:var(--gray-600);">連結有效期（小時）</label>
                                <select v-model="secureSendOptions.expires_in_hours" class="input text-sm">
                                    <option :value="1">1 小時</option><option :value="6">6 小時</option>
                                    <option :value="24">24 小時</option><option :value="48">48 小時</option>
                                    <option :value="72">72 小時</option><option :value="168">7 天</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-xs font-semibold mb-1" style="color:var(--gray-600);">最多開啟次數</label>
                                <select v-model="secureSendOptions.max_open_count" class="input text-sm">
                                    <option :value="1">1 次（閱後即不可再開）</option>
                                    <option :value="3">3 次</option><option :value="5">5 次</option><option :value="10">10 次</option>
                                </select>
                            </div>
                        </div>
                        <div style="display:flex;align-items:center;gap:1.5rem;margin-top:0.75rem;flex-wrap:wrap;">
                            <label style="display:flex;align-items:center;gap:0.5rem;font-size:0.875rem;cursor:pointer;">
                                <input type="checkbox" v-model="secureSendOptions.burn_after_read" class="w-4 h-4" />
                                <span>閱後即焚</span>
                                <select v-if="secureSendOptions.burn_after_read" v-model="secureSendOptions.burn_delay_seconds" class="input text-xs" style="width:auto;padding:0.125rem 0.375rem;margin-left:0.25rem;">
                                    <option :value="10">10 秒</option><option :value="30">30 秒</option><option :value="60">60 秒</option>
                                </select>
                            </label>
                            <label style="display:flex;align-items:center;gap:0.5rem;font-size:0.875rem;cursor:pointer;">
                                <input type="checkbox" v-model="secureSendOptions.no_download" class="w-4 h-4" />
                                <span>禁止下載附件</span>
                            </label>
                            <label style="display:flex;align-items:center;gap:0.5rem;font-size:0.875rem;cursor:pointer;">
                                <input type="checkbox" v-model="secureSendOptions.watermark" class="w-4 h-4" />
                                <span>動態浮水印</span>
                            </label>
                        </div>
                    </div>

                </div>
            </div>
            <div v-if="showRecipientPickerModal"
                class="modal-overlay" style="z-index:10000;">
                <div class="modal-box w-full max-w-lg">
                    <div class="modal-header">
                        <h3 class="modal-title">通訊錄（選擇收件者）</h3>
                        <button @click="closeRecipientPicker" class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="modal-body space-y-4">
                        <div class="flex items-center gap-2">
                            <input v-model="recipientPickerQuery" @keydown.enter.prevent="searchRecipientContacts"
                                class="flex-1 border rounded px-3 py-2 text-sm"
                                placeholder="輸入 Email / 姓名 / 標籤" />
                            <button type="button" @click.stop.prevent="searchRecipientContacts" :disabled="recipientPickerLoading"
                                class="btn btn-primary">
                                {{ recipientPickerLoading ? '搜尋中...' : '搜尋' }}
                            </button>
                        </div>

                        <div v-if="recipientPickerError" style="font-size:0.875rem;color:var(--color-danger);">{{ recipientPickerError }}</div>

                        <div v-if="safeArr(recipientPickerResults).length === 0 && !recipientPickerLoading && !recipientPickerError" style="font-size:0.875rem;color:var(--gray-500);">
                            可輸入關鍵字搜尋；或直接選擇最近的聯絡人。
                        </div>

                        <div v-else class="space-y-2">
                            <div v-for="(c, idx) in safeArr(recipientPickerResults)" :key="keyById(c, 'rcptpick', idx)" class="input p-3">
                                <div class="flex items-start justify-between gap-3">
                                    <div class="flex items-start gap-3 min-w-0">
                                        <input type="checkbox"
                                               class="mt-1"
                                               :value="c.name ? (c.name + ' <' + c.email + '>') : c.email"
                                               v-model="recipientPickerSelected" />
                                        <div>
                                            <div class="text-sm font-bold truncate" style="color:var(--gray-900);">{{ c.name || '—' }}</div>
                                            <div class="truncate" style="font-size:0.75rem;color:var(--gray-600);margin-top:0.25rem;">{{ c.email || '—' }}</div>
                                            <div class="truncate" style="font-size:0.75rem;color:var(--gray-500);margin-top:0.25rem;" v-if="c.tags">{{ c.tags }}</div>
                                        </div>
                                    </div>
                                    <button type="button" @click.stop.prevent="pickRecipientFromContacts(c)"
                                        class="btn btn-success btn-sm">
                                        選取
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="justify-content:space-between;">
                        <div style="font-size:0.75rem;color:var(--gray-600);">已選 {{ recipientPickerSelected.length }} 位</div>
                        <div class="flex gap-2">
                            <button @click="addSelectedRecipients" :disabled="recipientPickerSelected.length === 0"
                                class="btn btn-sm btn-primary disabled:opacity-50 disabled:cursor-not-allowed">
                                加入已選至 {{ recipientPickerTarget.toUpperCase() }}
                            </button>
                            <button @click="closeRecipientPicker" class="btn btn-sm btn-outline">關閉</button>
                        </div>
                    </div>
                </div>
            </div>
            </teleport>

            <div v-if="showOriginalMailModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-4xl">
                    <div class="modal-header">
                        <h3 class="modal-title">原始來信</h3>
                        <button @click="showOriginalMailModal = false; originalMailMessage = null"
                            class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="modal-body">
                        <div v-if="originalMailLoading" class="empty-state h-full">
                            <span class="spinner spinner-sm" style="margin-right:0.5rem;"></span> 載入中...
                        </div>
                        <div v-else-if="!originalMailMessage" class="text-center" style="color:var(--gray-500);">
                            無法載入原始來信
                        </div>
                        <div v-else class="space-y-4">
                            <div class="card card-body" style="padding:1rem;">
                                <div style="font-size:1.25rem;font-weight:700;color:var(--gray-800);margin-bottom:0.5rem;">{{ originalMailMessage.subject }}</div>
                                <div class="flex justify-between items-start text-sm">
                                    <div style="color:var(--gray-600);">
                                        <div class="mb-1"><span style="font-weight:700;color:var(--gray-700);">寄件者:</span> {{ originalMailMessage.from }}</div>
                                        <div><span style="font-weight:700;color:var(--gray-700);">收件者:</span> {{ originalMailMessage.to }}</div>
                                    </div>
                                    <div style="color:var(--gray-500);">{{ originalMailMessage.date }}</div>
                                </div>
                                <div v-if="originalMailMessage.mailAuditLogId" class="mt-3 flex flex-wrap items-center gap-2" style="font-size:0.75rem;color:var(--gray-600);">
                                    <span v-if="originalMailMessage.status" class="px-2 py-0.5 rounded border" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">狀態:</span> {{ originalMailMessage.status }}
                                    </span>
                                    <span v-if="originalMailMessage.spam_score !== null && originalMailMessage.spam_score !== undefined" class="px-2 py-0.5 rounded border" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">分數:</span> {{ Number(originalMailMessage.spam_score).toFixed(2) }}
                                    </span>
                                    <span v-if="originalMailMessage.direction" class="px-2 py-0.5 rounded border" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">方向:</span> {{ originalMailMessage.direction }}
                                    </span>
                                    <span class="px-2 py-0.5 rounded border" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">內容:</span> {{ originalMailMessage.has_archive ? '已保存' : '未保存' }}
                                    </span>
                                    <span v-if="originalMailMessage.queue_id" class="px-2 py-0.5 rounded border" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">Queue:</span> {{ originalMailMessage.queue_id }}
                                    </span>
                                    <span v-if="originalMailMessage.message_id" class="px-2 py-0.5 rounded border max-w-[520px] truncate" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">Message-ID:</span> {{ originalMailMessage.message_id }}
                                    </span>
                                    <button v-if="originalMailMessage.mailAuditLogId" @click="fetchMailAuditAttachments(originalMailMessage.mailAuditLogId)"
                                        class="btn btn-xs btn-outline ml-auto" :disabled="originalMailLoading">
                                        載入附件
                                    </button>
                                    <button @click="downloadMailAuditEml(originalMailMessage.mailAuditLogId)"
                                        class="btn btn-xs btn-outline" :disabled="originalMailLoading">
                                        下載 EML
                                    </button>
                                    <button v-if="!originalMailMessage.has_archive" @click="fetchMailAuditArchive(originalMailMessage.mailAuditLogId)"
                                        class="btn btn-xs btn-outline" :disabled="originalMailLoading">
                                        <span v-if="originalMailLoading" class="spinner spinner-sm" style="margin-right:0.25rem;"></span> 補抓內容
                                    </button>
                                </div>
                                <div v-else class="mt-3 flex flex-wrap items-center gap-2" style="font-size:0.75rem;color:var(--gray-600);">
                                    <span v-if="originalMailMessage.spam_score !== null && originalMailMessage.spam_score !== undefined" class="px-2 py-0.5 rounded border" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">分數:</span> {{ Number(originalMailMessage.spam_score).toFixed(2) }}
                                    </span>
                                    <span v-if="originalMailMessage.spam_action" class="px-2 py-0.5 rounded border" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">Action:</span> {{ String(originalMailMessage.spam_action) }}
                                    </span>
                                    <span v-if="originalMailMessage.message_id" class="px-2 py-0.5 rounded border max-w-[520px] truncate" style="background:var(--surface);">
                                        <span style="font-weight:700;color:var(--gray-700);">Message-ID:</span> {{ originalMailMessage.message_id }}
                                    </span>
                                </div>
                                <div v-if="originalMailMessage.evidence_summary" class="mt-3 text-xs" style="color:var(--gray-700);">
                                    <span style="font-weight:700;color:var(--gray-700);">原因摘要:</span>
                                    <span class="ml-1">{{ String(originalMailMessage.evidence_summary) }}</span>
                                </div>
                            </div>
                            <div v-if="originalMailMessage.headers && Object.keys(originalMailMessage.headers || {}).length" class="card p-4">
                                <div style="font-size:0.875rem;font-weight:700;color:var(--gray-700);margin-bottom:0.5rem;">安全相關標頭</div>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-2 text-xs">
                                    <div v-for="(v, k) in originalMailMessage.headers" :key="k" class="card p-2">
                                        <div style="font-weight:700;color:var(--gray-700);margin-bottom:0.25rem;">{{ k }}</div>
                                        <div class="font-mono whitespace-pre-wrap break-words" style="color:var(--gray-600);">{{ v }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="originalMailMessage.security_flags && originalMailMessage.security_flags.length" class="card p-4">
                                <div style="font-size:0.875rem;font-weight:700;color:var(--gray-700);margin-bottom:0.5rem;">風險旗標</div>
                                <div class="flex flex-wrap gap-2">
                                    <span v-for="(f, idx) in originalMailMessage.security_flags" :key="idx"
                                        class="badge badge-danger" style="border-radius:9999px;">
                                        {{ String(f) }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="originalMailMessage.extracted_links && originalMailMessage.extracted_links.length" class="card p-4">
                                <div class="flex items-center justify-between gap-2 mb-2">
                                    <div style="font-size:0.875rem;font-weight:700;color:var(--gray-700);">連結分析</div>
                                    <div style="font-size:0.75rem;color:var(--gray-500);">
                                        共 {{ originalMailMessage.extracted_links.length }} 筆
                                        <span v-if="originalMailMessage.links_suspicious !== undefined && originalMailMessage.links_total !== undefined">
                                            ，可疑 {{ Number(originalMailMessage.links_suspicious || 0) }}/{{ Number(originalMailMessage.links_total || 0) }}
                                        </span>
                                        <span v-else-if="originalMailMessage.phishing_links_suspicious !== undefined && originalMailMessage.phishing_links_total !== undefined">
                                            ，可疑 {{ Number(originalMailMessage.phishing_links_suspicious || 0) }}/{{ Number(originalMailMessage.phishing_links_total || 0) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="overflow-x-auto border rounded">
                                    <table class="data-table">
                                        <thead style="background:var(--gray-50);border-bottom:1px solid var(--gray-200);">
                                            <tr>
                                                <th class="p-2 w-40">Domain</th>
                                                <th class="p-2">URL</th>
                                                <th class="p-2 w-44">Flags</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(l, idx) in originalMailMessage.extracted_links" :key="idx" class="border-b" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
                                                <td class="p-2 font-mono break-all" style="color:var(--gray-700);">{{ l.domain || '—' }}</td>
                                                <td class="p-2 break-all">
                                                    <a :href="l.href" target="_blank" rel="noopener noreferrer"
                                                        style="color:var(--brand-700,#4338ca);" class="hover:underline">{{ l.href }}</a>
                                                    <div v-if="l.text" class="mt-1 truncate" style="color:var(--gray-500);" :title="l.text">{{ l.text }}</div>
                                                </td>
                                                <td class="p-2">
                                                    <span v-if="l.flags && l.flags.length" style="color:var(--color-danger);font-weight:700;">
                                                        {{ l.flags.slice(0, 6).join('、') }}
                                                    </span>
                                                    <span v-else style="color:var(--gray-400);">—</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="originalMailMessage.attachments && originalMailMessage.attachments.length"
                                class="pb-4 border-b">
                                <h3 style="font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">附件 ({{ originalMailMessage.attachments.length }})</h3>
                                <div class="flex flex-wrap gap-2">
                                    <div v-for="(att, idx) in originalMailMessage.attachments" :key="idx"
                                        class="flex items-center gap-2 border rounded p-2" style="font-size:0.875rem;background:var(--gray-50);">
                                        <span style="color:var(--gray-600);">📎</span>
                                        <span style="font-weight:500;color:var(--gray-800);">{{ att.filename }}</span>
                                        <span class="text-xs" style="color:var(--gray-500);">({{ (att.size / 1024).toFixed(1) }} KB)</span>
                                        <button @click="downloadOriginalAttachment(att.filename)"
                                            class="btn btn-xs btn-outline ml-2">下載</button>
                                    </div>
                                </div>
                            </div>
                            <div class="prose max-w-none" v-html="originalMailMessage.body"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="showOriginalMailModal = false; originalMailMessage = null"
                            class="btn btn-sm btn-outline">
                            關閉
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="showNotificationsModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-3xl">
                    <div class="modal-header">
                        <h3 class="modal-title">通知中心</h3>
                        <button @click="showNotificationsModal = false"
                            class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="p-4 border-b flex flex-wrap gap-3 items-center" style="background:var(--gray-50);">
                        <label class="flex items-center gap-2" style="font-size:0.875rem;color:var(--gray-700);">
                            <input type="checkbox" v-model="notificationsIncludeCooling" class="checkbox checkbox-sm" />
                            啟用「潛客降溫」規則
                        </label>
                        <div class="flex items-center gap-2">
                            <span style="font-size:0.75rem;font-weight:700;color:var(--gray-600);">天數</span>
                            <select v-model.number="notificationsDays" class="input text-xs">
                                <option :value="1">1</option>
                                <option :value="3">3</option>
                                <option :value="7">7</option>
                                <option :value="14">14</option>
                            </select>
                        </div>
                        <button @click="fetchNotifications"
                            :disabled="notificationsLoading"
                            class="btn btn-dark btn-sm ml-auto">
                            <span v-if="notificationsLoading" class="spinner spinner-sm" style="margin-right:0.5rem;"></span>
                            載入
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="notificationsLoading" class="empty-state" style="height:10rem;">
                            <span class="spinner spinner-sm" style="margin-right:0.5rem;"></span> 載入中...
                        </div>
                        <div v-else-if="safeArr(notifications).length === 0" class="empty-state" style="padding:2.5rem 1rem;">
                            目前沒有通知
                        </div>
                        <div v-else class="space-y-3">
                            <div v-for="(n, idx) in safeArr(notifications)" :key="keyById(n, 'notif', idx)"
                                class="input -lg p-4 hover:shadow-sm transition">
                                <div class="flex items-start justify-between gap-3">
                                    <div class="min-w-0">
                                        <div style="font-size:0.75rem;color:var(--gray-500);">{{ new Date(n.created_at).toLocaleString() }} · {{ n.rule || 'rule' }}</div>
                                        <div class="truncate" style="font-weight:700;color:var(--gray-900);margin-top:0.25rem;" :title="n.title">{{ n.title }}</div>
                                        <div style="font-size:0.875rem;color:var(--gray-700);margin-top:0.5rem;white-space:pre-wrap;">{{ n.message }}</div>
                                    </div>
                                    <button v-if="n.contact_id" @click="openCrmTimeline({ contact_id: n.contact_id })"
                                        class="btn btn-primary btn-sm">
                                        🧾 CRM
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="showNotificationsModal = false" class="btn btn-sm btn-outline">關閉</button>
                    </div>
                </div>
            </div>

            <div v-if="showCrmModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-4xl">
                    <div class="modal-header">
                        <h3 class="modal-title">CRM 自動更新</h3>
                        <div class="flex items-center gap-2">
                            <button @click="crmQuickFollowup"
                                :disabled="crmFollowupGenerating || !(crmTimeline?.contact?.email)"
                                class="btn btn-primary btn-sm">
                                {{ crmFollowupGenerating ? '生成中…' : '一鍵智慧跟進' }}
                            </button>
                            <button @click="closeCrmModal"
                                class="btn btn-ghost btn-sm">×</button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div v-if="crmLoading" class="empty-state" style="height:10rem;">
                            <span class="spinner spinner-sm" style="margin-right:0.5rem;"></span> 載入中...
                        </div>
                        <div v-else-if="!crmTimeline" class="empty-state" style="padding:2.5rem 1rem;">
                            尚無時間線資料
                        </div>
                        <div v-else class="space-y-4">
                            <div class="card card-body" style="padding:1rem;">
                                <div style="font-size:0.875rem;font-weight:700;color:var(--gray-800);">{{ crmTimeline.contact?.name || '—' }}</div>
                                <div style="font-size:0.75rem;color:var(--gray-600);margin-top:0.25rem;">{{ crmTimeline.contact?.email || '—' }}</div>
                                <div style="font-size:0.75rem;color:var(--gray-500);margin-top:0.5rem;" v-if="crmTimeline.contact?.last_interaction_at">
                                    最近互動：{{ new Date(crmTimeline.contact.last_interaction_at).toLocaleString() }}
                                </div>
                            </div>

                            <div class="card p-4">
                                <div class="flex items-center justify-between gap-3">
                                    <div style="font-size:0.875rem;font-weight:700;color:var(--gray-800);">聯絡人資料</div>
                                    <button @click="crmContactEditOpen = !crmContactEditOpen"
                                        class="btn btn-secondary btn-sm">
                                        {{ crmContactEditOpen ? '收起' : '編輯' }}
                                    </button>
                                </div>

                                <div v-if="crmContactLoading" class="empty-state" style="padding:1.5rem 0;">
                                    <span class="spinner spinner-sm" style="margin-right:0.5rem;"></span> 載入中...
                                </div>

                                <div v-else-if="!crmContact" style="font-size:0.875rem;color:var(--gray-500);padding:1rem 0;">
                                    尚無聯絡人資料
                                </div>

                                <div v-else class="mt-3">
                                    <div v-if="!crmContactEditOpen" class="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <div class="card p-3">
                                            <div style="font-size:0.75rem;font-weight:700;color:var(--gray-600);">電話</div>
                                            <div style="font-size:0.875rem;color:var(--gray-800);margin-top:0.25rem;">{{ crmContact.phone || '—' }}</div>
                                        </div>
                                        <div class="card p-3">
                                            <div style="font-size:0.75rem;font-weight:700;color:var(--gray-600);">標籤</div>
                                            <div style="font-size:0.875rem;color:var(--gray-800);margin-top:0.25rem;">{{ crmContact.tags || '—' }}</div>
                                        </div>
                                        <div class="card p-3">
                                            <div style="font-size:0.75rem;font-weight:700;color:var(--gray-600);">群組</div>
                                            <div style="font-size:0.875rem;color:var(--gray-800);margin-top:0.25rem;">{{ crmContact.group_name || '—' }}</div>
                                        </div>
                                    </div>

                                    <div v-else class="space-y-3">
                                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            <div>
                                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">姓名</label>
                                                <input v-model="crmContactForm.name" class="input" />
                                            </div>
                                            <div>
                                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">Email</label>
                                                <input v-model="crmContactForm.email" class="input" />
                                            </div>
                                        </div>
                                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            <div>
                                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">電話</label>
                                                <input v-model="crmContactForm.phone" class="input" />
                                            </div>
                                            <div>
                                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">標籤</label>
                                                <div class="flex flex-wrap gap-1 mb-1" v-if="crmContactForm.tags">
                                                    <span v-for="(tag, ti) in crmContactForm.tags.split(',').map(t=>t.trim()).filter(Boolean)" :key="ti"
                                                        style="display:inline-flex;align-items:center;gap:3px;background:var(--brand-100,#e0e7ff);color:var(--brand-700,#4338ca);border-radius:999px;padding:2px 10px;font-size:0.75rem;font-weight:600;">
                                                        {{ tag }}
                                                        <button type="button"
                                                            @click="crmContactForm.tags = crmContactForm.tags.split(',').map(t=>t.trim()).filter((t,i)=>i!==ti).join(',')"
                                                            style="background:none;border:none;cursor:pointer;color:inherit;padding:0;font-size:0.9rem;line-height:1;">&times;</button>
                                                    </span>
                                                </div>
                                                <input
                                                    @keydown.enter.prevent="e => { const v=(e.target.value||'').trim(); if(v){ crmContactForm.tags=(crmContactForm.tags?crmContactForm.tags+',':'')+v; e.target.value=''; } }"
                                                    @keydown.comma.prevent="e => { const v=(e.target.value||'').trim(); if(v){ crmContactForm.tags=(crmContactForm.tags?crmContactForm.tags+',':'')+v; e.target.value=''; } }"
                                                    class="input" placeholder="輸入後按 Enter 新增，例如：VIP" />
                                            </div>
                                        </div>
                                        <div class="flex justify-end">
                                            <button @click="saveCrmContact" :disabled="crmContactSaving || !crmContact?.id"
                                                class="btn btn-primary">
                                                {{ crmContactSaving ? '儲存中...' : '儲存聯絡人' }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card p-4">
                                <div style="font-size:0.875rem;font-weight:700;color:var(--gray-800);margin-bottom:0.5rem;">補充摘要（寫回聯絡人備註）</div>
                                <div class="flex flex-wrap gap-2 mb-3">
                                    <button @click="insertCrmNoteTemplate('📞 通話摘要：')"
                                        class="btn btn-secondary btn-sm">
                                        通話
                                    </button>
                                    <button @click="insertCrmNoteTemplate('🤝 會議摘要：')"
                                        class="btn btn-secondary btn-sm">
                                        會議
                                    </button>
                                    <button @click="insertCrmNoteTemplate('✉️ 寄信紀錄：')"
                                        class="btn btn-secondary btn-sm">
                                        寄信
                                    </button>
                                    <button @click="insertCrmNoteTemplate('➡️ 下一步：')"
                                        class="btn btn-secondary btn-sm">
                                        下一步
                                    </button>
                                    <button @click="insertCrmNoteTemplate('⚠️ 風險點：')"
                                        class="btn btn-secondary btn-sm">
                                        風險
                                    </button>
                                </div>
                                <textarea v-model="crmNote.note" rows="4" class="input"
                                    placeholder="通話/會議摘要、下一步、風險點…"></textarea>
                                <div class="flex justify-end mt-3">
                                    <button @click="saveCrmNote"
                                        :disabled="crmLoading || !crmNote.contact_id"
                                        class="btn btn-success">
                                        儲存摘要
                                    </button>
                                </div>
                            </div>

                            <div class="card p-4">
                                <div class="flex items-center justify-between gap-3 mb-3">
                                    <div style="font-size:0.875rem;font-weight:700;color:var(--gray-800);">行事曆（該聯絡人）</div>
                                    <div class="flex items-center gap-2">
                                        <span style="font-size:0.75rem;color:var(--gray-500);">未來</span>
                                        <input type="number" min="1" max="90" v-model.number="crmCalendarRangeDays"
                                            class="w-20 border rounded px-2 py-1 text-xs" />
                                        <span style="font-size:0.75rem;color:var(--gray-500);">天</span>
                                        <button @click="fetchCrmCalendarEvents"
                                            :disabled="crmCalendarLoading || !crmNote.contact_id"
                                            class="btn btn-secondary btn-sm">
                                            重新載入
                                        </button>
                                    </div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-6 gap-3 items-end">
                                    <div class="md:col-span-2">
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">標題</label>
                                        <input v-model="crmCalendarCreateForm.title" class="input" placeholder="例如：會議 / Demo / 回訪" />
                                    </div>
                                    <div>
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">開始</label>
                                        <input v-model="crmCalendarCreateForm.start_time" type="datetime-local" step="60"
                                            class="input" />
                                    </div>
                                    <div>
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">結束（可選）</label>
                                        <input v-model="crmCalendarCreateForm.end_time" type="datetime-local" step="60"
                                            class="input" />
                                    </div>
                                    <div class="md:col-span-2">
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">地點（可選）</label>
                                        <input v-model="crmCalendarCreateForm.location" class="input" placeholder="Google Meet / 會議室" />
                                    </div>
                                    <div class="md:col-span-6">
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">描述（可選）</label>
                                        <input v-model="crmCalendarCreateForm.description" class="input" placeholder="議程 / 會議連結 / 備註" />
                                    </div>
                                    <button @click="createCrmCalendarEvent"
                                        :disabled="crmCalendarCreating || !crmNote.contact_id"
                                        class="btn btn-primary md:col-span-6">
                                        {{ crmCalendarCreating ? '建立中...' : '建立事件（綁定此聯絡人）' }}
                                    </button>
                                </div>

                                <div class="mt-4">
                                    <div v-if="crmCalendarLoading" class="empty-state" style="padding:1.5rem 0;">
                                        <span class="spinner spinner-sm" style="margin-right:0.5rem;"></span> 載入中...
                                    </div>
                                    <div v-else-if="safeArr(crmCalendarEvents).length === 0" style="font-size:0.875rem;color:var(--gray-500);padding:1rem 0;">
                                        尚無行事曆事件
                                    </div>
                                    <div v-else class="space-y-2">
                                        <div v-for="(e, idx) in safeArr(crmCalendarEvents)" :key="keyById(e, 'crmcal', idx)" class="input p-3">
                                            <div class="flex items-start justify-between gap-3">
                                                <div class="min-w-0">
                                                    <div style="font-size:0.75rem;color:var(--gray-500);">
                                                        {{ formatCalendarTime(e.start_at) }} → {{ formatCalendarTime(e.end_at) }}
                                                        <span v-if="e.location">· {{ e.location }}</span>
                                                    </div>
                                                    <div style="font-size:0.875rem;font-weight:700;color:var(--gray-800);margin-top:0.25rem;">{{ e.title || '—' }}</div>
                                                    <div style="font-size:0.875rem;color:var(--gray-700);margin-top:0.5rem;white-space:pre-wrap;" v-if="e.description">{{ e.description }}</div>
                                                </div>
                                                <div class="flex items-center gap-2 whitespace-nowrap">
                                                    <button @click="openCalendarEdit(e)"
                                                        class="btn btn-primary btn-sm">
                                                        編輯
                                                    </button>
                                                    <button @click="downloadCalendarIcs(e.id)"
                                                        class="btn btn-secondary btn-sm">
                                                        📅 ICS
                                                    </button>
                                                    <button @click="cancelCalendarEvent(e.id)"
                                                        class="btn btn-warning btn-sm">
                                                        取消
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card p-4">
                                <div class="flex items-center justify-between gap-3">
                                    <div style="font-size:0.875rem;font-weight:700;color:var(--gray-800);">互動時間線</div>
                                    <div style="font-size:0.75rem;color:var(--gray-500);">
                                        {{ (filteredCrmTimelineEvents || []).length }} / {{ (crmTimeline.events || []).length }}
                                    </div>
                                </div>

                                <div class="mt-3 flex flex-wrap items-center gap-2">
                                    <button @click="crmTimelineFilterType = 'all'"
                                        :class="crmTimelineFilterType === 'all' ? 'active' : ''"
                        class="tab-item">
                                        全部
                                    </button>
                                    <button @click="crmTimelineFilterType = 'calendar_event'"
                                        :class="crmTimelineFilterType === 'calendar_event' ? 'active' : ''"
                        class="tab-item">
                                        行事曆
                                    </button>
                                    <button @click="crmTimelineFilterType = 'opportunity'"
                                        :class="crmTimelineFilterType === 'opportunity' ? 'active' : ''"
                        class="tab-item">
                                        商機
                                    </button>
                                    <button @click="crmTimelineFilterType = 'auto_reply'"
                                        :class="crmTimelineFilterType === 'auto_reply' ? 'active' : ''"
                        class="tab-item">
                                        草稿
                                    </button>
                                    <button @click="crmTimelineFilterType = 'lead_score'"
                                        :class="crmTimelineFilterType === 'lead_score' ? 'active' : ''"
                        class="tab-item">
                                        Lead Score
                                    </button>
                                    <button @click="crmTimelineFilterType = 'note'"
                                        :class="crmTimelineFilterType === 'note' ? 'active' : ''"
                        class="tab-item">
                                        摘要
                                    </button>
                                    <button @click="crmTimelineFilterType = 'journey'"
                                        :class="crmTimelineFilterType === 'journey' ? 'active' : ''"
                        class="tab-item">
                                        旅程
                                    </button>
                                    <button @click="crmTimelineFilterType = 'form'"
                                        :class="crmTimelineFilterType === 'form' ? 'active' : ''"
                        class="tab-item">
                                        表單
                                    </button>
                                    <input v-model="crmTimelineQuery"
                                        class="ml-auto border rounded px-3 py-1.5 text-xs w-full md:w-64"
                                        placeholder="搜尋標題/內容" />
                                </div>

                                <div v-if="safeArr(filteredCrmTimelineEvents).length === 0" style="font-size:0.875rem;color:var(--gray-500);margin-top:0.75rem;">
                                    沒有符合條件的紀錄
                                </div>
                                <div v-else class="space-y-3 mt-3">
                                    <div v-for="(e, idx) in safeArr(filteredCrmTimelineEvents)" :key="keyById(e, 'crmtl', idx)" class="input p-3">
                                        <div class="flex items-start justify-between gap-3">
                                            <div class="min-w-0">
                                                <div style="font-size:0.75rem;color:var(--gray-500);">
                                                    {{ e.created_at ? new Date(e.created_at).toLocaleString() : '—' }} · {{ e.event_type }}
                                                </div>
                                                <div style="font-size:0.875rem;font-weight:700;color:var(--gray-800);margin-top:0.25rem;">{{ e.title || '—' }}</div>
                                                <div style="font-size:0.875rem;color:var(--gray-700);margin-top:0.5rem;white-space:pre-wrap;">{{ e.content || '' }}</div>
                                            </div>
                                            <div v-if="e.ref_id && (e.event_type === 'calendar_event' || e.event_type === 'opportunity' || e.event_type === 'auto_reply')"
                                                class="flex items-center gap-2 whitespace-nowrap">
                                                <template v-if="e.event_type === 'calendar_event'">
                                                    <button @click="openCalendarEditById(e.ref_id)"
                                                        class="btn btn-primary btn-sm">
                                                        編輯
                                                    </button>
                                                    <button @click="downloadCalendarIcs(e.ref_id)"
                                                        class="btn btn-secondary btn-sm">
                                                        📅 ICS
                                                    </button>
                                                    <button @click="cancelCalendarEvent(e.ref_id)"
                                                        class="btn btn-warning btn-sm">
                                                        取消
                                                    </button>
                                                </template>
                                                <template v-else-if="e.event_type === 'opportunity'">
                                                    <button type="button" @click.stop.prevent="openOpportunityDetailById(e.ref_id)"
                                                        class="btn btn-dark btn-sm">
                                                        查看商機
                                                    </button>
                                                </template>
                                                <template v-else-if="e.event_type === 'auto_reply'">
                                                    <button @click="openCrmAutoReplyById(e.ref_id)"
                                                        class="btn btn-primary btn-sm">
                                                        開啟草稿
                                                    </button>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="closeCrmModal" class="btn btn-sm btn-outline">關閉</button>
                    </div>
                </div>
            </div>

            <div v-if="showCalendarEditModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-lg">
                    <div class="modal-header">
                        <h3 class="modal-title">編輯行事曆事件</h3>
                        <button @click="closeCalendarEditModal"
                            class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="modal-body space-y-4">
                        <div>
                            <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">標題</label>
                            <input v-model="calendarEditForm.title" class="input" />
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">開始</label>
                                <input v-model="calendarEditForm.start_time" type="datetime-local" step="60" class="input" />
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">結束</label>
                                <input v-model="calendarEditForm.end_time" type="datetime-local" step="60" class="input" />
                            </div>
                        </div>
                        <div>
                            <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">聯絡人 Email（可選）</label>
                            <input v-model="calendarEditForm.contact_email" class="input" />
                        </div>
                        <div>
                            <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">地點（可選）</label>
                            <input v-model="calendarEditForm.location" class="input" />
                        </div>
                        <div>
                            <div class="flex items-center justify-between mb-1">
                                <label style="font-size:0.875rem;font-weight:700;color:var(--gray-700);">描述（可選）</label>
                                <div class="flex items-center gap-2">
                                    <button @click="aiAgendaForEdit" :disabled="calendarEditSaving"
                                        class="btn btn-ghost btn-xs">AI 建議議程</button>
                                    <button @click="aiInviteDraftForEdit" :disabled="calendarEditSaving"
                                        class="btn btn-ghost btn-xs">AI 邀請文案</button>
                                </div>
                            </div>
                            <textarea v-model="calendarEditForm.description" rows="4" class="input"></textarea>
                        </div>
                        <div>
                            <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">狀態</label>
                            <select v-model="calendarEditForm.status" class="input">
                                <option value="confirmed">confirmed</option>
                                <option value="draft">draft</option>
                                <option value="canceled">canceled</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="closeCalendarEditModal" class="btn btn-sm btn-outline">取消</button>
                        <button @click="saveCalendarEdit" :disabled="calendarEditSaving"
                            class="btn btn-primary">
                            {{ calendarEditSaving ? '儲存中...' : '儲存' }}
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="showCrmAutoReplyModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-4xl">
                    <div class="modal-header">
                        <h3 class="modal-title">自動跟進草稿</h3>
                        <button @click="closeCrmAutoReplyModal"
                            class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="modal-body space-y-4">
                        <div v-if="crmAutoReplyLoading" class="empty-state" style="padding:2.5rem 0;">
                            <span class="spinner spinner-sm" style="margin-right:0.5rem;"></span> 載入中...
                        </div>

                        <div v-else-if="!crmAutoReplyDetail" class="empty-state" style="padding:2.5rem 1rem;">
                            尚無草稿資料
                        </div>

                        <div v-else class="space-y-4">
                            <div class="flex flex-wrap items-center gap-2">
                                <button @click="crmOpenAutoReplyOriginal"
                                    :disabled="!(crmAutoReplyDetail.original_message_id || crmAutoReplyDetail.original_imap_id || (contactCache[crmAutoReplyDetail?.contact_id]?.email && crmAutoReplyDetail.original_subject))"
                                    :title="(crmAutoReplyDetail.original_message_id || crmAutoReplyDetail.original_imap_id || (contactCache[crmAutoReplyDetail?.contact_id]?.email && crmAutoReplyDetail.original_subject)) ? '在「我的信箱」開啟原始來信' : '此草稿沒有原信資訊（可能是舊資料）'"
                                    class="btn btn-secondary">
                                    查看原信
                                </button>
                                <button @click="crmApplyAutoReplyToCompose"
                                    class="btn btn-primary">
                                    帶入撰寫
                                </button>
                                <button @click="crmSendAutoReply"
                                    :disabled="crmAutoReplySending"
                                    class="btn btn-dark">
                                    {{ crmAutoReplySending ? '送出中…' : '送出' }}
                                </button>

                                <div class="ml-auto flex items-center gap-2">
                                    <span style="font-size:0.75rem;color:var(--gray-500);">狀態</span>
                                    <select v-model="crmAutoReplyEditForm.status" class="input">
                                        <option value="pending">pending</option>
                                        <option value="approved">approved</option>
                                        <option value="rejected">rejected</option>
                                        <option value="sent">sent</option>
                                    </select>
                                </div>
                            </div>

                            <div class="card card-body" style="padding:1rem;">
                                <div style="font-size:0.875rem;font-weight:700;color:var(--gray-800);">原始來信</div>
                                <div style="font-size:0.875rem;color:var(--gray-600);margin-top:0.5rem;">主旨：{{ crmAutoReplyDetail.original_subject || '—' }}</div>
                                <textarea class="input p-3 mt-3" rows="6" readonly
                                    :value="crmAutoReplyDetail.original_body || ''"></textarea>
                            </div>

                            <div class="border rounded-lg p-4 space-y-3" style="background:var(--surface);">
                                <div>
                                    <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">草稿主旨</label>
                                    <input v-model="crmAutoReplyEditForm.draft_subject" class="input" />
                                </div>
                                <div>
                                    <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">草稿內容</label>
                                    <textarea v-model="crmAutoReplyEditForm.draft_body" rows="10"
                                        class="input"></textarea>
                                </div>
                                <div class="flex justify-end">
                                    <button @click="crmSaveAutoReply"
                                        :disabled="crmAutoReplySaving"
                                        class="btn btn-success">
                                        {{ crmAutoReplySaving ? '儲存中...' : '儲存草稿' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="closeCrmAutoReplyModal" class="btn btn-sm btn-outline">關閉</button>
                    </div>
                </div>
            </div>

            <div v-if="showCrmPickerModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-lg">
                    <div class="modal-header">
                        <h3 class="modal-title">CRM（搜尋聯絡人）</h3>
                        <button @click="closeCrmPicker"
                            class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="modal-body space-y-4">
                        <div class="flex items-center gap-2">
                            <input v-model="crmPickerQuery" @keydown.enter.prevent="searchCrmContacts"
                                class="flex-1 border rounded px-3 py-2 text-sm"
                                placeholder="輸入 contact_id 或 Email/姓名" />
                            <button type="button" @click.stop.prevent="searchCrmContacts" :disabled="crmPickerLoading"
                                class="btn btn-primary">
                                {{ crmPickerLoading ? '搜尋中...' : '搜尋' }}
                            </button>
                        </div>

                        <div v-if="crmPickerError" style="font-size:0.875rem;color:var(--color-danger);">{{ crmPickerError }}</div>

                        <div v-if="safeArr(crmPickerResults).length === 0 && !crmPickerLoading" style="font-size:0.875rem;color:var(--gray-500);">
                            輸入 Email/姓名可搜尋聯絡人；或直接輸入 contact_id 開啟 CRM。
                        </div>

                        <div v-else class="space-y-2">
                            <div v-for="(c, idx) in safeArr(crmPickerResults)" :key="keyById(c, 'crmpick', idx)" class="input p-3">
                                <div class="flex items-start justify-between gap-3">
                                    <div class="min-w-0">
                                        <div style="font-size:0.875rem;font-weight:700;color:var(--gray-900);">{{ c.name || '—' }}</div>
                                        <div style="font-size:0.75rem;color:var(--gray-600);margin-top:0.25rem;">{{ c.email || '—' }} · #{{ c.id }}</div>
                                        <div style="font-size:0.75rem;color:var(--gray-500);margin-top:0.25rem;" v-if="c.last_interaction_at">
                                            最近互動：{{ new Date(c.last_interaction_at).toLocaleString() }}
                                        </div>
                                    </div>
                                    <button type="button" @click.stop.prevent="openCrmFromPicked(c)"
                                        class="btn btn-primary btn-sm">
                                        開啟 CRM
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="closeCrmPicker" class="btn btn-sm btn-outline">關閉</button>
                    </div>
                </div>
            </div>

            <!-- Subject Optimizer Modal -->
            <div v-if="showSubjectOptimizerModal"
                class="modal-overlay" style="z-index:10010;">
                <div class="modal-box w-full max-w-lg">
                    <div class="modal-header">
                        <h3 class="font-bold text-lg flex items-center gap-2">
                            <span>🔮</span> AI 主旨優化 (A/B Testing)
                        </h3>
                        <button @click="showSubjectOptimizerModal = false"
                            class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="p-6 overflow-y-auto" style="background:var(--surface);">
                        <div v-if="optimizingSubject" class="flex flex-col items-center justify-center py-8">
                            <span class="spinner spinner-lg"></span>
                            <p class="animate-pulse" style="color:var(--gray-600);">正在分析內容並生成高開啟率主旨...</p>
                        </div>

                        <div v-else-if="subjectVariations.length === 0" class="text-center py-8" style="color:var(--gray-500);">
                            無法生成主旨建議，請稍後再試。
                        </div>

                        <div v-else class="space-y-4">
                            <p style="font-size:0.875rem;color:var(--gray-500);margin-bottom:1rem;">以下是 AI 根據您的內容預測開啟率較高的主旨建議：</p>

                            <div v-for="(item, idx) in subjectVariations" :key="idx"
                                class="card p-4 hover:shadow-md transition-shadow">
                                <div class="flex justify-between items-start mb-2">
                                    <h4 style="font-weight:700;font-size:1.125rem;color:var(--gray-900);">{{ item.subject }}</h4>
                                    <span
                                        class="badge badge-default whitespace-nowrap">
                                        預測分數: {{ item.score }}
                                    </span>
                                </div>

                                <!-- Score Bar -->
                                <div style="width:100%;background:var(--gray-200);border-radius:9999px;height:0.375rem;margin-bottom:0.75rem;">
                                    <div style="background:var(--brand-600,#4f46e5);height:0.375rem;border-radius:9999px;" :style="{ width: item.score + '%' }">
                                    </div>
                                </div>

                                <p class="border rounded p-2" style="font-size:0.875rem;color:var(--gray-600);margin-bottom:0.75rem;background:var(--surface);">
                                    💡 <span class="italic">{{ item.reasoning }}</span>
                                </p>

                                <button @click="applySubject(item.subject)"
                                    class="btn btn-primary w-full">
                                    <span>✅</span> 套用此主旨
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- AI Draft Modal -->
            <div v-if="showAiDraftModal"
                class="modal-overlay">
                <div class="card p-6 -xl w-full max-w-lg flex flex-col">
                    <div class="flex justify-between items-center p-4 border-b">
                        <h3 class="font-bold text-lg">AI 智能撰寫</h3>
                        <button @click="showAiDraftModal = false"
                            class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="p-4 space-y-4">
                        <div>
                            <label class="block text-sm font-bold mb-2">撰寫指引 (您想寫什麼？)</label>
                            <textarea v-model="aiDraftForm.instructions" placeholder="例如：寫一封信給客戶，說明下週會議延期到週五..."
                                class="input" style="height:8rem;resize:vertical;"></textarea>
                        </div>
                        <div>
                            <label class="block text-sm font-bold mb-2">語氣</label>
                            <select v-model="aiDraftForm.tone" class="input">
                                <option value="professional">專業 (Professional)</option>
                                <option value="friendly">親切 (Friendly)</option>
                                <option value="concise">簡潔 (Concise)</option>
                                <option value="urgent">緊急 (Urgent)</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="showAiDraftModal = false"
                            class="btn btn-ghost btn-sm">取消</button>
                        <button @click="generateSmartDraft"
                            class="btn btn-primary"
                            :disabled="aiLoading">
                            <span v-if="aiLoading" class="spinner spinner-sm"></span>
                            {{ aiLoading ? '生成中...' : '開始生成' }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- AI Reply Modal -->
            <div v-if="showAiReplyModal"
                class="modal-overlay">
                <div class="card p-6 -xl w-full max-w-lg flex flex-col">
                    <div class="flex justify-between items-center p-4 border-b cbi-header">
                        <div class="flex items-center gap-2">
                            <span>↩️</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 智能回覆</h3>
                        </div>
                        <button @click="showAiReplyModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>
                    <div class="p-4 space-y-4">
                        <p style="font-size:0.875rem;color:var(--gray-600);">針對目前的郵件內容，您希望 AI 如何回覆？</p>
                        <div>
                            <label class="block text-sm font-bold mb-2">回覆語氣/類型</label>
                            <select v-model="aiReplyForm.tone" class="input">
                                <option value="professional">專業回覆 (Professional)</option>
                                <option value="friendly">親切感謝 (Friendly)</option>
                                <option value="concise">簡短確認 (Concise)</option>
                                <option value="refusal">委婉拒絕 (Refusal)</option>
                                <option value="multi-tone">提供三種版本供選擇</option>
                            </select>
                        </div>
                        <div>
                            <label class="block text-sm font-bold mb-2">額外指示 (選填)</label>
                            <input v-model="aiReplyForm.instructions" placeholder="例如：提到我下週不在辦公室..."
                                class="input">
                        </div>
                        <div class="grid grid-cols-2 gap-3">
                            <div>
                                <label class="block text-sm font-bold mb-2">語言</label>
                                <select v-model="aiReplyForm.language" class="w-full border p-2 rounded">
                                    <option value="auto">自動偵測</option>
                                    <option value="Traditional Chinese (繁體中文)">繁體中文</option>
                                    <option value="English">English</option>
                                    <option value="Japanese">日本語</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm font-bold mb-2">長度</label>
                                <select v-model="aiReplyForm.length" class="w-full border p-2 rounded">
                                    <option value="short">短</option>
                                    <option value="medium">中</option>
                                    <option value="long">長</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm font-bold mb-2">模板</label>
                                <select v-model="aiReplyForm.template" class="w-full border p-2 rounded">
                                    <option value="standard_reply">標準回覆</option>
                                    <option value="acknowledge_and_confirm">確認收到</option>
                                    <option value="ask_clarifying">追問釐清</option>
                                    <option value="provide_options">提供選項</option>
                                    <option value="polite_decline">禮貌拒絕</option>
                                </select>
                            </div>
                            <div class="flex items-end">
                                <label class="inline-flex items-center gap-2 text-sm">
                                    <input type="checkbox" v-model="aiReplyForm.include_quote">
                                    附上原文引用
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="showAiReplyModal = false"
                            class="btn btn-ghost btn-sm">取消</button>
                        <button @click="generateSmartReply"
                            class="btn btn-primary"
                            :disabled="aiLoading">
                            <span v-if="aiLoading" class="spinner spinner-sm"></span>
                            {{ aiLoading ? '生成中...' : '生成回覆' }}
                        </button>
                    </div>
                </div>
            </div>
            <!-- AI Rewrite Modal -->
            <div v-if="showAiRewriteModal"
                class="modal-overlay" style="z-index:10010;">
                <div class="card p-6 -xl w-full max-w-lg flex flex-col">
                    <div class="flex justify-between items-center p-4 border-b">
                        <h3 class="font-bold text-lg">AI 郵件潤飾</h3>
                        <button @click="showAiRewriteModal = false"
                            class="btn btn-ghost btn-sm">×</button>
                    </div>
                    <div class="p-4 space-y-4">
                        <p style="font-size:0.875rem;color:var(--gray-600);">AI 將會優化您的郵件內容，使其更加流暢得體。</p>
                        <div>
                            <label class="block text-sm font-bold mb-2">潤飾語氣</label>
                            <select v-model="aiRewriteForm.tone" class="w-full border p-2 rounded">
                                <option value="professional">專業正式 (Professional)</option>
                                <option value="friendly">親切友善 (Friendly)</option>
                                <option value="concise">簡潔明瞭 (Concise)</option>
                                <option value="detailed">詳細說明 (Detailed)</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="showAiRewriteModal = false"
                            class="btn btn-ghost btn-sm">取消</button>
                        <button @click="generateSmartRewrite"
                            class="btn btn-primary"
                            :disabled="aiLoading">
                            <span v-if="aiLoading" class="spinner spinner-sm"></span>
                            {{ aiLoading ? '處理中...' : '開始潤飾' }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- AI Translate Modal -->
            <div v-if="showAiTranslateModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-lg">
                    <div class="flex justify-between items-center p-4 border-b cbi-header">
                        <div class="flex items-center gap-2">
                            <span>🌐</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 郵件翻譯</h3>
                        </div>
                        <button @click="showAiTranslateModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>
                    <div class="p-4 space-y-4 overflow-y-auto">
                        <div v-if="!aiTranslateResult">
                            <label class="block text-sm font-bold mb-2">目標語言</label>
                            <select v-model="aiTranslateForm.target_language" class="w-full border p-2 rounded">
                                <option value="Traditional Chinese (繁體中文)">繁體中文 (Traditional Chinese)</option>
                                <option value="English">英文 (English)</option>
                                <option value="Japanese">日文 (Japanese)</option>
                                <option value="Korean">韓文 (Korean)</option>
                                <option value="Simplified Chinese (简体中文)">簡體中文 (Simplified Chinese)</option>
                            </select>
                        </div>
                        <div v-else>
                            <div class="border rounded" style="background:var(--gray-50);padding:0.75rem;white-space:pre-wrap;">{{ aiTranslateResult }}</div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="showAiTranslateModal = false"
                            class="btn btn-ghost btn-sm">關閉</button>
                        <button v-if="!aiTranslateResult" @click="generateSmartTranslate"
                            class="btn btn-primary"
                            :disabled="aiLoading">
                            <span v-if="aiLoading" class="spinner spinner-sm"></span>
                            {{ aiLoading ? '翻譯中...' : '開始翻譯' }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- AI Summary Modal -->
            <div v-if="showAiSummaryModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-lg">
                    <div class="flex justify-between items-center p-4 border-b cbi-header">
                        <div class="flex items-center gap-2">
                            <span>📝</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 郵件摘要</h3>
                        </div>
                        <button @click="showAiSummaryModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>
                    <div class="p-4 overflow-y-auto">
                        <div class="prose max-w-none whitespace-pre-wrap">{{ aiSummaryResult }}</div>
                    </div>
                    <div class="modal-footer">
                        <button @click="showAiSummaryModal = false"
                            class="btn btn-primary">關閉</button>
                    </div>
                </div>
            </div>

            <!-- AI Customer Background Modal -->
            <div v-if="showAiCustomerModal" class="modal-overlay">
                <div class="modal-box w-full max-w-2xl cbi-modal">

                    <!-- Header -->
                    <div class="flex justify-between items-center p-4 border-b cbi-header">
                        <div class="flex items-center gap-2">
                            <span style="font-size:1.2rem;">🏢</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 客戶背景情報分析</h3>
                        </div>
                        <button @click="showAiCustomerModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>

                    <!-- Loading State -->
                    <div v-if="aiLoading && !aiCustomerResult" class="cbi-loading-body">
                        <div class="cbi-loading-icon">🤖</div>
                        <div class="font-semibold mb-5" style="color:var(--gray-700);">AI 正在分析客戶背景情報...</div>
                        <div class="cbi-steps">
                            <div class="cbi-step cbi-step-done">
                                <span class="cbi-step-icon done">✓</span>
                                <span class="cbi-step-label">讀取郵件內容</span>
                            </div>
                            <div class="cbi-step" style="animation:cbi-step-in 0.4s ease 2.5s both;">
                                <span class="cbi-step-icon spin">⟳</span>
                                <span class="cbi-step-label">分析寄件者與公司網域</span>
                            </div>
                            <div class="cbi-step" style="animation:cbi-step-in 0.4s ease 5s both;">
                                <span class="cbi-step-icon spin">⟳</span>
                                <span class="cbi-step-label">推論需求意圖與商機</span>
                            </div>
                            <div class="cbi-step" style="animation:cbi-step-in 0.4s ease 8s both;">
                                <span class="cbi-step-icon spin">⟳</span>
                                <span class="cbi-step-label">生成客戶情報報告</span>
                            </div>
                        </div>
                        <div class="cbi-loading-hint">通常需要 10–30 秒，視 AI 引擎負載而定</div>
                    </div>

                    <!-- Result Content -->
                    <div class="overflow-y-auto" style="max-height:65vh;" v-if="aiCustomerResult">

                        <!-- Company Banner -->
                        <div class="p-4 border-b" style="background:linear-gradient(135deg,#f0f4ff 0%,#f5f3ff 100%);">
                            <div class="flex items-start justify-between gap-3">
                                <div class="flex-1 min-w-0">
                                    <div class="font-bold text-lg" style="color:var(--gray-900);">
                                        {{ aiCustomerResult.company_profile?.name || '未識別公司' }}
                                    </div>
                                    <div class="text-sm mt-1" style="color:#4338ca;" v-if="aiCustomerResult.company_profile?.website">
                                        🔗 {{ aiCustomerResult.company_profile?.website }}
                                    </div>
                                    <div class="flex flex-wrap gap-1 mt-2">
                                        <span v-for="ind in (aiCustomerResult.company_profile?.industry || [])" :key="ind"
                                              class="cbi-tag">{{ ind }}</span>
                                        <span class="cbi-tag-gray">
                                            🏭 {{ aiCustomerResult.company_profile?.size_estimate?.band || 'unknown' }}
                                        </span>
                                    </div>
                                </div>
                                <div class="text-center flex-shrink-0">
                                    <div class="cbi-confidence"
                                         :class="(aiCustomerResult.confidence||0)>=0.7?'high':(aiCustomerResult.confidence||0)>=0.4?'mid':'low'">
                                        {{ Math.round((aiCustomerResult.confidence||0)*100) }}%
                                    </div>
                                    <div class="text-xs mt-1" style="color:var(--gray-500);">信心指數</div>
                                </div>
                            </div>
                        </div>

                        <div class="p-4 space-y-3">

                            <!-- Intent -->
                            <div class="card p-4">
                                <div class="flex items-center justify-between mb-3">
                                    <div class="font-bold" style="color:var(--gray-800);">📨 來信意圖</div>
                                    <span class="cbi-intent-badge"
                                          :data-type="aiCustomerResult.email_intent?.type">
                                        {{ {quote:'詢價',inquiry:'詢問',complaint:'客訴',partnership:'合作',other:'其他'}[aiCustomerResult.email_intent?.type] || aiCustomerResult.email_intent?.type || '—' }}
                                    </span>
                                </div>
                                <div class="grid grid-cols-2 gap-2 text-sm">
                                    <div class="flex items-center gap-2">
                                        <span style="color:var(--gray-500);">急迫度</span>
                                        <span class="font-medium"
                                              :style="{color:{high:'#dc2626',medium:'#d97706',low:'#16a34a',unknown:'#6b7280'}[aiCustomerResult.email_intent?.urgency]||'#6b7280'}">
                                            {{ {high:'🔴 高',medium:'🟡 中',low:'🟢 低',unknown:'⚪ 未知'}[aiCustomerResult.email_intent?.urgency] || aiCustomerResult.email_intent?.urgency || '—' }}
                                        </span>
                                    </div>
                                    <div v-if="aiCustomerResult.email_intent?.budget_hint" class="flex items-center gap-2">
                                        <span style="color:var(--gray-500);">預算</span>
                                        <span class="font-medium" style="color:var(--gray-700);">{{ aiCustomerResult.email_intent?.budget_hint }}</span>
                                    </div>
                                    <div v-if="aiCustomerResult.email_intent?.timeline_hint" class="flex items-center gap-2 col-span-2">
                                        <span style="color:var(--gray-500);">時程</span>
                                        <span class="font-medium" style="color:var(--gray-700);">{{ aiCustomerResult.email_intent?.timeline_hint }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Requirements -->
                            <div class="card p-4" v-if="(aiCustomerResult.requirements_guess||[]).length">
                                <div class="flex items-center justify-between mb-3">
                                    <div class="font-bold" style="color:var(--gray-800);">🎯 需求推論</div>
                                    <button @click="copyToClipboard(formatCustomerSummary(aiCustomerResult))"
                                            class="text-xs hover:underline" style="color:var(--brand-600,#4f46e5);">複製摘要</button>
                                </div>
                                <div class="space-y-2">
                                    <div v-for="(r,idx) in aiCustomerResult.requirements_guess" :key="idx"
                                         class="cbi-req-card">
                                        <div class="flex items-center justify-between mb-1">
                                            <span class="text-sm font-bold" style="color:var(--gray-800);">{{ r.category }}</span>
                                            <span class="cbi-conf-badge"
                                                  :class="r.confidence>=0.7?'high':r.confidence>=0.4?'mid':'low'">
                                                {{ Math.round(r.confidence*100) }}%
                                            </span>
                                        </div>
                                        <div class="text-xs" style="color:var(--gray-600);">{{ r.rationale }}</div>
                                        <div v-if="r.spec_range" class="text-xs mt-1" style="color:var(--gray-500);">規格：{{ r.spec_range }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Next Questions -->
                            <div class="card p-4" v-if="(aiCustomerResult.next_questions||[]).length">
                                <div class="font-bold mb-3" style="color:var(--gray-800);">💬 建議追問</div>
                                <div class="space-y-2">
                                    <div v-for="(q,idx) in aiCustomerResult.next_questions" :key="idx"
                                         class="flex items-start gap-2 text-sm p-2 rounded" style="background:var(--gray-50);">
                                        <span class="flex-shrink-0 font-bold" style="color:#7c3aed;">Q{{ idx+1 }}</span>
                                        <span style="color:var(--gray-700);">{{ q }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Reply Outline -->
                            <div class="card p-4" v-if="(aiCustomerResult.recommended_reply_outline||[]).length">
                                <div class="font-bold mb-3" style="color:var(--gray-800);">✉️ 回覆建議</div>
                                <div class="space-y-2">
                                    <div v-for="(step,idx) in aiCustomerResult.recommended_reply_outline" :key="idx"
                                         class="flex items-start gap-2 text-sm">
                                        <span class="cbi-step-num">{{ idx+1 }}</span>
                                        <span style="color:var(--gray-700);">{{ step }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Evidence -->
                            <div class="card p-4" v-if="(aiCustomerResult.evidence||[]).length">
                                <div class="font-bold mb-3" style="color:var(--gray-800);">🔍 情報來源</div>
                                <div class="space-y-2">
                                    <div v-for="(e,idx) in aiCustomerResult.evidence" :key="idx"
                                         class="text-xs p-2 rounded" style="background:var(--gray-50);color:var(--gray-700);">
                                        <div class="flex items-center gap-2 mb-1">
                                            <span class="cbi-source-badge">{{ e.source }}</span>
                                            <span v-if="e.url" class="break-all" style="color:#4338ca;">{{ e.url }}</span>
                                        </div>
                                        <div style="color:var(--gray-600);">{{ e.snippet }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Risk Flags -->
                            <div v-if="(aiCustomerResult.risk_flags||[]).length"
                                 class="p-4 rounded-lg border" style="background:#fef2f2;border-color:#fecaca;">
                                <div class="font-bold mb-2" style="color:#b91c1c;">⚠️ 風險提示</div>
                                <ul class="space-y-1 text-sm" style="color:#b91c1c;">
                                    <li v-for="(f,idx) in aiCustomerResult.risk_flags" :key="idx"
                                        class="flex items-start gap-1"><span>•</span><span>{{ f }}</span></li>
                                </ul>
                            </div>

                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="modal-footer">
                        <button v-if="aiCustomerResult?._meta?.contact_id"
                                @click="openContactById(aiCustomerResult._meta.contact_id)"
                                class="btn btn-dark">開啟聯絡人</button>
                        <button v-if="aiCustomerResult" @click="linkCustomerBackgroundToContact"
                                class="btn btn-success" :disabled="linkCbiToContactLoading">
                            {{ linkCbiToContactLoading ? '處理中...' : '建立/更新聯絡人' }}
                        </button>
                        <button @click="showAiCustomerModal = false" class="btn btn-primary">關閉</button>
                    </div>
                </div>
            </div>

            <!-- Customer Background List Modal -->
            <div v-if="showCustomerBackgroundListModal" class="modal-overlay">
                <div class="modal-box w-full max-w-4xl cbi-modal">

                    <!-- Header -->
                    <div class="flex justify-between items-center p-4 border-b cbi-header flex-shrink-0">
                        <div class="flex items-center gap-2">
                            <span style="font-size:1.2rem;">📋</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 客戶背景情報列表</h3>
                        </div>
                        <button @click="showCustomerBackgroundListModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>

                    <!-- Search & Filter Bar -->
                    <div class="p-4 border-b flex-shrink-0" style="background:var(--gray-50);">
                        <div class="flex items-center gap-2 mb-3">
                            <input v-model="cbiSearch" placeholder="🔍 搜尋公司 / 寄件者 / 主旨"
                                class="input flex-1" @keyup.enter="fetchCustomerBackgroundList" />
                            <button @click="fetchCustomerBackgroundList"
                                class="btn btn-primary btn-sm" :disabled="cbiListLoading">
                                <span v-if="cbiListLoading" class="animate-spin mr-1">⟳</span>
                                查詢
                            </button>
                        </div>
                        <div class="flex flex-wrap items-center gap-2">
                            <span class="text-xs font-bold" style="color:var(--gray-500);">排序</span>
                            <select v-model="cbiSortBy" class="input" style="width:auto;font-size:0.8rem;padding:0.25rem 0.5rem;">
                                <option value="created_at">時間</option>
                                <option value="company_name">公司</option>
                                <option value="confidence">信心</option>
                            </select>
                            <select v-model="cbiSortDir" class="input" style="width:auto;font-size:0.8rem;padding:0.25rem 0.5rem;">
                                <option value="desc">↓ 降冪</option>
                                <option value="asc">↑ 升冪</option>
                            </select>
                            <span class="text-xs font-bold ml-2" style="color:var(--gray-500);">狀態</span>
                            <select v-model="cbiStatusFilter" class="input" style="width:auto;font-size:0.8rem;padding:0.25rem 0.5rem;">
                                <option value="">全部</option>
                                <option value="new">未連結</option>
                                <option value="linked">已連結聯絡人</option>
                            </select>
                            <button @click="fetchCustomerBackgroundList"
                                class="btn btn-secondary btn-sm">套用</button>
                        </div>
                    </div>

                    <!-- List Body -->
                    <div class="overflow-y-auto" style="max-height:55vh;">

                        <!-- Loading -->
                        <div v-if="cbiListLoading" class="p-10 text-center" style="color:var(--gray-500);">
                            <div style="font-size:2rem;animation:cbi-spin 1s linear infinite;display:inline-block;" class="mb-3">⟳</div>
                            <div class="text-sm">載入中...</div>
                        </div>

                        <!-- Empty -->
                        <div v-else-if="!cbiList.length" class="p-10 text-center" style="color:var(--gray-400);">
                            <div style="font-size:2.5rem;" class="mb-2">🏢</div>
                            <div class="font-medium mb-1" style="color:var(--gray-600);">尚無情報記錄</div>
                            <div class="text-sm">在讀信時使用「AI 智能助手 → AI客戶背景情報分析」即可產生情報</div>
                        </div>

                        <!-- Table -->
                        <table v-else class="w-full text-sm cbi-list-table">
                            <thead>
                                <tr style="background:var(--gray-50);border-bottom:2px solid var(--gray-200);">
                                    <th class="cbi-th" style="width:2.5rem;">#</th>
                                    <th class="cbi-th">公司 / 寄件者</th>
                                    <th class="cbi-th">主旨</th>
                                    <th class="cbi-th" style="width:5rem;">信心</th>
                                    <th class="cbi-th" style="width:5rem;">狀態</th>
                                    <th class="cbi-th" style="width:9rem;">時間</th>
                                    <th class="cbi-th" style="width:8.5rem;text-align:right;">操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in cbiList" :key="item.id" class="cbi-list-row">
                                    <td class="cbi-td" style="color:var(--gray-400);font-size:0.75rem;">{{ item.id }}</td>
                                    <td class="cbi-td">
                                        <div class="font-medium" style="color:var(--gray-800);">
                                            {{ item.company_name || '—' }}
                                        </div>
                                        <div class="text-xs mt-0.5" style="color:var(--gray-500);">
                                            {{ item.sender_email || item.sender_name || '' }}
                                        </div>
                                    </td>
                                    <td class="cbi-td">
                                        <div class="truncate" style="max-width:220px;color:var(--gray-700);">
                                            {{ item.subject || '—' }}
                                        </div>
                                    </td>
                                    <td class="cbi-td">
                                        <span v-if="item.confidence != null" class="cbi-conf-badge"
                                              :class="item.confidence>=0.7?'high':item.confidence>=0.4?'mid':'low'">
                                            {{ Math.round(item.confidence*100) }}%
                                        </span>
                                        <span v-else style="color:var(--gray-400);">—</span>
                                    </td>
                                    <td class="cbi-td">
                                        <span v-if="item.contact_id" class="cbi-status-linked">已連結</span>
                                        <span v-else class="cbi-status-new">未連結</span>
                                    </td>
                                    <td class="cbi-td whitespace-nowrap" style="color:var(--gray-500);font-size:0.75rem;">
                                        {{ item.created_at ? new Date(item.created_at).toLocaleString() : '—' }}
                                    </td>
                                    <td class="cbi-td text-right">
                                        <button @click="viewCustomerBackground(item.id)"
                                            class="btn btn-ghost btn-xs mr-1" style="color:#4f46e5;">查看</button>
                                        <button v-if="!item.contact_id" @click="linkCustomerBackgroundRow(item)"
                                            class="btn btn-ghost btn-xs" style="color:var(--color-success);">建聯絡人</button>
                                        <button v-else @click="openContactById(item.contact_id)"
                                            class="btn btn-ghost btn-xs" style="color:var(--gray-600);">開聯絡人</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Footer -->
                    <div class="modal-footer flex-shrink-0">
                        <span class="text-sm mr-auto" style="color:var(--gray-500);" v-if="cbiListTotal">
                            共 {{ cbiListTotal }} 筆
                        </span>
                        <button @click="showCustomerBackgroundListModal = false" class="btn btn-primary">關閉</button>
                    </div>
                </div>
            </div>
            <!-- AI Event Modal -->
            <div v-if="showAiEventModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-lg">
                    <div class="flex justify-between items-center p-4 border-b cbi-header">
                        <div class="flex items-center gap-2">
                            <span>📅</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 提取事件</h3>
                        </div>
                        <button @click="showAiEventModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>
                    <div class="p-4 overflow-y-auto space-y-4" v-if="aiEventResult">
                        <div><label class="font-bold block">標題</label><input v-model="aiEventResult.title"
                                class="input w-full"></div>
                        <div><label class="font-bold block">開始時間</label><input v-model="aiEventResult.start_time" type="datetime-local" step="60"
                                class="input w-full"></div>
                        <div><label class="font-bold block">結束時間</label><input v-model="aiEventResult.end_time" type="datetime-local" step="60"
                                class="input w-full"></div>
                        <div><label class="font-bold block">地點</label><input v-model="aiEventResult.location"
                                class="input w-full"></div>
                        <div><label class="font-bold block">描述</label><textarea v-model="aiEventResult.description"
                                class="input w-full" rows="3"></textarea></div>
                    </div>
                    <div class="modal-footer flex-wrap">
                        <button @click="showAiEventModal = false"
                            class="btn btn-ghost btn-sm">取消</button>
                        <button @click="applyAiEventToCreateForm" :disabled="calendarAiParsing || calendarSavingFromAi"
                            class="btn btn-dark">
                            <span>📝</span>
                            帶入到新增事件
                        </button>
                        <button @click="saveAiEventToCalendar" :disabled="calendarSavingFromAi"
                            class="btn btn-primary">
                            <span v-if="calendarSavingFromAi" class="spinner spinner-sm"></span>
                            <span v-else>✅</span>
                            建立行事曆
                        </button>
                        <button @click="downloadIcs"
                            class="btn btn-success">
                            <span>📅</span> 下載 ICS
                        </button>
                    </div>
                </div>
            </div>

            <!-- AI Marketing Modal -->
            <div v-if="showAiMarketingModal" class="modal-overlay">
                <div class="modal-box w-full" :style="aiMarketingMaximized
                    ? 'max-width:100%;width:100%;height:100vh;max-height:100vh;border-radius:0;margin:0;'
                    : 'max-width:48rem;display:flex;flex-direction:column;max-height:92vh;'"
                    style="display:flex;flex-direction:column;">
                    <!-- Header -->
                    <div class="flex justify-between items-center px-6 py-4 shrink-0 cbi-header">
                        <div class="flex items-center gap-2">
                            <span style="font-size:1.2rem;">📣</span>
                            <div>
                                <div class="font-bold text-base" style="color:#fff;">AI 智能行銷助手</div>
                                <div class="text-xs" style="color:rgba(255,255,255,0.75);">行銷內容生成、群發活動、旅程規劃</div>
                            </div>
                        </div>
                        <div class="flex items-center gap-2">
                            <!-- Maximize toggle -->
                            <button @click="aiMarketingMaximized = !aiMarketingMaximized"
                                class="flex items-center justify-center w-8 h-8 rounded-lg transition"
                                style="background:rgba(255,255,255,0.15);color:#fff;border:none;cursor:pointer;"
                                :title="aiMarketingMaximized ? '還原視窗' : '最大化'"
                                onmouseover="this.style.background='rgba(255,255,255,0.28)'" onmouseout="this.style.background='rgba(255,255,255,0.15)'">
                                <svg v-if="!aiMarketingMaximized" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
                                <svg v-else width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="10" y1="14" x2="3" y2="21"/><line x1="21" y1="3" x2="14" y2="10"/></svg>
                            </button>
                            <button @click="showAiMarketingModal = false"
                                class="flex items-center justify-center w-8 h-8 rounded-lg transition"
                                style="background:rgba(255,255,255,0.15);color:#fff;border:none;font-size:1.125rem;cursor:pointer;"
                                onmouseover="this.style.background='rgba(255,255,255,0.28)'" onmouseout="this.style.background='rgba(255,255,255,0.15)'">
                                ×
                            </button>
                        </div>
                    </div>

                    <!-- Tab Navigation -->
                    <div class="flex shrink-0 overflow-x-auto" style="background:var(--surface);border-bottom:2px solid var(--gray-100);">
                        <button v-for="tab in [
                            { key:'generate', icon:'✉️', label:'EDM 生成' },
                            { key:'social',   icon:'📱', label:'社群貼文' },
                            { key:'campaign', icon:'🚀', label:'活動發送' },
                            { key:'journey',  icon:'🗺️', label:'行銷旅程' },
                        ]" :key="tab.key"
                            @click="handleMarketingTabClick(tab)"
                            class="flex items-center gap-1.5 px-4 py-3 text-sm font-medium whitespace-nowrap transition-all border-b-2 -mb-0.5"
                            :style="aiMarketingState.step === tab.key
                                ? 'border-color:#ec4899;color:#be185d;background:linear-gradient(to bottom,#fff5f7,transparent);'
                                : 'border-color:transparent;color:var(--gray-500);'">
                            <span>{{ tab.icon }}</span>
                            <span>{{ tab.label }}</span>
                        </button>
                    </div>

                    <!-- Scrollable Content -->
                    <div class="overflow-y-auto flex-1 p-6 space-y-5 custom-scrollbar">

                        <!-- ── EDM 生成 ── -->
                        <div v-if="aiMarketingState.step === 'generate'" class="space-y-5">
                            <!-- Template bar -->
                            <div class="flex items-center gap-3 rounded-xl p-3.5"
                                style="background:linear-gradient(to right,#eef2ff,#f5f3ff);border:1px solid #c7d2fe;">
                                <svg width="16" height="16" fill="none" stroke="#6366f1" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>
                                <span class="text-sm font-semibold" style="color:#4f46e5;white-space:nowrap;">快速載入範本</span>
                                <select class="input flex-1 text-sm" style="min-width:0;"
                                    @focus="fetchTemplates()"
                                    @change="loadTemplate($event)">
                                    <option value="">── 選擇行銷範本 ──</option>
                                    <option v-for="(t, idx) in safeArr(aiMarketingState.templates)" :key="keyById(t, 'tmpl', idx)" :value="t.id">{{ t.name }}</option>
                                </select>
                                <button @click="showTemplateManagerModal = true; fetchCustomTemplates()"
                                    class="flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm font-medium transition whitespace-nowrap"
                                    style="background:#fff;border:1px solid #c7d2fe;color:#4f46e5;"
                                    onmouseover="this.style.background='#eef2ff'" onmouseout="this.style.background='#fff'">
                                    <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 2v2m0 16v2M4.22 4.22l1.42 1.42m12.72 12.72 1.42 1.42M2 12h2m16 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>
                                    管理範本
                                </button>
                            </div>

                            <!-- Form grid -->
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">
                                            產品 / 服務名稱
                                            <span style="color:var(--color-danger);margin-left:2px;">*</span>
                                        </label>
                                        <input v-model="aiMarketingState.form.product_name" class="input w-full"
                                            placeholder="例如：AI 智能咖啡機">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">目標受眾</label>
                                        <div class="flex gap-2 mb-1.5">
                                            <select class="input" style="flex:0 0 auto;width:auto;max-width:60%;"
                                                @change="e => { if(e.target.value) { aiMarketingState.form.target_audience = e.target.value; e.target.value=''; } }">
                                                <option value="">── 快速選擇 ──</option>
                                                <optgroup label="年齡層">
                                                    <option value="18–24 歲 Z 世代">18–24 歲 Z 世代</option>
                                                    <option value="25–34 歲 千禧世代">25–34 歲 千禧世代</option>
                                                    <option value="35–50 歲 中壯年">35–50 歲 中壯年</option>
                                                    <option value="50 歲以上 銀髮族">50 歲以上 銀髮族</option>
                                                </optgroup>
                                                <optgroup label="職業 / 身份">
                                                    <option value="上班族">上班族</option>
                                                    <option value="學生族群">學生族群</option>
                                                    <option value="家庭主婦 / 主夫">家庭主婦 / 主夫</option>
                                                    <option value="中小企業主">中小企業主</option>
                                                    <option value="企業採購人員">企業採購人員</option>
                                                    <option value="IT 技術人員">IT 技術人員</option>
                                                    <option value="醫療從業人員">醫療從業人員</option>
                                                </optgroup>
                                                <optgroup label="興趣 / 消費族群">
                                                    <option value="咖啡愛好者">咖啡愛好者</option>
                                                    <option value="健身運動族群">健身運動族群</option>
                                                    <option value="美容保養族群">美容保養族群</option>
                                                    <option value="旅遊愛好者">旅遊愛好者</option>
                                                    <option value="科技早鳥用戶">科技早鳥用戶</option>
                                                    <option value="親子家庭">親子家庭</option>
                                                    <option value="電商消費者">電商消費者</option>
                                                    <option value="高端奢侈品消費者">高端奢侈品消費者</option>
                                                </optgroup>
                                                <optgroup label="地區">
                                                    <option value="台灣本地用戶">台灣本地用戶</option>
                                                    <option value="海外華語用戶">海外華語用戶</option>
                                                    <option value="大台北都會區">大台北都會區</option>
                                                </optgroup>
                                            </select>
                                            <span class="text-xs self-center" style="color:var(--gray-400);flex-shrink:0;">或</span>
                                        </div>
                                        <input v-model="aiMarketingState.form.target_audience" class="input w-full"
                                            placeholder="自訂：例如 30–45 歲愛好健康飲食的上班族">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">語氣風格</label>
                                        <div class="grid grid-cols-1 gap-1.5">
                                            <label v-for="opt in [
                                                {v:'Professional', label:'專業穩重', sub:'Professional'},
                                                {v:'Enthusiastic', label:'熱情活潑', sub:'Enthusiastic'},
                                                {v:'Urgent',       label:'限時促銷', sub:'Urgent'},
                                                {v:'Friendly',     label:'親切友善', sub:'Friendly'},
                                                {v:'Storytelling', label:'故事行銷', sub:'Storytelling'},
                                            ]" :key="opt.v"
                                                class="flex items-center gap-2.5 px-3 py-2 rounded-lg cursor-pointer border transition"
                                                :style="aiMarketingState.form.tone === opt.v
                                                    ? 'border-color:#ec4899;background:#fff5f7;'
                                                    : 'border-color:var(--gray-200);background:var(--surface);'">
                                                <input type="radio" v-model="aiMarketingState.form.tone" :value="opt.v" class="w-3.5 h-3.5" style="accent-color:#ec4899;">
                                                <span class="text-sm font-medium" style="color:var(--gray-800);">{{ opt.label }}</span>
                                                <span class="text-xs ml-auto" style="color:var(--gray-400);">{{ opt.sub }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex flex-col">
                                    <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">
                                        核心賣點 <span class="font-normal" style="color:var(--gray-400);">— 每行一點</span>
                                    </label>
                                    <textarea v-model="aiMarketingState.form.key_features" rows="12"
                                        class="input w-full flex-1"
                                        style="resize:none;font-size:0.875rem;line-height:1.6;"
                                        placeholder="- 快速加熱，30 秒到達最佳溫度&#10;- 智能溫控，自動調節&#10;- App 遠端操作&#10;- 省電節能認證"></textarea>
                                    <p class="text-xs mt-1.5" style="color:var(--gray-400);">以 - 開頭更好閱讀，AI 會自動整理格式</p>
                                </div>
                            </div>

                            <!-- Preview area -->
                            <div v-if="aiMarketingState.result" class="rounded-xl overflow-hidden animate-fade-in"
                                style="border:1px solid var(--border);">
                                <div class="flex justify-between items-center px-4 py-3"
                                    style="background:var(--gray-50);border-bottom:1px solid var(--border);">
                                    <div class="flex items-center gap-2">
                                        <svg width="14" height="14" fill="none" stroke="#6366f1" stroke-width="2" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                        <span class="text-sm font-semibold" style="color:var(--gray-700);">EDM 預覽</span>
                                        <span v-if="aiMarketingState.fullResult?.subject"
                                            class="ml-2 px-2 py-0.5 rounded-full text-xs font-medium"
                                            style="background:#e0e7ff;color:#4338ca;">
                                            主旨：{{ aiMarketingState.fullResult.subject }}
                                        </span>
                                    </div>
                                    <div class="flex items-center gap-1.5 flex-wrap">
                                        <button @click="() => { templateMgmt.form.name = aiMarketingState.form?.product_name ? aiMarketingState.form.product_name + ' 範本' : ''; templateMgmt.form.subject = aiMarketingState.fullResult?.subject || ''; templateMgmt.form.content_html = aiMarketingState.result || ''; templateMgmt.form.description = ''; templateMgmt.editingId = null; showTemplateManagerModal = true; }"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:#fff;border:1px solid var(--gray-200);color:var(--gray-600);"
                                            onmouseover="this.style.borderColor='#a5b4fc';this.style.color='#4f46e5'" onmouseout="this.style.borderColor='var(--gray-200)';this.style.color='var(--gray-600)'">
                                            💾 另存為範本
                                        </button>
                                        <button @click="openInboxPreview()"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:#fff;border:1px solid var(--gray-200);color:var(--gray-600);"
                                            onmouseover="this.style.borderColor='#6ee7b7';this.style.color='#059669'" onmouseout="this.style.borderColor='var(--gray-200)';this.style.color='var(--gray-600)'">
                                            📬 收件匣預覽
                                        </button>
                                        <button @click="runSpamCheck()" :disabled="spamCheck.loading"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:#fff;border:1px solid var(--gray-200);color:var(--gray-600);"
                                            onmouseover="this.style.borderColor='#fca5a5';this.style.color='#dc2626'" onmouseout="this.style.borderColor='var(--gray-200)';this.style.color='var(--gray-600)'">
                                            {{ spamCheck.loading ? '分析中...' : '🛡️ 垃圾郵件分析' }}
                                        </button>
                                    </div>
                                </div>
                                <iframe class="w-full" style="height:22rem;border:none;background:#fff;display:block;"
                                    :srcdoc="aiMarketingState.result"
                                    sandbox="allow-same-origin"></iframe>

                                <!-- ── 垃圾郵件分析結果 ── -->
                                <div v-if="spamCheck.result" style="border-top:1px solid var(--border);padding:0.75rem 1rem;background:#fafafa;">
                                    <div class="flex items-center gap-3 mb-2">
                                        <span class="text-xs font-bold" style="color:var(--gray-700);">🛡️ 垃圾郵件分析</span>
                                        <span class="text-sm font-bold px-3 py-0.5 rounded-full"
                                            :style="spamCheck.result.score >= 8 ? 'background:#d1fae5;color:#065f46;' : spamCheck.result.score >= 5 ? 'background:#fef3c7;color:#92400e;' : 'background:#fee2e2;color:#991b1b;'">
                                            {{ spamCheck.result.grade }} {{ spamCheck.result.score }} / 10
                                        </span>
                                        <span v-if="spamCheck.result.rspamd_score !== null" class="text-xs" style="color:var(--gray-500);">
                                            Rspamd: {{ spamCheck.result.rspamd_score }} ({{ spamCheck.result.rspamd_action }})
                                        </span>
                                    </div>
                                    <div v-if="spamCheck.result.issues?.length" class="space-y-1">
                                        <div v-for="(issue, i) in spamCheck.result.issues" :key="i"
                                            class="text-xs px-2 py-1 rounded flex items-start gap-1"
                                            :style="issue.severity === 'error' ? 'background:#fee2e2;color:#991b1b;' : 'background:#fef3c7;color:#92400e;'">
                                            {{ issue.severity === 'error' ? '✗' : '⚠' }} {{ issue.desc }}
                                        </div>
                                    </div>
                                    <div v-else class="text-xs" style="color:#059669;">✓ 未偵測到明顯問題</div>
                                </div>
                                <div v-if="spamCheck.error" style="border-top:1px solid var(--border);padding:0.5rem 1rem;">
                                    <span class="text-xs" style="color:var(--color-danger);">{{ spamCheck.error }}</span>
                                </div>

                                <!-- ── 追蹤連結插入面板 ── -->
                                <div style="border-top:1px solid var(--border);background:var(--surface-secondary,var(--gray-50));">
                                  <div class="px-4 pt-3 pb-1 flex items-center gap-2">
                                    <svg width="14" height="14" fill="none" stroke="#6366f1" stroke-width="2" viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
                                    <span class="text-xs font-semibold" style="color:var(--gray-700);">插入追蹤連結</span>
                                    <span class="text-xs" style="color:var(--gray-400);">點擊後自動記入點閱率</span>
                                  </div>
                                  <div class="px-4 pb-3 space-y-2">
                                    <!-- Input row -->
                                    <div class="flex gap-2 items-center flex-wrap">
                                      <input v-model="trackingLinkForm.label"
                                        class="input text-xs flex-1" style="min-width:120px;height:32px;"
                                        placeholder="按鈕文字，例如：立即了解"
                                        @keyup.enter="insertTrackingLink" />
                                      <input v-model="trackingLinkForm.url"
                                        class="input text-xs flex-1" style="min-width:200px;height:32px;"
                                        placeholder="https://your-website.com/page"
                                        @keyup.enter="insertTrackingLink" />
                                      <select v-model="trackingLinkForm.style"
                                        class="input text-xs" style="height:32px;width:88px;">
                                        <option value="button">按鈕</option>
                                        <option value="text">文字連結</option>
                                      </select>
                                      <button @click="insertTrackingLink"
                                        class="btn btn-primary btn-sm" style="height:32px;white-space:nowrap;">
                                        + 插入 EDM
                                      </button>
                                    </div>
                                    <!-- Inserted links list -->
                                    <div v-if="insertedLinkSnippets.length" class="flex flex-wrap gap-1.5 pt-1">
                                      <span v-for="(item, i) in insertedLinkSnippets" :key="i"
                                        class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs"
                                        style="background:#e0e7ff;color:#4338ca;max-width:320px;">
                                        <svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
                                        <span class="truncate" style="max-width:140px;" :title="item.url">{{ item.label }}</span>
                                        <span class="opacity-50 truncate" style="max-width:100px;font-size:0.65rem;">{{ item.url.replace(/^https?:\/\//, '') }}</span>
                                        <button @click="removeInsertedLink(i)"
                                          class="ml-0.5 rounded-full w-3.5 h-3.5 flex items-center justify-center hover:bg-indigo-200 transition"
                                          style="color:#4338ca;font-size:0.6rem;line-height:1;">✕</button>
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <!-- ── 插入行銷頁面 / 問卷連結 ── -->
                                <div style="border-top:1px solid var(--border);background:var(--surface-secondary,var(--gray-50));">
                                  <div class="px-4 pt-3 pb-1 flex items-center gap-2">
                                    <svg width="14" height="14" fill="none" stroke="#10b981" stroke-width="2" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
                                    <span class="text-xs font-semibold" style="color:var(--gray-700);">插入行銷頁面 / 問卷連結</span>
                                    <span class="text-xs" style="color:var(--gray-400);">從已建立的頁面或問卷一鍵插入 CTA 按鈕</span>
                                  </div>
                                  <div class="px-4 pb-3 space-y-2">
                                    <div class="flex gap-1 pb-1" style="border-bottom:1px solid var(--border);">
                                      <button v-for="t in [{k:'landing',l:'🖼 行銷推廣頁面'},{k:'survey',l:'📋 問卷調查'},{k:'booking',l:'📅 預約連結'}]" :key="t.k"
                                        @click="insertPageTab = t.k; loadInsertPageList()"
                                        :style="insertPageTab === t.k ? 'background:#ecfdf5;color:#065f46;font-weight:600;' : 'background:none;color:var(--gray-500);'"
                                        style="border:none;border-radius:5px;padding:3px 10px;font-size:.75rem;cursor:pointer;transition:.15s;">
                                        {{ t.l }}
                                      </button>
                                    </div>
                                    <div class="flex gap-2 items-center flex-wrap">
                                      <select v-model="insertPageSelected" class="input text-xs flex-1" style="min-width:180px;height:32px;" @change="autoFillInsertLabel">
                                        <option :value="null">-- 選擇{{ insertPageTab === 'landing' ? '行銷推廣頁面' : insertPageTab === 'survey' ? '問卷' : '預約頁面' }} --</option>
                                        <option v-for="p in insertPageList" :key="p.id" :value="p">{{ p.title }}</option>
                                      </select>
                                      <input v-model="insertPageLabel" class="input text-xs flex-1" style="min-width:110px;height:32px;" placeholder="按鈕文字">
                                      <select v-model="insertPageStyle" class="input text-xs" style="height:32px;width:80px;">
                                        <option value="button">按鈕</option>
                                        <option value="text">文字連結</option>
                                      </select>
                                      <button @click="insertPageLink" :disabled="!insertPageSelected || !insertPageLabel.trim()"
                                        class="btn btn-sm" style="height:32px;white-space:nowrap;background:#10b981;color:#fff;border:none;border-radius:6px;">
                                        + 插入 EDM
                                      </button>
                                    </div>
                                    <div v-if="insertPageSelected" class="text-xs" style="color:var(--gray-400);">
                                      連結：{{ pagePublicUrl(insertPageSelected) }}
                                    </div>
                                  </div>
                                </div>

                            </div>

                            <!-- ── AI 品質評分 & 翻譯 ── -->
                            <div v-if="aiMarketingState.result" class="rounded-xl overflow-hidden animate-fade-in" style="border:1px solid var(--border);margin-top:0.75rem;">
                                <div class="px-4 py-3 flex items-center gap-3 flex-wrap" style="background:linear-gradient(90deg,#f5f3ff,#eef2ff);border-bottom:1px solid #c7d2fe;">
                                    <span class="text-xs font-bold" style="color:#4f46e5;">🤖 AI 輔助工具</span>
                                    <!-- Quality check -->
                                    <button @click="checkEdmQuality" :disabled="edmQualityLoading"
                                        class="btn btn-sm" style="background:#4f46e5;color:#fff;border:none;">
                                        {{ edmQualityLoading ? '評分中...' : '🔍 品質評分' }}
                                    </button>
                                    <!-- Translate -->
                                    <div class="flex items-center gap-1.5">
                                        <select v-model="edmTranslateLang" class="input" style="height:30px;font-size:0.75rem;padding:0 0.5rem;">
                                            <option value="English">英文</option>
                                            <option value="Japanese">日文</option>
                                            <option value="Simplified Chinese">簡中</option>
                                            <option value="Korean">韓文</option>
                                        </select>
                                        <button @click="translateEdm" :disabled="edmTranslateLoading"
                                            class="btn btn-sm" style="background:#0891b2;color:#fff;border:none;white-space:nowrap;">
                                            {{ edmTranslateLoading ? '翻譯中...' : '🌐 翻譯版本' }}
                                        </button>
                                    </div>
                                </div>

                                <!-- Quality Result -->
                                <div v-if="edmQualityResult" class="p-4 space-y-3" style="background:#fafafa;">
                                    <div class="text-xs font-bold mb-2" style="color:#4f46e5;">📊 EDM 品質評分</div>
                                    <div class="grid grid-cols-2 md:grid-cols-5 gap-2">
                                        <div v-for="(item) in [
                                            {label:'主旨吸引力', val:edmQualityResult.subject_score, good:70},
                                            {label:'CTA 清晰度', val:edmQualityResult.cta_score, good:70},
                                            {label:'垃圾信風險', val:edmQualityResult.spam_risk, good:null, reverse:true},
                                            {label:'個人化程度', val:edmQualityResult.personal_score, good:50},
                                            {label:'整體評分', val:edmQualityResult.overall, good:70, bold:true},
                                        ]" :key="item.label" class="rounded-lg p-3 text-center" style="border:1px solid var(--border);background:#fff;">
                                            <div class="text-lg font-bold"
                                                :style="{color: item.val == null ? 'var(--gray-400)' : item.reverse ? (item.val<=30?'var(--color-success)':item.val<=60?'var(--color-warning)':'var(--color-danger)') : (item.val>=item.good?'var(--color-success)':item.val>=(item.good*0.7)?'var(--color-warning)':'var(--color-danger)')}">
                                                {{ item.val != null ? item.val : '—' }}
                                            </div>
                                            <div class="text-xs mt-0.5" style="color:var(--gray-500);">{{ item.label }}</div>
                                        </div>
                                    </div>
                                    <div v-if="edmQualityResult.suggestions" class="rounded p-3 text-xs whitespace-pre-line" style="background:#eef2ff;color:#3730a3;border:1px solid #c7d2fe;">
                                        <div class="font-bold mb-1">改善建議：</div>{{ edmQualityResult.suggestions }}
                                    </div>
                                    <div v-if="edmQualityError" class="text-xs" style="color:var(--color-danger);">{{ edmQualityError }}</div>
                                </div>

                                <!-- Translate Result -->
                                <div v-if="edmTranslateResult" class="p-4 space-y-3" style="background:#f0f9ff;border-top:1px solid #bae6fd;">
                                    <div class="flex items-center justify-between mb-1">
                                        <div class="text-xs font-bold" style="color:#0891b2;">🌐 {{ edmTranslateLang }} 翻譯版本</div>
                                        <div class="flex gap-2">
                                            <button @click="() => { navigator.clipboard.writeText(edmTranslateResult.subject || ''); $toast?.success('已複製主旨') }"
                                                class="btn btn-sm btn-outline" style="font-size:0.7rem;">複製主旨</button>
                                            <button @click="() => { navigator.clipboard.writeText(edmTranslateResult.body_html || ''); $toast?.success('已複製 HTML') }"
                                                class="btn btn-sm btn-outline" style="font-size:0.7rem;">複製 HTML</button>
                                        </div>
                                    </div>
                                    <div v-if="edmTranslateResult.subject" class="text-xs font-semibold px-2 py-1 rounded" style="background:#e0f2fe;color:#0369a1;">
                                        主旨：{{ edmTranslateResult.subject }}
                                    </div>
                                    <iframe v-if="edmTranslateResult.body_html"
                                        class="w-full rounded" style="height:16rem;border:1px solid #bae6fd;background:#fff;"
                                        :srcdoc="edmTranslateResult.body_html"
                                        sandbox="allow-same-origin"></iframe>
                                    <div v-if="edmTranslateError" class="text-xs" style="color:var(--color-danger);">{{ edmTranslateError }}</div>
                                </div>

                                <!-- ── 版型 AI 重構 ── -->
                                <div style="border-top:1px solid #e0e7ff;">
                                    <div class="flex items-center gap-2 p-3" style="background:#f5f3ff;">
                                        <span class="text-xs font-bold" style="color:#7c3aed;">🎨 版型 AI 重構</span>
                                        <select v-model="edmRedesignStyle" class="input" style="height:28px;font-size:0.75rem;padding:0 0.5rem;flex:1;">
                                            <option value="modern">現代感（漸層色塊）</option>
                                            <option value="minimal">極簡風（純白留白）</option>
                                            <option value="bold">強烈衝擊（大字標題）</option>
                                        </select>
                                        <button @click="redesignEdm" :disabled="edmRedesignLoading"
                                            class="btn btn-sm" style="background:#7c3aed;color:#fff;white-space:nowrap;">
                                            {{ edmRedesignLoading ? '重構中...' : '🎨 重構版型' }}
                                        </button>
                                    </div>
                                    <div v-if="edmRedesignError" class="text-xs px-3 py-1" style="color:var(--color-danger);">{{ edmRedesignError }}</div>
                                    <div v-if="edmRedesignResult" class="p-3 space-y-2">
                                        <div class="flex items-center justify-between">
                                            <span class="text-xs font-bold" style="color:#7c3aed;">重構預覽</span>
                                            <button @click="applyEdmRedesign" class="btn btn-sm" style="background:#7c3aed;color:#fff;">
                                                ✅ 套用此版型
                                            </button>
                                        </div>
                                        <iframe :srcdoc="edmRedesignResult.html"
                                            style="width:100%;height:340px;border:1px solid #ddd;border-radius:6px;background:#fff;"
                                            sandbox="allow-same-origin"></iframe>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- ── 社群貼文 ── -->
                        <div v-if="aiMarketingState.step === 'social'" class="space-y-5 animate-fade-in">
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">產品名稱</label>
                                        <input v-model="aiSocialState.form.product_name" class="input w-full"
                                            placeholder="例如：極速智能吹風機">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">目標受眾</label>
                                        <div class="flex gap-2 mb-1.5">
                                            <select class="input" style="flex:0 0 auto;width:auto;max-width:60%;"
                                                @change="e => { if(e.target.value) { aiSocialState.form.target_audience = e.target.value; e.target.value=''; } }">
                                                <option value="">── 快速選擇 ──</option>
                                                <optgroup label="年齡層">
                                                    <option value="18–24 歲 Z 世代">18–24 歲 Z 世代</option>
                                                    <option value="25–34 歲 千禧世代">25–34 歲 千禧世代</option>
                                                    <option value="35–50 歲 中壯年">35–50 歲 中壯年</option>
                                                    <option value="50 歲以上 銀髮族">50 歲以上 銀髮族</option>
                                                </optgroup>
                                                <optgroup label="職業 / 身份">
                                                    <option value="上班族">上班族</option>
                                                    <option value="學生族群">學生族群</option>
                                                    <option value="家庭主婦 / 主夫">家庭主婦 / 主夫</option>
                                                    <option value="中小企業主">中小企業主</option>
                                                    <option value="企業採購人員">企業採購人員</option>
                                                    <option value="IT 技術人員">IT 技術人員</option>
                                                    <option value="醫療從業人員">醫療從業人員</option>
                                                </optgroup>
                                                <optgroup label="興趣 / 消費族群">
                                                    <option value="咖啡愛好者">咖啡愛好者</option>
                                                    <option value="健身運動族群">健身運動族群</option>
                                                    <option value="美容保養族群">美容保養族群</option>
                                                    <option value="旅遊愛好者">旅遊愛好者</option>
                                                    <option value="科技早鳥用戶">科技早鳥用戶</option>
                                                    <option value="親子家庭">親子家庭</option>
                                                    <option value="電商消費者">電商消費者</option>
                                                    <option value="高端奢侈品消費者">高端奢侈品消費者</option>
                                                </optgroup>
                                                <optgroup label="地區">
                                                    <option value="台灣本地用戶">台灣本地用戶</option>
                                                    <option value="海外華語用戶">海外華語用戶</option>
                                                    <option value="大台北都會區">大台北都會區</option>
                                                </optgroup>
                                            </select>
                                            <span class="text-xs self-center" style="color:var(--gray-400);flex-shrink:0;">或</span>
                                        </div>
                                        <input v-model="aiSocialState.form.target_audience" class="input w-full"
                                            placeholder="自訂：例如 25–40 歲愛美女性、健身愛好者">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">語調風格</label>
                                        <select v-model="aiSocialState.form.tone" class="input w-full">
                                            <option value="Professional">🎩 專業正式</option>
                                            <option value="Friendly">😊 親切友善</option>
                                            <option value="Humorous">😄 幽默風趣</option>
                                            <option value="Inspiring">💪 勵志激勵</option>
                                            <option value="Urgency">⚡ 緊迫促購</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">發布平台</label>
                                        <div class="grid grid-cols-2 gap-2">
                                            <label v-for="p in [{v:'facebook',label:'Facebook',color:'#1877f2'},{v:'instagram',label:'Instagram',color:'#e1306c'},{v:'linkedin',label:'LinkedIn',color:'#0a66c2'},{v:'twitter',label:'X (Twitter)',color:'#000'}]"
                                                :key="p.v"
                                                class="flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer transition text-sm"
                                                :style="safeArr(aiSocialState.form.platforms).includes(p.v)
                                                    ? `border-color:${p.color};background:${p.color}11;color:${p.color};font-weight:600;`
                                                    : 'border-color:var(--gray-200);color:var(--gray-600);'">
                                                <input type="checkbox" v-model="aiSocialState.form.platforms" :value="p.v" style="display:none;">
                                                <span>{{ p.label }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-col">
                                    <label class="block text-sm font-semibold mb-1.5" style="color:var(--gray-700);">產品特色 / 促銷內容</label>
                                    <textarea v-model="aiSocialState.form.key_features" rows="10"
                                        class="input w-full flex-1"
                                        style="resize:none;"
                                        placeholder="描述產品優點或目前的促銷活動..."></textarea>
                                </div>
                            </div>

                            <div v-if="aiSocialState.result" class="rounded-xl overflow-hidden animate-fade-in"
                                style="border:1px solid var(--border);">
                                <div class="flex items-center justify-between px-4 py-3"
                                    style="background:var(--gray-50);border-bottom:1px solid var(--border);">
                                    <span class="text-sm font-semibold" style="color:var(--gray-700);">📝 社群貼文預覽</span>
                                    <button @click="navigator.clipboard.writeText(aiSocialState.result).then(() => showToast('已複製到剪貼簿'))"
                                        class="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                        style="background:#fff;border:1px solid var(--gray-200);color:var(--gray-600);"
                                        onmouseover="this.style.borderColor='#6366f1';this.style.color='#4f46e5'" onmouseout="this.style.borderColor='var(--gray-200)';this.style.color='var(--gray-600)'">
                                        <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                                        複製全部
                                    </button>
                                </div>
                                <div class="p-4" style="background:var(--gray-50);white-space:pre-wrap;color:var(--gray-700);height:20rem;overflow-y:auto;font-size:0.875rem;line-height:1.7;">
                                    {{ aiSocialState.result }}
                                </div>
                            </div>
                        </div>

                        <!-- Step 2: Campaign -->
                        <div v-if="aiMarketingState.step === 'campaign'" class="space-y-6">
                            <div class="border rounded-lg p-4" style="background:var(--brand-50,#eef2ff);">
                                <h4 style="font-weight:700;color:var(--brand-800,#3730a3);margin-bottom:0.5rem;">準備發送行銷郵件</h4>
                                <div style="font-size:0.875rem;color:var(--brand-600,#4f46e5);">
                                    <p><strong>主旨:</strong> {{ aiMarketingState.fullResult?.subject || '(無主旨)' }}</p>
                                    <p class="mt-1"><strong>內容:</strong> 已載入 HTML 內容</p>
                                </div>
                            </div>

                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">收件人來源</label>
                                <div class="flex gap-4 mb-4">
                                    <label class="flex items-center gap-2 cursor-pointer border rounded" style="padding:0.5rem 0.75rem;background:#fff;" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background='#fff'"
                                           :style="aiMarketingState.recipientSource === 'manual' ? 'border-color:var(--brand-500,#6366f1);box-shadow:0 0 0 1px var(--brand-500,#6366f1);' : ''">
                                        <input type="radio" v-model="aiMarketingState.recipientSource" value="manual" style="color:var(--brand-600,#4f46e5);">
                                        <span style="font-weight:700;color:var(--gray-700);">手動輸入</span>
                                    </label>
                                    <label class="flex items-center gap-2 cursor-pointer border rounded" style="padding:0.5rem 0.75rem;background:#fff;" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background='#fff'"
                                           :style="aiMarketingState.recipientSource === 'segment' ? 'border-color:var(--brand-500,#6366f1);box-shadow:0 0 0 1px var(--brand-500,#6366f1);' : ''">
                                        <input type="radio" v-model="aiMarketingState.recipientSource" value="segment" style="color:var(--brand-600,#4f46e5);">
                                        <span style="font-weight:700;color:var(--gray-700);">智慧分群 (Smart Segment)</span>
                                    </label>
                                </div>

                                <!-- Manual Input -->
                                <div v-if="aiMarketingState.recipientSource === 'manual'">
                                    <div class="flex items-center justify-between mb-2">
                                        <label style="font-size:0.875rem;font-weight:700;color:var(--gray-700);">收件人列表 (Email, 姓名)</label>
                                        <div class="flex items-center gap-2">
                                            <input ref="csvRecipientInput" type="file" accept=".csv,.txt" style="display:none;"
                                                @change="e => { const f = e.target.files?.[0]; if (!f) return; const r = new FileReader(); r.onload = ev => importCsvToRecipients(ev.target.result); r.readAsText(f, 'UTF-8'); e.target.value = ''; }">
                                            <button @click="$refs.csvRecipientInput.click()" class="btn btn-sm btn-outline" style="font-size:0.75rem;">
                                                📁 匯入 CSV
                                            </button>
                                            <button v-if="campaignForm.recipients" @click="campaignForm.recipients = ''" class="btn btn-sm btn-outline" style="font-size:0.75rem;color:var(--color-danger);">
                                                清空
                                            </button>
                                        </div>
                                    </div>
                                    <div class="relative">
                                        <textarea v-model="campaignForm.recipients" rows="10"
                                            class="input w-full p-3 resize-none font-mono text-sm"
                                            placeholder="user1@example.com, 王小明&#10;user2@example.com, 李大華&#10;...&#10;&#10;或直接匯入 CSV 檔案"></textarea>
                                        <div style="position:absolute;bottom:0.5rem;right:0.5rem;font-size:0.75rem;color:var(--gray-400);">
                                            {{ campaignForm.recipients ? (campaignForm.recipients.split('\n').filter(l => l.trim()).length + ' 位') : '一行一位收件人' }}
                                        </div>
                                    </div>
                                    <p style="font-size:0.75rem;color:var(--gray-500);margin-top:0.25rem;">CSV 欄位自動辨識（email/name 或 Email/姓名），支援有無標頭列。提示：{{name}} 自動替換為姓名；{{company}}、{{phone}} 從聯絡人資料填充。</p>
                                    <!-- 名單健康度 + 進階分群 + AI 變數預覽 -->
                                    <div class="mt-3 flex flex-wrap gap-2">
                                        <button @click="checkListHealth()" :disabled="listHealthLoading"
                                            class="btn btn-sm btn-outline" style="font-size:0.75rem;">
                                            {{ listHealthLoading ? '檢查中...' : '💊 名單健康度檢查' }}
                                        </button>
                                        <button @click="showAdvancedSegmentModal = true"
                                            class="btn btn-sm btn-outline" style="font-size:0.75rem;">
                                            🎯 進階分群匯入
                                        </button>
                                        <button @click="previewFillVariables" :disabled="fillVarsLoading"
                                            class="btn btn-sm btn-outline" style="font-size:0.75rem;">
                                            {{ fillVarsLoading ? '分析中...' : '🔍 AI 變數填充預覽' }}
                                        </button>
                                        <span v-if="fillVarsError" class="text-xs ml-2" style="color:var(--color-danger);">{{ fillVarsError }}</span>
                                    </div>
                                    <!-- 健康度結果 -->
                                    <div v-if="listHealth" class="mt-2 rounded-lg p-3" style="border:1px solid var(--border);background:var(--gray-50);">
                                        <div class="flex items-center gap-3 mb-2">
                                            <span class="text-xs font-bold" style="color:var(--gray-700);">💊 名單健康度</span>
                                            <span class="text-sm font-bold px-2 py-0.5 rounded-full"
                                                :style="listHealth.health_score >= 90 ? 'background:#d1fae5;color:#065f46;' : listHealth.health_score >= 70 ? 'background:#fef3c7;color:#92400e;' : 'background:#fee2e2;color:#991b1b;'">
                                                {{ listHealth.grade }} {{ listHealth.health_score }}%
                                            </span>
                                            <span class="text-xs" style="color:var(--gray-500);">
                                                有效 {{ listHealth.valid }} / 總計 {{ listHealth.total }}
                                            </span>
                                        </div>
                                        <div class="flex flex-wrap gap-2 text-xs">
                                            <span v-if="listHealth.invalid_format > 0" style="color:#dc2626;">格式錯誤 {{ listHealth.invalid_format }}</span>
                                            <span v-if="listHealth.unsubscribed > 0" style="color:#d97706;">已退訂 {{ listHealth.unsubscribed }}</span>
                                            <span v-if="listHealth.bounced > 0" style="color:#dc2626;">退信 {{ listHealth.bounced }}</span>
                                            <span v-if="listHealth.inactive_180d > 0" style="color:#6b7280;">半年無互動 {{ listHealth.inactive_180d }}</span>
                                            <span v-if="listHealth.valid === listHealth.total" style="color:#059669;">✓ 全部有效</span>
                                        </div>
                                    </div>
                                    <div v-if="fillVarsResult && fillVarsResult.variable_names?.length" class="mt-3 rounded-lg overflow-hidden" style="border:1px solid var(--border);">
                                        <div class="px-3 py-2 text-xs font-bold" style="background:var(--gray-50);border-bottom:1px solid var(--border);color:var(--gray-700);">
                                            📊 變數填充預覽（偵測到 {{ fillVarsResult.variable_names.join('、') }}）
                                        </div>
                                        <div style="max-height:200px;overflow-y:auto;">
                                            <table style="width:100%;font-size:0.75rem;border-collapse:collapse;">
                                                <thead>
                                                    <tr style="background:var(--gray-50);">
                                                        <th class="px-2 py-1 text-left" style="border-bottom:1px solid var(--border);color:var(--gray-600);">Email</th>
                                                        <th v-for="v in fillVarsResult.variable_names" :key="v" class="px-2 py-1 text-left" style="border-bottom:1px solid var(--border);color:var(--gray-600);">&#123;&#123;{{ v }}&#125;&#125;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="p in (fillVarsResult.preview || [])" :key="p.email" style="border-bottom:1px solid var(--border);">
                                                        <td class="px-2 py-1" style="color:var(--gray-700);">{{ p.email }}</td>
                                                        <td v-for="v in fillVarsResult.variable_names" :key="v" class="px-2 py-1">
                                                            <span v-if="p.variables?.[v]" style="color:var(--color-success);">{{ p.variables[v] }}</span>
                                                            <span v-else style="color:var(--gray-400);">（空）</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-else-if="fillVarsResult && !fillVarsResult.variable_names?.length" class="mt-2 text-xs" style="color:var(--gray-500);">模板中未找到需填充的自訂變數。</div>
                                </div>

                                <!-- Smart Segment Selection -->
                                <div v-else class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div v-for="(seg, idx) in safeArr(aiMarketingState.segments)" :key="keyById(seg, 'seg', idx)" 
                                         class="input -lg p-4 cursor-pointer hover:shadow-md transition relative overflow-hidden"
                                         :style="aiMarketingState.selectedSegment === seg.id ? 'border-color:var(--brand-500,#6366f1);background:var(--brand-50,#eef2ff);' : 'border-color:var(--gray-200);background:var(--surface);'"
                                         @click="selectSegment(seg)">
                                        <div class="flex justify-between items-start mb-2">
                                            <div style="font-weight:700;color:var(--gray-800);font-size:1.125rem;">{{ seg.name }}</div>
                                            <div class="badge badge-default">{{ seg.contact_count }} 人</div>
                                        </div>
                                        <div style="font-size:0.875rem;color:var(--gray-600);">{{ seg.description }}</div>
                                        <div v-if="aiMarketingState.selectedSegment === seg.id" class="absolute bottom-0 right-0 p-2">
                                            <span class="text-xl" style="color:var(--brand-500,#6366f1);">✓</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- A/B Test Subject -->
                            <div class="border rounded-lg p-4" style="background:var(--surface);">
                                <div class="flex items-center justify-between gap-2 mb-2">
                                    <div class="flex items-center gap-2">
                                        <span class="text-sm font-bold" style="color:var(--gray-700);">🧪 A/B 測試主旨</span>
                                        <span class="text-xs" style="color:var(--gray-400);">將收件人各半發送不同主旨，比較開啟率</span>
                                    </div>
                                    <label class="flex items-center gap-2 cursor-pointer">
                                        <input type="checkbox" v-model="aiMarketingState.abTestEnabled" class="w-4 h-4">
                                        <span class="text-sm" style="color:var(--gray-600);">啟用</span>
                                    </label>
                                </div>
                                <div v-if="aiMarketingState.abTestEnabled" class="space-y-2 mt-3">
                                    <div class="flex items-center gap-2">
                                        <span class="text-xs font-bold w-12 text-center rounded px-1 py-0.5" style="background:var(--brand-100,#e0e7ff);color:var(--brand-700,#4338ca);">A 組</span>
                                        <input :value="aiMarketingState.fullResult?.subject || '行銷郵件'" readonly class="input flex-1 text-sm" style="background:var(--gray-50);color:var(--gray-500);" placeholder="主旨 A（目前生成的主旨）">
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <span class="text-xs font-bold w-12 text-center rounded px-1 py-0.5" style="background:#fff7ed;color:#c2410c;">B 組</span>
                                        <input v-model="aiMarketingState.subjectB" class="input flex-1 text-sm" placeholder="輸入主旨 B（替代版本）">
                                        <button @click="generateAbSubject" :disabled="aiMarketingState.abSubjectGenerating"
                                            class="btn btn-sm flex-shrink-0"
                                            style="background:linear-gradient(135deg,#7c3aed,#4f46e5);color:#fff;border:none;white-space:nowrap;">
                                            {{ aiMarketingState.abSubjectGenerating ? '產生中...' : '🤖 AI 產生' }}
                                        </button>
                                    </div>
                                    <div v-if="aiMarketingState.abSubjectError" class="text-xs" style="color:var(--color-danger);">{{ aiMarketingState.abSubjectError }}</div>
                                </div>
                            </div>

                            <!-- Schedule Send -->
                            <div class="border rounded-lg p-4" style="background:var(--surface);">
                                <div class="flex items-center justify-between gap-2">
                                    <div class="flex items-center gap-2">
                                        <span class="text-sm font-bold" style="color:var(--gray-700);">🕐 排程發送</span>
                                        <span class="text-xs" style="color:var(--gray-400);">設定未來的發送時間</span>
                                    </div>
                                    <label class="flex items-center gap-2 cursor-pointer">
                                        <input type="checkbox" v-model="aiMarketingState.scheduleEnabled" class="w-4 h-4">
                                        <span class="text-sm" style="color:var(--gray-600);">啟用</span>
                                    </label>
                                </div>
                                <div v-if="aiMarketingState.scheduleEnabled" class="mt-3">
                                    <input v-model="aiMarketingState.scheduledAt" type="datetime-local"
                                        class="input w-full md:w-64"
                                        :min="new Date().toISOString().slice(0,16)">
                                    <p v-if="aiMarketingState.scheduledAt" class="text-xs mt-1" style="color:var(--gray-500);">
                                        將於 {{ new Date(aiMarketingState.scheduledAt).toLocaleString() }} 發送
                                    </p>
                                    <!-- 寄件時間建議 -->
                                    <div class="mt-3">
                                        <button @click="fetchSendTimeStats()" :disabled="sendTimeLoading" class="btn btn-xs btn-outline" style="font-size:0.72rem;">
                                            {{ sendTimeLoading ? '分析中...' : '📊 最佳發送時段建議' }}
                                        </button>
                                        <div v-if="sendTimeStats" class="mt-2 rounded-lg p-3" style="background:#f0fdf4;border:1px solid #bbf7d0;">
                                            <div class="text-xs font-bold mb-1" style="color:#166534;">{{ sendTimeStats.recommendation }}</div>
                                            <div class="flex gap-2 flex-wrap">
                                                <span v-for="t in (sendTimeStats.top_hours || [])" :key="t.hour"
                                                    class="text-xs px-2 py-0.5 rounded-full font-semibold"
                                                    style="background:#d1fae5;color:#065f46;">
                                                    {{ t.label }} ({{ t.pct }}%)
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Webhook 設定 -->
                            <div class="border rounded-lg p-4" style="background:var(--surface);">
                                <div class="flex items-center justify-between mb-3">
                                    <div class="flex items-center gap-2">
                                        <span class="text-sm font-bold" style="color:var(--gray-700);">🔔 Webhook 推播</span>
                                        <span class="text-xs" style="color:var(--gray-400);">活動完成時通知外部系統</span>
                                    </div>
                                    <button @click="fetchWebhookConfig()" class="btn btn-xs btn-outline">載入設定</button>
                                </div>
                                <div class="space-y-2">
                                    <div class="flex items-center gap-2">
                                        <input v-model="webhookConfig.webhook_url" type="url" class="input flex-1"
                                            placeholder="https://hooks.slack.com/..." style="font-size:0.8rem;" />
                                        <label class="flex items-center gap-1 text-xs cursor-pointer">
                                            <input type="checkbox" v-model="webhookConfig.enabled" class="w-3.5 h-3.5">
                                            啟用
                                        </label>
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <select v-model="webhookConfig.events" class="input" style="font-size:0.8rem;flex:1;">
                                            <option value="completed">僅完成</option>
                                            <option value="completed,failed">完成 + 失敗</option>
                                            <option value="failed">僅失敗</option>
                                        </select>
                                        <button @click="saveWebhookConfig()" :disabled="webhookSaving || !webhookConfig.webhook_url"
                                            class="btn btn-sm" style="background:#7c3aed;color:#fff;border:none;">
                                            {{ webhookSaving ? '儲存中...' : '💾 儲存' }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="campaignProgress && campaignProgress.campaign_id" class="rounded-xl overflow-hidden" style="border:1px solid var(--border);">
                                <!-- Progress header -->
                                <div class="flex items-center justify-between px-4 py-3" style="background:var(--gray-50);border-bottom:1px solid var(--border);">
                                    <div class="flex items-center gap-2">
                                        <div class="w-2 h-2 rounded-full" :style="campaignProgress.progress?.finished ? 'background:#10b981' : 'background:#f59e0b;animation:pulse 1.5s infinite'"></div>
                                        <span class="font-semibold text-sm" style="color:var(--gray-800);">寄送進度追蹤</span>
                                        <span class="text-xs px-2 py-0.5 rounded-full" style="background:var(--gray-200);color:var(--gray-600);">
                                            {{ campaignProgress.status || 'running' }}
                                        </span>
                                    </div>
                                    <div class="flex items-center gap-1.5">
                                        <button @click="openCampaignDetails(campaignProgress.campaign_id)"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:#eef2ff;color:#4f46e5;border:none;"
                                            onmouseover="this.style.background='#e0e7ff'" onmouseout="this.style.background='#eef2ff'">
                                            📊 報表
                                        </button>
                                        <button @click="openCampaignList()"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:var(--gray-100);color:var(--gray-700);border:none;"
                                            onmouseover="this.style.background='var(--gray-200)'" onmouseout="this.style.background='var(--gray-100)'">
                                            📋 列表
                                        </button>
                                        <button @click="retryCampaignFailedRecipients(campaignProgress.campaign_id)"
                                            :disabled="campaignOps.retryLoading"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:#fff7ed;color:#c2410c;border:none;"
                                            onmouseover="if(!this.disabled) this.style.background='#ffedd5'" onmouseout="this.style.background='#fff7ed'">
                                            🔄 重試失敗
                                        </button>
                                        <button @click="downloadCampaignFailuresCsv(campaignProgress.campaign_id)"
                                            :disabled="campaignOps.downloadLoading"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:var(--gray-100);color:var(--gray-700);border:none;"
                                            onmouseover="if(!this.disabled) this.style.background='var(--gray-200)'" onmouseout="this.style.background='var(--gray-100)'">
                                            ⬇ 失敗名單
                                        </button>
                                        <button @click="downloadCampaignRecipientsCsv(campaignProgress.campaign_id, 'all')"
                                            :disabled="campaignOps.downloadLoading"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:var(--gray-100);color:var(--gray-700);border:none;"
                                            onmouseover="if(!this.disabled) this.style.background='var(--gray-200)'" onmouseout="this.style.background='var(--gray-100)'">
                                            ⬇ 收件人
                                        </button>
                                        <button @click="downloadCampaignReportPdf(campaignProgress.campaign_id)"
                                            :disabled="campaignPdfLoading"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:#ede9fe;color:#5b21b6;border:none;"
                                            onmouseover="if(!this.disabled) this.style.background='#ddd6fe'" onmouseout="this.style.background='#ede9fe'">
                                            <span v-if="campaignPdfLoading" class="spinner spinner-sm"></span>
                                            📄 PDF 報告
                                        </button>
                                        <button @click="fetchCampaignProgress(campaignProgress.campaign_id)"
                                            :disabled="campaignProgress.loading"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:#f0fdf4;color:#166534;border:none;"
                                            onmouseover="if(!this.disabled) this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                                            {{ campaignProgress.loading ? '更新中…' : '↻ 刷新' }}
                                        </button>
                                        <button @click="stopCampaignProgressPolling"
                                            class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium transition"
                                            style="background:var(--gray-100);color:var(--gray-500);border:none;"
                                            onmouseover="this.style.background='var(--gray-200)'" onmouseout="this.style.background='var(--gray-100)'">
                                            ✕ 停止追蹤
                                        </button>
                                    </div>
                                </div>
                                <div class="p-4">
                                    <div class="h-2 rounded-full overflow-hidden" style="background:var(--gray-100);">
                                        <div class="h-2 rounded-full transition-all" style="background:linear-gradient(to right,#10b981,#34d399);" :style="{ width: (campaignProgress.progress?.percent || 0) + '%' }"></div>
                                    </div>
                                    <div class="mt-2 text-xs flex flex-wrap gap-3" style="color:var(--gray-600);">
                                        <span class="font-semibold">{{ campaignProgress.progress?.percent || 0 }}%</span>
                                        <span>已處理 {{ campaignProgress.progress?.processed || 0 }}</span>
                                        <span>待處理 {{ campaignProgress.counts?.pending || 0 }}</span>
                                        <span style="color:#166534;">✓ 成功 {{ campaignProgress.counts?.sent || 0 }}</span>
                                        <span style="color:#dc2626;">✗ 失敗 {{ campaignProgress.counts?.failed || 0 }}</span>
                                        <span v-if="(campaignProgress.counts?.moved || 0) > 0">移轉 {{ campaignProgress.counts?.moved || 0 }}</span>
                                        <span v-if="(campaignProgress.tracking?.open_count || 0) > 0" style="color:#7c3aed;">
                                            📬 開信 {{ campaignProgress.tracking.open_count }}（{{ campaignProgress.tracking.open_rate }}%）
                                        </span>
                                        <span v-if="(campaignProgress.tracking?.click_count || 0) > 0" style="color:#0369a1;">
                                            🖱 點擊 {{ campaignProgress.tracking.click_count }}（{{ campaignProgress.tracking.click_rate }}%）
                                        </span>
                                    </div>
                                    <div v-if="campaignProgress.progress?.finished" class="mt-2 flex items-center gap-1.5 text-sm font-semibold" style="color:#166534;">
                                        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                                        已完成寄送處理
                                    </div>
                                    <div v-if="campaignProgress.error" class="mt-2 text-sm" style="color:var(--color-danger);">
                                        載入進度失敗：{{ campaignProgress.error }}
                                    </div>

                                    <div v-if="safeArr(campaignProgress.failures).length" class="mt-3 pt-3 border-t">
                                        <div class="text-xs font-semibold mb-2" style="color:var(--gray-700);">最近失敗（最多 20 筆）</div>
                                        <div class="space-y-1.5 max-h-36 overflow-y-auto custom-scrollbar">
                                            <div v-for="(f, idx) in safeArr(campaignProgress.failures)" :key="keyById(f, 'fail', idx)"
                                                class="rounded-lg px-3 py-2" style="background:#fff5f5;border:1px solid #fecaca;font-size:0.75rem;">
                                                <div class="font-mono font-semibold" style="color:#991b1b;">{{ f.email }}<span v-if="f.name" class="font-normal">（{{ f.name }}）</span></div>
                                                <div class="mt-0.5" style="color:var(--color-danger);word-break:break-word;">{{ f.error_message || 'send_failed' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 建立分群 — 發送完成後顯示 -->
                            <div v-if="campaignProgress && campaignProgress.campaign_id && campaignProgress.progress?.finished"
                                class="border rounded-lg p-4 mt-4" style="background:var(--surface);">
                                <div class="flex items-center gap-2 mb-3">
                                    <span class="text-sm font-bold" style="color:var(--gray-700);">👥 從成功收件人建立分群</span>
                                    <span class="text-xs" style="color:var(--gray-500);">（{{ campaignProgress.counts?.sent || 0 }} 位成功收件人）</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <input v-model="campaignCreateSegmentName" type="text"
                                        class="input flex-1"
                                        placeholder="輸入新分群名稱，例如：2026-04 EDM 成功名單"
                                        :disabled="campaignCreateSegmentLoading" />
                                    <button @click="createSegmentFromCampaign(campaignProgress.campaign_id, campaignCreateSegmentName)"
                                        class="btn btn-primary flex items-center gap-1"
                                        :disabled="campaignCreateSegmentLoading || !campaignCreateSegmentName.trim()">
                                        <span v-if="campaignCreateSegmentLoading" class="spinner spinner-sm"></span>
                                        {{ campaignCreateSegmentLoading ? '建立中...' : '建立分群' }}
                                    </button>
                                </div>
                            </div>

                            <!-- 自動再行銷 -->
                            <div v-if="campaignProgress && campaignProgress.campaign_id && campaignProgress.progress?.finished"
                                class="border rounded-lg p-4 mt-4" style="background:#fefce8;border-color:#fde68a;">
                                <div class="flex items-center gap-2 mb-3">
                                    <span class="text-sm font-bold" style="color:#92400e;">🔄 自動再行銷</span>
                                    <span class="text-xs" style="color:#b45309;">對未開信者寄送不同主旨版本</span>
                                </div>
                                <div v-if="remarketResult" class="mb-3 rounded-lg px-3 py-2 text-xs" style="background:#d1fae5;color:#065f46;">
                                    ✓ 再行銷活動已建立 #{{ remarketResult.campaign_id }}，
                                    {{ remarketResult.recipient_count }} 位收件人
                                    <span v-if="remarketResult.scheduled_at">，排程：{{ new Date(remarketResult.scheduled_at).toLocaleString() }}</span>
                                </div>
                                <div class="space-y-2">
                                    <input v-model="remarketForm.subject" type="text" class="input w-full"
                                        placeholder="新主旨（例如：您可能錯過了這份優惠…）" style="font-size:0.875rem;" />
                                    <div class="flex items-center gap-2">
                                        <label class="text-xs font-medium" style="color:var(--gray-700);white-space:nowrap;">延遲天數</label>
                                        <select v-model="remarketForm.delay_days" class="input" style="width:120px;font-size:0.875rem;">
                                            <option :value="0">立即發送</option>
                                            <option :value="1">1 天後</option>
                                            <option :value="2">2 天後</option>
                                            <option :value="3">3 天後</option>
                                            <option :value="5">5 天後</option>
                                            <option :value="7">7 天後</option>
                                        </select>
                                        <button @click="submitRemarket(campaignProgress.campaign_id)"
                                            :disabled="remarketLoading || !remarketForm.subject.trim()"
                                            class="btn btn-sm flex items-center gap-1"
                                            style="background:#f59e0b;color:#fff;border:none;">
                                            <span v-if="remarketLoading" class="spinner spinner-sm"></span>
                                            {{ remarketLoading ? '建立中...' : '🚀 啟動再行銷' }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- IP 預熱排程 -->
                            <div class="border rounded-lg p-4 mt-4" style="background:var(--surface);">
                                <div class="flex items-center justify-between mb-3">
                                    <div class="flex items-center gap-2">
                                        <span class="text-sm font-bold" style="color:var(--gray-700);">🌡️ IP 預熱排程</span>
                                        <span class="text-xs" style="color:var(--gray-400);">逐日提升發送量，建立信譽</span>
                                    </div>
                                    <button @click="fetchWarmupStatus()" :disabled="warmupLoading"
                                        class="btn btn-xs btn-outline">
                                        {{ warmupLoading ? '載入中...' : '查看狀態' }}
                                    </button>
                                </div>
                                <div v-if="warmupStatus">
                                    <div v-if="!warmupStatus.enabled" class="space-y-2">
                                        <p class="text-xs" style="color:var(--gray-500);">目前未啟用 IP 預熱。啟用後系統將依預熱曲線控制每日最大發送量。</p>
                                        <button @click="startWarmup(currentUser?.email)"
                                            class="btn btn-sm" style="background:#7c3aed;color:#fff;border:none;">
                                            ▶ 從今日開始預熱
                                        </button>
                                    </div>
                                    <div v-else class="space-y-3">
                                        <div class="flex flex-wrap gap-3 text-xs">
                                            <span class="px-2 py-1 rounded-full font-bold" style="background:#ede9fe;color:#5b21b6;">
                                                第 {{ warmupStatus.day_number }} 天
                                            </span>
                                            <span style="color:var(--gray-700);">今日上限：<strong>{{ warmupStatus.daily_limit?.toLocaleString() }}</strong> 封</span>
                                            <span style="color:#166534;">已寄：{{ warmupStatus.sent_today?.toLocaleString() }}</span>
                                            <span style="color:#b45309;">剩餘：{{ warmupStatus.remaining?.toLocaleString() }}</span>
                                        </div>
                                        <div class="h-2 rounded-full overflow-hidden" style="background:var(--gray-100);">
                                            <div class="h-2 rounded-full" style="background:linear-gradient(to right,#7c3aed,#a78bfa);"
                                                :style="{ width: Math.min(100, ((warmupStatus.sent_today || 0) / (warmupStatus.daily_limit || 1)) * 100) + '%' }"></div>
                                        </div>
                                        <div class="overflow-x-auto">
                                            <table style="font-size:0.7rem;width:100%;border-collapse:collapse;">
                                                <thead>
                                                    <tr style="background:var(--gray-50);">
                                                        <th v-for="s in (warmupStatus.schedule || [])" :key="s.day"
                                                            class="px-2 py-1 text-center"
                                                            :style="s.day === warmupStatus.day_number ? 'background:#ede9fe;color:#5b21b6;font-weight:700;' : 'color:var(--gray-500);'">
                                                            D{{ s.day }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td v-for="s in (warmupStatus.schedule || [])" :key="s.day"
                                                            class="px-2 py-1 text-center"
                                                            :style="s.day === warmupStatus.day_number ? 'background:#ede9fe;color:#5b21b6;font-weight:700;' : 'color:var(--gray-600);'">
                                                            {{ s.limit >= 10000 ? '10K' : s.limit >= 1000 ? (s.limit/1000).toFixed(1)+'K' : s.limit }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <button @click="disableWarmup(currentUser?.email)"
                                            class="btn btn-xs btn-outline" style="color:var(--color-danger);">
                                            停用預熱
                                        </button>
                                    </div>
                                </div>
                                <div v-else class="text-xs" style="color:var(--gray-400);">點擊「查看狀態」載入預熱資訊</div>
                            </div>
                        </div>

                        <!-- Step: Marketing Journey -->
                        <div v-if="aiMarketingState.step === 'journey'" class="space-y-6 animate-fade-in">
                            <div class="flex justify-between items-center mb-4">
                                <h3 style="font-size:1.25rem;font-weight:700;color:var(--gray-800);">行銷旅程管理</h3>
                                <div class="flex gap-2">
                                    <button @click="showUnsubscribeModal = true; fetchUnsubscribeList()"
                                        class="btn btn-secondary btn-sm flex items-center gap-1">
                                        🚫 退訂管理
                                    </button>
                                    <button @click="showSubscribeFormModal = true"
                                        class="btn btn-secondary btn-sm flex items-center gap-1">
                                        📋 訂閱表單
                                    </button>
                                    <button @click="openJourneyEditor()"
                                        class="btn btn-primary transition flex items-center gap-2">
                                        <span>➕</span> 新增旅程
                                    </button>
                                    <button @click="createDemoJourney"
                                        class="btn btn-primary transition flex items-center gap-2">
                                        <span>➕</span> 建立示範旅程
                                    </button>
                                </div>
                            </div>

                            <!-- Journey Overall Dashboard -->
                            <div v-if="safeArr(aiMarketingState.journeys).length > 0" class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-2">
                                <div class="rounded-lg p-3 text-center" style="background:var(--brand-50,#eef2ff);border:1px solid var(--brand-200,#c7d2fe);">
                                    <div class="text-2xl font-bold" style="color:var(--brand-700,#4338ca);">{{ safeArr(aiMarketingState.journeys).length }}</div>
                                    <div class="text-xs mt-0.5" style="color:var(--brand-600,#4f46e5);">旅程總數</div>
                                </div>
                                <div class="rounded-lg p-3 text-center" style="background:#f0fdf4;border:1px solid #bbf7d0;">
                                    <div class="text-2xl font-bold" style="color:var(--color-success);">{{ safeArr(aiMarketingState.journeys).filter(j => j.status === 'active').length }}</div>
                                    <div class="text-xs mt-0.5" style="color:var(--color-success);">啟用中</div>
                                </div>
                                <div class="rounded-lg p-3 text-center" style="background:#f5f3ff;border:1px solid #ddd6fe;">
                                    <div class="text-2xl font-bold" style="color:#7c3aed;">
                                        {{ safeArr(aiMarketingState.journeys).reduce((s,j) => s + (j._stats?.enrollments_total || 0), 0) }}
                                    </div>
                                    <div class="text-xs mt-0.5" style="color:#7c3aed;">總參與人次</div>
                                </div>
                                <div class="rounded-lg p-3 text-center" style="background:var(--color-warning-bg,#fff7ed);border:1px solid var(--color-warning-border,#fed7aa);">
                                    <div class="text-2xl font-bold" style="color:var(--color-warning-dark,#b45309);">
                                        {{ (() => { const js = safeArr(aiMarketingState.journeys).filter(j => j._stats?.enrollments_total > 0); return js.length ? Math.round(js.reduce((s,j) => s + (j._stats?.open_rate_step1 || 0), 0) / js.length * 100) + '%' : '-'; })() }}
                                    </div>
                                    <div class="text-xs mt-0.5" style="color:var(--color-warning,#d97706);">平均開啟率</div>
                                </div>
                            </div>

                            <div v-if="safeArr(aiMarketingState.journeys).length === 0" class="text-center py-12 rounded-lg" style="background:var(--gray-50);border:2px dashed var(--gray-300);">
                                <div class="text-4xl mb-3">🗺️</div>
                                <h4 style="font-size:1.125rem;font-weight:500;color:var(--gray-600);">尚無行銷旅程</h4>
                                <p class="mb-4" style="color:var(--gray-500);">建立您的第一個自動化行銷旅程</p>
                            </div>

                            <div v-else class="grid grid-cols-1 gap-4">
                                <div v-for="(journey, idx) in safeArr(aiMarketingState.journeys)" :key="keyById(journey, 'journey', idx)"
                                    class="border rounded-lg p-4 hover:shadow-md transition" style="background:var(--surface);border-color:var(--border);">
                                    <div class="flex justify-between items-start">
                                        <div>
                                            <div class="flex items-center gap-2 mb-1">
                                                <h4 style="font-weight:700;font-size:1.125rem;color:var(--gray-800);">{{ journey.name }}</h4>
                                                <span class="px-2 py-0.5 rounded text-xs font-medium"
                                                    :class="journey.status === 'active' ? 'badge-success' : 'badge-default'">
                                                    {{ journey.status === 'active' ? '啟用中' : '已暫停' }}
                                                </span>
                                            </div>
                                            <p style="color:var(--gray-600);font-size:0.875rem;margin-bottom:0.75rem;">{{ journey.description || '無描述' }}</p>
                                            <div class="flex gap-4" style="font-size:0.75rem;color:var(--gray-500);">
                                                <span class="flex items-center gap-1">👤 擁有者: {{ journey.sender }}</span>
                                                <span class="flex items-center gap-1">📅 建立於: {{ new Date(journey.created_at).toLocaleDateString() }}</span>
                                            </div>
                                        </div>
                                        <div class="flex gap-2">
                                            <button @click="toggleJourneyStatus(journey)" class="btn btn-ghost btn-sm" :title="journey.status === 'active' ? '暫停' : '啟用'">
                                                {{ journey.status === 'active' ? '⏸️' : '▶️' }}
                                            </button>
                                            <button @click="openJourneyEditor(journey)" class="btn btn-ghost btn-sm" style="color:var(--brand-600,#4f46e5);" title="編輯">✏️</button>
                                            <button @click="openJourneyEnrollments(journey)" class="btn btn-ghost btn-sm" style="color:var(--brand-600,#4f46e5);" title="參與者">👥</button>
                                            <button @click="deleteJourney(journey)" class="btn btn-ghost btn-sm" style="color:var(--color-danger);" title="刪除">🗑️</button>
                                        </div>
                                    </div>
                                    
                                    <!-- Simple Stats Preview -->
                                    <div class="mt-4 pt-3 border-t grid grid-cols-3 gap-2 text-center">
                                        <div class="rounded p-2" style="background:var(--brand-50,#eef2ff);">
                                            <div style="font-size:1.125rem;font-weight:700;color:var(--brand-700,#4338ca);">{{ journey._stats ? journey._stats.enrollments_total : '-' }}</div>
                                            <div style="font-size:0.75rem;color:var(--brand-600,#4f46e5);">參與人數</div>
                                        </div>
                                        <div class="rounded p-2" style="background:#f5f3ff;">
                                            <div style="font-size:1.125rem;font-weight:700;color:#7c3aed;">{{ journey._stats ? Math.round((journey._stats.open_rate_step1 || 0) * 100) + '%' : '-' }}</div>
                                            <div style="font-size:0.75rem;color:#7c3aed;">開啟率</div>
                                        </div>
                                        <div class="rounded p-2" style="background:#f0fdf4;">
                                            <div style="font-size:1.125rem;font-weight:700;color:var(--color-success);">{{ journey._stats ? Math.round((journey._stats.completed_rate || 0) * 100) + '%' : '-' }}</div>
                                            <div style="font-size:0.75rem;color:var(--color-success);">完成率</div>
                                        </div>
                                    </div>

                                    <div class="mt-3 flex flex-col md:flex-row gap-2 md:items-center">
                                        <select v-model="journey._selectedSegment" class="input flex-1 text-sm">
                                            <option value="">選擇分眾（加入旅程）</option>
                                            <option v-for="(seg, idx) in safeArr(aiMarketingState.segments)" :key="keyById(seg, 'segopt', idx)" :value="seg.id">{{ seg.name }}</option>
                                        </select>
                                        <button @click="enrollJourneyFromSegment(journey)"
                                            class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition whitespace-nowrap"
                                            style="background:#eef2ff;color:#4f46e5;border:none;"
                                            onmouseover="this.style.background='#e0e7ff'" onmouseout="this.style.background='#eef2ff'">
                                            👥 加入分眾
                                        </button>
                                        <button @click="runJourneyNow(journey)"
                                            class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition whitespace-nowrap"
                                            style="background:#f0fdf4;color:#166534;border:none;"
                                            onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                                            ▶ 立即執行
                                        </button>
                                        <button @click="openJourneyFunnel(journey)"
                                            class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition whitespace-nowrap"
                                            style="background:#f5f3ff;color:#6d28d9;border:none;"
                                            onmouseover="this.style.background='#ede9fe'" onmouseout="this.style.background='#f5f3ff'">
                                            📊 查看漏斗
                                        </button>
                                        <button @click="fetchJourneyStats()"
                                            class="flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm font-medium transition whitespace-nowrap"
                                            style="background:var(--gray-100);color:var(--gray-600);border:none;"
                                            onmouseover="this.style.background='var(--gray-200)'" onmouseout="this.style.background='var(--gray-100)'">
                                            ↻ 刷新統計
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="modal-footer shrink-0" style="gap:0.5rem;flex-wrap:wrap;">
                        <button @click="showAiMarketingModal = false"
                            class="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition"
                            style="background:var(--gray-100);color:var(--gray-600);border:none;"
                            onmouseover="this.style.background='var(--gray-200)'" onmouseout="this.style.background='var(--gray-100)'">
                            關閉
                        </button>

                        <template v-if="aiMarketingState.step === 'generate'">
                            <!-- Secondary actions (only when result exists) -->
                            <template v-if="aiMarketingState.result">
                                <button @click="useMarketingContent"
                                    class="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition"
                                    style="background:#f0fdf4;color:#166534;border:1px solid #bbf7d0;"
                                    onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                                    <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                                    帶入郵件撰寫
                                </button>
                                <button @click="aiMarketingState.step = 'campaign'"
                                    class="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition"
                                    style="background:#f5f3ff;color:#6d28d9;border:1px solid #ddd6fe;"
                                    onmouseover="this.style.background='#ede9fe'" onmouseout="this.style.background='#f5f3ff'">
                                    <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>
                                    建立行銷活動
                                </button>
                            </template>
                            <!-- Primary action -->
                            <button @click="generateMarketingContent"
                                class="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-bold transition ml-auto"
                                :style="aiMarketingState.loading
                                    ? 'background:#fda4af;color:#fff;cursor:not-allowed;border:none;'
                                    : 'background:linear-gradient(135deg,#ec4899,#f43f5e);color:#fff;border:none;box-shadow:0 2px 8px rgba(236,72,153,0.35);'"
                                :disabled="aiMarketingState.loading"
                                onmouseover="if(!this.disabled) this.style.filter='brightness(1.08)'" onmouseout="this.style.filter=''">
                                <span v-if="aiMarketingState.loading" class="spinner spinner-sm" style="border-color:rgba(255,255,255,0.3);border-top-color:#fff;"></span>
                                <svg v-else width="15" height="15" fill="none" stroke="#fff" stroke-width="2.5" viewBox="0 0 24 24"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
                                {{ aiMarketingState.loading ? 'AI 生成中…' : '生成 EDM' }}
                            </button>
                        </template>

                        <template v-if="aiMarketingState.step === 'social'">
                            <button @click="generateSocialContent"
                                class="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-bold transition ml-auto"
                                :style="aiSocialState.loading
                                    ? 'background:#93c5fd;color:#fff;cursor:not-allowed;border:none;'
                                    : 'background:linear-gradient(135deg,#3b82f6,#6366f1);color:#fff;border:none;box-shadow:0 2px 8px rgba(99,102,241,0.35);'"
                                :disabled="aiSocialState.loading"
                                onmouseover="if(!this.disabled) this.style.filter='brightness(1.08)'" onmouseout="this.style.filter=''">
                                <span v-if="aiSocialState.loading" class="spinner spinner-sm" style="border-color:rgba(255,255,255,0.3);border-top-color:#fff;"></span>
                                <svg v-else width="15" height="15" fill="none" stroke="#fff" stroke-width="2.5" viewBox="0 0 24 24"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
                                {{ aiSocialState.loading ? 'AI 生成中…' : '生成社群貼文' }}
                            </button>
                        </template>


                        <template v-if="aiMarketingState.step === 'campaign'">
                            <button @click="aiMarketingState.step = 'generate'"
                                class="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition"
                                style="background:var(--gray-100);color:var(--gray-600);border:none;"
                                onmouseover="this.style.background='var(--gray-200)'" onmouseout="this.style.background='var(--gray-100)'">
                                <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
                                上一步
                            </button>
                            <button @click="showCampaignPreviewModal = true"
                                :disabled="!aiMarketingState.result && !aiMarketingState.fullResult"
                                class="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition"
                                style="background:#f0f9ff;color:#0369a1;border:1px solid #bae6fd;"
                                onmouseover="if(!this.disabled) this.style.background='#e0f2fe'" onmouseout="this.style.background='#f0f9ff'">
                                <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                預覽排版
                            </button>
                            <button @click="sendTestCampaign"
                                :disabled="campaignTestSending || (!aiMarketingState.result && !aiMarketingState.fullResult)"
                                class="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition"
                                style="background:#fffbeb;color:#92400e;border:1px solid #fde68a;"
                                onmouseover="if(!this.disabled) this.style.background='#fef3c7'" onmouseout="this.style.background='#fffbeb'">
                                <span v-if="campaignTestSending" class="spinner spinner-sm"></span>
                                <svg v-else width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                                {{ campaignTestSending ? '寄送中…' : '測試寄送' }}
                            </button>
                            <button @click="sendCampaign"
                                :disabled="campaignSending"
                                class="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-bold transition ml-auto"
                                :style="campaignSending
                                    ? 'background:#6ee7b7;color:#fff;cursor:not-allowed;border:none;'
                                    : 'background:linear-gradient(135deg,#10b981,#059669);color:#fff;border:none;box-shadow:0 2px 8px rgba(16,185,129,0.35);'"
                                onmouseover="if(!this.disabled) this.style.filter='brightness(1.08)'" onmouseout="this.style.filter=''">
                                <span v-if="campaignSending" class="spinner spinner-sm" style="border-color:rgba(255,255,255,0.3);border-top-color:#fff;"></span>
                                <svg v-else width="15" height="15" fill="none" stroke="#fff" stroke-width="2.5" viewBox="0 0 24 24"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>
                                {{ campaignSending ? '發送中…' : '確認發送' }}
                            </button>
                        </template>
                    </div>
                </div>
            </div>

            <!-- Campaign Details Modal -->
            <div v-if="showCampaignDetailsModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-3xl">
                    <div
                        class="flex justify-between items-center p-4 border-b rounded-t-lg" style="background:linear-gradient(to right,#059669,#16a34a);color:#fff;">
                        <h3 class="font-bold text-lg flex items-center gap-2">
                            <span>📊</span> 行銷活動報表
                            <span class="text-xs opacity-90" v-if="campaignDetails?.data?.campaign?.id">#{{ campaignDetails.data.campaign.id }}</span>
                        </h3>
                        <button @click="closeCampaignDetails"
                            class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>

                    <div class="p-6 overflow-y-auto space-y-4">
                        <div v-if="campaignDetails.loading" class="flex items-center justify-center py-10">
                            <span class="spinner spinner-lg"></span>
                        </div>
                        <div v-else-if="campaignDetails.error" style="color:var(--color-danger);">
                            載入失敗：{{ campaignDetails.error }}
                        </div>
                        <div v-else-if="campaignDetails.data" class="space-y-4">
                            <div class="border rounded p-4" style="background:#ecfdf5;border-color:#d1fae5;">
                                <div style="font-weight:700;color:var(--color-success);">{{ campaignDetails.data.campaign?.subject || '(無主旨)' }}</div>
                                <div style="font-size:0.75rem;color:var(--color-success);margin-top:0.25rem;">
                                    建立時間：{{ campaignDetails.data.campaign?.created_at ? new Date(campaignDetails.data.campaign.created_at).toLocaleString() : '—' }}
                                    ｜狀態：{{ campaignDetails.data.campaign?.status || '—' }}
                                    ｜總收件人：{{ campaignDetails.data.campaign?.total_recipients || 0 }}
                                </div>
                            </div>

                            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <div class="card p-3">
                                    <div style="font-size:0.75rem;color:var(--gray-500);">開信率</div>
                                    <div style="font-size:1.5rem;font-weight:700;color:var(--gray-900);">{{ campaignDetails.data.stats?.open_rate || 0 }}%</div>
                                    <div style="font-size:0.75rem;color:var(--gray-600);margin-top:0.25rem;">Unique opens：{{ campaignDetails.data.stats?.unique_opens || 0 }}</div>
                                </div>
                                <div class="card p-3">
                                    <div style="font-size:0.75rem;color:var(--gray-500);">點擊率</div>
                                    <div style="font-size:1.5rem;font-weight:700;color:var(--gray-900);">{{ campaignDetails.data.stats?.click_rate || 0 }}%</div>
                                    <div style="font-size:0.75rem;color:var(--gray-600);margin-top:0.25rem;">Unique clicks：{{ campaignDetails.data.stats?.unique_clicks || 0 }}</div>
                                </div>
                            </div>

                            <div v-if="campaignProgress && campaignProgress.campaign_id === campaignDetails.data.campaign?.id" class="input p-3">
                                <div style="font-weight:700;color:var(--gray-800);margin-bottom:0.5rem;">寄送狀態統計</div>
                                <div class="flex flex-wrap gap-3" style="font-size:0.75rem;color:var(--gray-700);">
                                    <span>待處理：{{ campaignProgress.counts?.pending || 0 }}</span>
                                    <span>成功：{{ campaignProgress.counts?.sent || 0 }}</span>
                                    <span>失敗：{{ campaignProgress.counts?.failed || 0 }}</span>
                                    <span v-if="(campaignProgress.counts?.moved || 0) > 0">移轉：{{ campaignProgress.counts?.moved || 0 }}</span>
                                </div>
                            </div>

                            <div class="card p-3">
                                <div class="flex items-center justify-between">
                                    <div style="font-weight:700;color:var(--gray-800);">收件人（前 30 筆）</div>
                                    <button @click="fetchCampaignDetails(campaignDetails.data.campaign?.id)"
                                        class="btn btn-secondary btn-sm"
                                        :disabled="campaignDetails.loading">
                                        重新整理
                                    </button>
                                </div>
                                <div class="mt-2 overflow-x-auto">
                                    <table class="min-w-full text-xs">
                                        <thead>
                                            <tr style="text-align:left;color:var(--gray-500);border-bottom:1px solid var(--gray-200);">
                                                <th class="py-2 pr-3">Email</th>
                                                <th class="py-2 pr-3">姓名</th>
                                                <th class="py-2 pr-3">狀態</th>
                                                <th class="py-2 pr-3">開信</th>
                                                <th class="py-2 pr-3">點擊</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(r, idx) in safeArr(campaignDetails.data.recipients).slice(0, 30)"
                                                :key="keyById(r, 'rcpt', idx)" class="border-b">
                                                <td class="py-2 pr-3 font-mono" style="color:var(--gray-800);">{{ r.email }}</td>
                                                <td style="padding:0.5rem 0.75rem 0.5rem 0;color:var(--gray-700);">{{ r.name || '' }}</td>
                                                <td class="py-2 pr-3">
                                                    <span class="badge"
                                                        :class="(r.status === 'sent') ? 'badge-success' : ((r.status === 'failed') ? 'badge-danger' : 'badge-default')">
                                                        {{ r.status || '—' }}
                                                    </span>
                                                </td>
                                                <td style="padding:0.5rem 0.75rem 0.5rem 0;color:var(--gray-700);">{{ r.is_opened ? '是' : '否' }}</td>
                                                <td style="padding:0.5rem 0.75rem 0.5rem 0;color:var(--gray-700);">{{ r.is_clicked ? '是' : '否' }}</td>
                                            </tr>
                                            <tr v-if="safeArr(campaignDetails.data.recipients).length === 0">
                                                <td colspan="5" class="py-4 text-center" style="color:var(--gray-500);">無收件人資料</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="card p-3">
                                <div style="font-weight:700;color:var(--gray-800);margin-bottom:0.5rem;">最近活動（前 20 筆）</div>
                                <div class="space-y-2 max-h-48 overflow-y-auto custom-scrollbar">
                                    <div v-for="(l, idx) in safeArr(campaignDetails.data.logs).slice(0, 20)"
                                        :key="keyById(l, 'log', idx)" class="card card-body" style="padding:0.5rem;font-size:0.75rem;">
                                        <div class="font-mono" style="color:var(--gray-800);">{{ l.recipient || '' }}</div>
                                        <div style="color:var(--gray-700);margin-top:0.25rem;">{{ l.event || '' }}｜{{ l.timestamp ? new Date(l.timestamp).toLocaleString() : '' }}</div>
                                        <div v-if="l.details" class="mt-1 break-words" style="color:var(--gray-600);">{{ l.details }}</div>
                                    </div>
                                    <div v-if="safeArr(campaignDetails.data.logs).length === 0" style="font-size:0.75rem;color:var(--gray-500);">
                                        尚無追蹤事件（開信/點擊）
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button v-if="campaignDetails.data && campaignDetails.data.campaign"
                            @click="downloadCampaignFailuresCsv(campaignDetails.data.campaign.id)"
                            class="btn btn-secondary"
                            :disabled="campaignOps.downloadLoading">
                            {{ campaignOps.downloadLoading ? '下載中...' : '下載失敗 CSV' }}
                        </button>
                        <div v-if="campaignDetails.data && campaignDetails.data.campaign" class="flex items-center gap-2">
                            <select v-model="campaignOps.exportStatus"
                                class="input text-sm">
                                <option value="all">全部</option>
                                <option value="pending">待處理</option>
                                <option value="sent">成功</option>
                                <option value="failed">失敗</option>
                                <option value="moved">移轉</option>
                            </select>
                            <button
                                @click="downloadCampaignRecipientsCsv(campaignDetails.data.campaign.id, campaignOps.exportStatus)"
                                class="btn btn-secondary"
                                :disabled="campaignOps.downloadLoading">
                                下載收件人 CSV
                            </button>
                        </div>
                        <button v-if="campaignDetails.data && campaignDetails.data.campaign"
                            @click="retryCampaignFailedRecipients(campaignDetails.data.campaign.id)"
                            class="btn btn-secondary"
                            :disabled="campaignOps.retryLoading">
                            {{ campaignOps.retryLoading ? '重試中...' : '重試失敗寄送' }}
                        </button>
                        <button v-if="campaignDetails.data && campaignDetails.data.campaign"
                            @click="fetchCampaignDetails(campaignDetails.data.campaign.id)"
                            class="btn btn-secondary"
                            :disabled="campaignDetails.loading">
                            重新整理
                        </button>
                        <button @click="closeCampaignDetails"
                            class="btn btn-ghost">
                            關閉
                        </button>
                    </div>
                </div>
            </div>

            <!-- Campaign List Modal -->
            <div v-if="showCampaignListModal"
                class="modal-overlay">
                <div class="modal-box w-full"
                    :style="campaignListMaximized
                        ? 'max-width:100vw;width:100vw;height:100vh;max-height:100vh;margin:0;border-radius:0;display:flex;flex-direction:column;'
                        : 'max-width:80vw;display:flex;flex-direction:column;max-height:90vh;'">
                    <div
                        class="flex justify-between items-center p-4 border-b rounded-t-lg" style="background:linear-gradient(to right,#334155,#0f172a);color:#fff;flex-shrink:0;">
                        <h3 class="font-bold text-lg flex items-center gap-2">
                            <span>{{ campaignList.status === 'scheduled' ? '🕐' : '🗂️' }}</span>
                            {{ campaignList.status === 'scheduled' ? '排程信件管理' : '行銷活動列表' }}
                        </h3>
                        <div class="flex items-center gap-1">
                            <button @click="campaignListMaximized = !campaignListMaximized"
                                class="btn btn-ghost btn-sm" style="color:#fff;" :title="campaignListMaximized ? '還原' : '最大化'">
                                <svg v-if="!campaignListMaximized" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
                                <svg v-else width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="10" y1="14" x2="3" y2="21"/><line x1="21" y1="3" x2="14" y2="10"/></svg>
                            </button>
                            <button @click="closeCampaignList"
                                class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                        </div>
                    </div>

                    <div class="p-6 overflow-y-auto" style="flex:1;min-height:0;">
                        <div v-if="campaignList.loading && safeArr(campaignList.items).length === 0" class="flex items-center justify-center py-10">
                            <span class="spinner spinner-lg"></span>
                        </div>
                        <div v-else-if="campaignList.error" style="color:var(--color-danger);">
                            載入失敗：{{ campaignList.error }}
                        </div>
                        <div v-else class="space-y-3">
                            <div class="flex flex-col md:flex-row md:items-center gap-2">
                                <input v-model="campaignList.q" class="input w-full md:flex-1 text-sm"
                                    placeholder="搜尋：主旨 / ID / 寄件者">
                                <select v-model="campaignList.status" class="input w-full md:w-48 text-sm">
                                    <option value="all">全部狀態</option>
                                    <option value="scheduled">已排程</option>
                                    <option value="processing">處理中</option>
                                    <option value="completed">已完成</option>
                                    <option value="failed">失敗</option>
                                    <option value="cancelled">已取消</option>
                                </select>
                            </div>
                            <div class="overflow-x-auto border rounded">
                                <table class="min-w-full text-sm">
                                    <thead style="background:var(--gray-50);color:var(--gray-600);">
                                        <tr class="text-left">
                                            <th class="py-2 px-3">ID</th>
                                            <th class="py-2 px-3">主旨</th>
                                            <th class="py-2 px-3">狀態</th>
                                            <th class="py-2 px-3">建立/排程時間</th>
                                            <th class="py-2 px-3">開信/點擊</th>
                                            <th class="py-2 px-3"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(c, idx) in filteredCampaignListItems()" :key="keyById(c, 'cl', idx)" class="border-t">
                                            <td class="py-2 px-3 font-mono" style="color:var(--gray-800);">{{ c.id }}</td>
                                            <td class="py-2 px-3 max-w-[420px] truncate" style="color:var(--gray-800);" :title="c.subject">{{ c.subject || '(無主旨)' }}</td>
                                            <td class="py-2 px-3">
                                                <span class="badge"
                                                    :class="(c.status === 'completed') ? 'badge-success' : ((c.status === 'processing') ? 'badge-info' : 'badge-default')">
                                                    {{ c.status || '—' }}
                                                </span>
                                            </td>
                                            <td style="padding:0.5rem 0.75rem;color:var(--gray-700);">
                                                <div>{{ c.created_at ? new Date(c.created_at).toLocaleString() : '—' }}</div>
                                                <div v-if="c.scheduled_at" style="font-size:0.75rem;color:#7c3aed;">🕐 排程：{{ new Date(c.scheduled_at).toLocaleString() }}</div>
                                            </td>
                                            <td style="padding:0.5rem 0.75rem;color:var(--gray-700);">{{ c.open_count || 0 }} / {{ c.click_count || 0 }}</td>
                                            <td class="py-2 px-3 text-right">
                                                <div class="flex flex-wrap justify-end gap-2">
                                                    <button @click="closeCampaignList(); openCampaignDetails(c.id)"
                                                        class="btn btn-secondary btn-sm">
                                                        查看報表
                                                    </button>
                                                    <button @click="retryCampaignFailedRecipients(c.id)"
                                                        class="btn btn-secondary btn-sm"
                                                        :disabled="campaignOps.retryLoading">
                                                        重試失敗
                                                    </button>
                                                    <button @click="downloadCampaignRecipientsCsv(c.id, 'all')"
                                                        class="btn btn-secondary btn-sm"
                                                        :disabled="campaignOps.downloadLoading">
                                                        下載收件人
                                                    </button>
                                                    <button @click="downloadCampaignFailuresCsv(c.id)"
                                                        class="btn btn-secondary btn-sm"
                                                        :disabled="campaignOps.downloadLoading">
                                                        下載失敗
                                                    </button>
                                                    <button v-if="c.status === 'scheduled'"
                                                        @click="cancelScheduledCampaign(c.id)"
                                                        class="btn btn-sm"
                                                        style="background:#fef2f2;color:#dc2626;border:1px solid #fecaca;">
                                                        取消排程
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="filteredCampaignListItems().length === 0">
                                            <td colspan="6" class="py-6 text-center" style="color:var(--gray-500);">沒有符合條件的活動</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="flex items-center justify-between">
                                <button @click="fetchCampaignList(true)"
                                    class="btn btn-secondary btn-sm"
                                    :disabled="campaignList.loading">
                                    重新整理
                                </button>
                                <button @click="fetchCampaignList(false)"
                                    class="btn btn-secondary btn-sm"
                                    :disabled="campaignList.loading">
                                    {{ campaignList.loading ? '載入中...' : '載入更多' }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="closeCampaignList"
                            class="btn btn-ghost">
                            關閉
                        </button>
                    </div>
                </div>
            </div>

            <!-- Lead Score Modal -->
            <div v-if="showLeadScoreModal"
                class="modal-overlay" style="z-index: 9999;">
                <div class="modal-box w-full max-w-lg">
                    <div
                        class="flex justify-between items-center p-4 border-b cbi-header">
                        <div class="flex items-center gap-2">
                            <span>🎯</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 業務意向評分</h3>
                        </div>
                        <button @click="showLeadScoreModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>

                    <div class="p-6 overflow-y-auto">
                        <div v-if="aiLoading" class="flex flex-col items-center justify-center py-10 space-y-4">
                            <span class="spinner spinner-lg"></span>
                            <p style="color:var(--gray-500);font-weight:500;">AI 正在分析客戶意向...</p>
                        </div>

                        <div v-else-if="leadScoreResult" class="space-y-6">
                            <!-- Score Card -->
                            <div
                                class="flex items-center justify-between rounded-lg border p-4" style="background:var(--color-warning-bg,#fff7ed);border-color:var(--color-warning-border,#fed7aa);">
                                <div>
                                    <span style="font-size:0.875rem;color:var(--gray-500);text-transform:uppercase;letter-spacing:0.05em;font-weight:700;">潛在價值
                                        (Score)</span>
                                    <div class="text-2xl font-bold mt-1" style="color:var(--color-warning-dark,#b45309);">{{ leadScoreResult.score }}
                                    </div>
                                </div>
                                <div class="text-4xl">
                                    <span v-if="leadScoreResult.score.includes('High')">🔥</span>
                                    <span v-else-if="leadScoreResult.score.includes('Cold')">❄️</span>
                                    <span v-else-if="leadScoreResult.score.includes('Observing')">👀</span>
                                    <span v-else>❓</span>
                                </div>
                            </div>

                            <!-- Action Card -->
                            <div class="border rounded-lg p-4" style="background:var(--brand-50,#eef2ff);">
                                <span style="font-size:0.875rem;color:var(--gray-500);text-transform:uppercase;letter-spacing:0.05em;font-weight:700;">建議行動
                                    (Action)</span>
                                <div class="flex items-center gap-2 mt-1" style="font-size:1.25rem;font-weight:700;color:var(--brand-700,#4338ca);">
                                    <span>👉</span> {{ leadScoreResult.action }}
                                </div>
                            </div>

                            <!-- Reasoning -->
                            <div>
                                <span style="display:block;font-size:0.875rem;color:var(--gray-500);text-transform:uppercase;letter-spacing:0.05em;font-weight:700;margin-bottom:0.5rem;">分析理由
                                    (Reasoning)</span>
                                <div
                                    class="border rounded-lg" style="background:var(--gray-50);padding:1rem;color:var(--gray-700);line-height:1.625;font-size:0.875rem;">
                                    {{ leadScoreResult.reasoning }}
                                </div>
                            </div>
                        </div>

                        <div v-else class="empty-state" style="padding:2.5rem 1rem;">
                            無法取得分析結果，請稍後再試。
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="showLeadScoreModal = false"
                            class="btn btn-secondary">
                            關閉
                        </button>
                        <button v-if="leadScoreResult" @click="showLeadScoreModal = false; openLeadHistoryFromMessage()"
                            class="btn btn-secondary">
                            📜 歷史
                        </button>
                        <button v-if="leadScoreResult" @click="openSalesReplyFromLeadScore()"
                            class="btn btn-primary font-bold flex items-center gap-2">
                            <span>↩️</span> 一鍵回覆
                        </button>
                        <button v-if="leadScoreResult" @click="showLeadScoreModal = false; prepareFollowup()"
                            class="btn btn-warning font-bold flex items-center gap-2">
                            <span>🏃</span> 立即跟進
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="showOpportunityModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-2xl">
                    <div
                        class="flex justify-between items-center p-4 border-b cbi-header">
                        <div class="flex items-center gap-2">
                            <span>🧾</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 商機抽取</h3>
                        </div>
                        <button @click="showOpportunityModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>

                    <div class="p-6 overflow-y-auto">
                        <div v-if="opportunityLoading" class="flex flex-col items-center justify-center py-10 space-y-4">
                            <span class="spinner spinner-lg"></span>
                            <p style="color:var(--gray-500);font-weight:500;">載入中...</p>
                        </div>

                        <div v-else-if="opportunityResult" class="space-y-4">
                            <div class="border rounded-lg p-4" style="background:#ecfdf5;border-color:#d1fae5;">
                                <div style="font-size:0.875rem;color:var(--color-success);font-weight:700;">商機詳情</div>
                                <div style="font-size:0.75rem;color:var(--color-success);margin-top:0.25rem;">ID: {{ opportunityResult.id }}｜{{ opportunityResult.created_at }}</div>
                            </div>

                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div class="card card-body" style="padding:0.75rem;">
                                    <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">寄件者</div>
                                    <div style="color:var(--gray-800);font-weight:500;white-space:pre-wrap;">{{ opportunityResult.sender_name || '—' }}</div>
                                    <div style="font-size:0.75rem;color:var(--gray-500);margin-top:0.25rem;">{{ opportunityResult.sender_email || '—' }}</div>
                                </div>
                                <div class="card card-body" style="padding:0.75rem;">
                                    <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">主旨</div>
                                    <div style="color:var(--gray-800);font-weight:500;white-space:pre-wrap;">{{ opportunityResult.subject || '—' }}</div>
                                </div>
                                <div class="card card-body" style="padding:0.75rem;">
                                    <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">聯絡人 / CRM</div>
                                    <div v-if="opportunityResult.contact_id" class="space-y-2">
                                        <div style="color:var(--gray-800);font-weight:500;white-space:pre-wrap;">{{ formatContactLabel(opportunityResult.contact_id) }}</div>
                                        <div class="flex flex-wrap items-center gap-2">
                                            <button @click="openCrmTimeline({ contact_id: opportunityResult.contact_id })"
                                                class="btn btn-primary btn-sm">
                                                CRM
                                            </button>
                                            <button @click="unlinkOpportunityContact" :disabled="opportunityContactLinking"
                                                class="btn btn-secondary btn-xs">
                                                解除連結
                                            </button>
                                        </div>
                                    </div>
                                    <div v-else class="space-y-2">
                                        <div style="font-size:0.875rem;color:var(--gray-600);">尚未連結聯絡人</div>
                                        <div class="flex flex-wrap items-center gap-2">
                                            <button @click="refreshOpportunityContactLookup(true)"
                                                :disabled="opportunityContactLookupLoading || opportunityContactCreateLoading || opportunityContactLinking || !(opportunityResult.sender_email || '').toString().trim()"
                                                class="btn btn-secondary btn-xs">
                                                <span v-if="opportunityContactLookupLoading" class="spinner spinner-sm" style="margin-right:0.25rem;"></span>
                                                查找
                                            </button>
                                            <button @click="createContactFromOpportunity"
                                                :disabled="opportunityContactLookupLoading || opportunityContactCreateLoading || opportunityContactLinking || !(opportunityResult.sender_email || '').toString().trim()"
                                                class="btn btn-success btn-sm">
                                                <span v-if="opportunityContactCreateLoading" class="spinner spinner-sm" style="margin-right:0.25rem;"></span>
                                                建立
                                            </button>
                                        </div>
                                        <div v-if="opportunityContactLookupError" style="font-size:0.75rem;color:var(--color-danger);">{{ opportunityContactLookupError }}</div>
                                        <div v-else-if="opportunityContactLookupResult" class="card p-2">
                                            <div style="font-size:0.75rem;color:var(--gray-500);margin-bottom:0.25rem;">找到：</div>
                                            <div style="font-size:0.875rem;font-weight:500;color:var(--gray-800);">{{ opportunityContactLookupResult.name }} &lt;{{ opportunityContactLookupResult.email }}&gt;</div>
                                            <button @click="linkOpportunityToContact(opportunityContactLookupResult.id)"
                                                :disabled="opportunityContactLinking"
                                                class="btn btn-dark btn-sm mt-2">
                                                <span v-if="opportunityContactLinking" class="spinner spinner-sm" style="margin-right:0.25rem;"></span>
                                                連結
                                            </button>
                                        </div>
                                        <div v-else-if="opportunityContactLookupAttemptedEmail" style="font-size:0.75rem;color:var(--gray-500);">未找到符合的聯絡人</div>
                                    </div>
                                </div>
                            </div>

                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div class="card card-body" style="padding:0.75rem;">
                                    <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">狀態</div>
                                    <div v-if="opportunityEditMode">
                                        <select v-model="opportunityEditForm.status" class="input">
                                            <option value="inbound">進線</option>
                                            <option value="qualified">已確認</option>
                                            <option value="proposal">提案/報價</option>
                                            <option value="negotiation">議價/簽約</option>
                                            <option value="won">成交</option>
                                            <option value="lost">流失</option>
                                        </select>
                                    </div>
                                    <div v-else style="color:var(--gray-800);font-weight:500;white-space:pre-wrap;">{{ stageLabel(opportunityResult.status || 'inbound') }}</div>
                                </div>
                                <div class="card card-body" style="padding:0.75rem;">
                                    <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">公司</div>
                                    <div v-if="opportunityEditMode">
                                        <input v-model="opportunityEditForm.company" class="input" />
                                    </div>
                                    <div v-else style="color:var(--gray-800);font-weight:500;white-space:pre-wrap;">{{ opportunityResult.company || '—' }}</div>
                                </div>
                                <div class="card card-body" style="padding:0.75rem;">
                                    <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">決策者</div>
                                    <div v-if="opportunityEditMode">
                                        <input v-model="opportunityEditForm.decision_maker" class="input" />
                                    </div>
                                    <div v-else style="color:var(--gray-800);font-weight:500;white-space:pre-wrap;">{{ opportunityResult.decision_maker || '—' }}</div>
                                </div>
                                <div class="card card-body" style="padding:0.75rem;">
                                    <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">預算</div>
                                    <div v-if="opportunityEditMode" class="space-y-2">
                                        <textarea v-model="opportunityEditForm.budget_text" rows="2" class="input"></textarea>
                                        <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
                                            <input v-model.number="opportunityEditForm.budget_min" type="number" step="0.01" class="input" placeholder="min" />
                                            <input v-model.number="opportunityEditForm.budget_max" type="number" step="0.01" class="input" placeholder="max" />
                                            <input v-model="opportunityEditForm.currency" class="input" placeholder="currency" />
                                        </div>
                                    </div>
                                    <div v-else style="color:var(--gray-800);font-weight:500;white-space:pre-wrap;">
                                        {{ opportunityResult.budget_text || '—' }}
                                        <span v-if="opportunityResult.budget_min != null || opportunityResult.budget_max != null" style="color:var(--gray-500);">
                                            ({{ opportunityResult.budget_min != null ? opportunityResult.budget_min : '—' }} ~ {{ opportunityResult.budget_max != null ? opportunityResult.budget_max : '—' }} {{ opportunityResult.currency || '' }})
                                        </span>
                                    </div>
                                </div>
                                <div class="card card-body" style="padding:0.75rem;">
                                    <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">時程</div>
                                    <div v-if="opportunityEditMode" class="space-y-2">
                                        <textarea v-model="opportunityEditForm.timeline" rows="2" class="input"></textarea>
                                        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                                            <input v-model="opportunityEditForm.timeline_start" class="input" placeholder="start" />
                                            <input v-model="opportunityEditForm.timeline_end" class="input" placeholder="end" />
                                        </div>
                                    </div>
                                    <div v-else style="color:var(--gray-800);font-weight:500;white-space:pre-wrap;">
                                        {{ opportunityResult.timeline || '—' }}
                                        <span v-if="opportunityResult.timeline_start || opportunityResult.timeline_end" style="color:var(--gray-500);">
                                            ({{ opportunityResult.timeline_start || '—' }} ~ {{ opportunityResult.timeline_end || '—' }})
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="card card-body" style="padding:0.75rem;">
                                <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">需求</div>
                                <div v-if="opportunityEditMode">
                                    <textarea v-model="opportunityEditForm.need" rows="4" class="input"></textarea>
                                </div>
                                <div v-else style="color:var(--gray-800);white-space:pre-wrap;">{{ opportunityResult.need || '—' }}</div>
                            </div>

                            <div class="card card-body" style="padding:0.75rem;">
                                <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">下一步</div>
                                <div v-if="opportunityEditMode">
                                    <textarea v-model="opportunityEditForm.next_step" rows="4" class="input"></textarea>
                                </div>
                                <div v-else style="color:var(--gray-800);white-space:pre-wrap;">{{ opportunityResult.next_step || '—' }}</div>
                            </div>

                            <div class="card card-body" style="padding:0.75rem;">
                                <div style="font-size:0.75rem;color:var(--gray-500);font-weight:700;margin-bottom:0.25rem;">摘要 / 信心值</div>
                                <div v-if="opportunityEditMode" class="space-y-2">
                                    <textarea v-model="opportunityEditForm.summary" rows="4" class="input"></textarea>
                                    <div class="flex items-center gap-2">
                                        <div style="font-size:0.75rem;color:var(--gray-500);">confidence</div>
                                        <input v-model.number="opportunityEditForm.confidence" type="number" step="0.01" min="0" max="1"
                                            class="input w-32 text-sm" />
                                    </div>
                                </div>
                                <div v-else>
                                    <div style="color:var(--gray-800);white-space:pre-wrap;">{{ opportunityResult.summary || '—' }}</div>
                                    <div style="font-size:0.75rem;color:var(--gray-500);margin-top:0.5rem;">confidence: {{ opportunityResult.confidence != null ? opportunityResult.confidence : '—' }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="empty-state" style="padding:2.5rem 1rem;display:flex;flex-direction:column;align-items:center;gap:0.75rem;">
                            <span style="font-size:2rem;">⚠️</span>
                            <div style="font-weight:600;color:var(--gray-700);">無法取得抽取結果</div>
                            <div v-if="opportunityError" style="font-size:0.8125rem;color:var(--color-danger);background:var(--color-danger-bg,#fff5f5);border:1px solid #fca5a5;border-radius:var(--radius-md);padding:0.5rem 0.875rem;max-width:28rem;text-align:center;word-break:break-all;">
                                {{ opportunityError }}
                            </div>
                            <div style="font-size:0.8125rem;color:var(--gray-400);">請確認 AI 服務正常運行後再試</div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="showOpportunityModal = false; opportunityEditMode = false"
                            class="btn btn-secondary">
                            關閉
                        </button>
                        <button v-if="opportunityResult && !opportunityEditMode" @click="enterOpportunityEditMode()"
                            class="btn btn-secondary">
                            編輯
                        </button>
                        <button v-if="opportunityResult && opportunityEditMode" @click="cancelOpportunityEdit()"
                            :disabled="opportunitySaving"
                            class="btn btn-secondary">
                            取消編輯
                        </button>
                        <button v-if="opportunityResult && opportunityEditMode" @click="saveOpportunityEdit()"
                            :disabled="opportunitySaving"
                            class="btn btn-success">
                            {{ opportunitySaving ? '儲存中...' : '儲存' }}
                        </button>
                        <button v-if="opportunityResult" @click="showOpportunityModal = false; openAiSalesView(); aiSalesTab = 'opportunities'; fetchOpportunities()"
                            class="btn btn-success font-bold flex items-center gap-2">
                            <span>📋</span> 查看清單
                        </button>
                        <button v-if="opportunityResult && (opportunityResult.message_id || (opportunityResult.sender_email && opportunityResult.subject) || opportunityResult.imap_id)" @click="showOpportunityModal = false; openOpportunityOriginal(opportunityResult)"
                            class="btn btn-secondary">
                            📨 查看原信
                        </button>
                    </div>
                </div>
            </div>

            <!-- Lead Score History Modal -->
            <div v-if="showLeadHistoryModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-3xl">
                    <div class="btn btn-dark justify-between p-4 border-b">
                        <h3 class="font-bold text-lg flex items-center gap-2">
                            <span>📜</span> Lead Score 歷史
                            <span v-if="leadHistoryContact" style="font-size:0.875rem;font-weight:400;color:var(--gray-200);">{{ leadHistoryContact.email }}</span>
                        </h3>
                        <button @click="showLeadHistoryModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>

                    <div class="p-6 overflow-y-auto">
                        <div v-if="leadHistoryLoading" class="empty-state" style="padding:1.5rem;">
                            <span class="spinner spinner-sm" style="margin-right:0.5rem;"></span> 載入中...
                        </div>
                        <div v-else>
                            <div v-if="safeArr(leadHistoryEvents).length === 0" class="p-8 text-center" style="color:var(--gray-500);">
                                尚無歷史紀錄
                            </div>
                            <div v-else class="space-y-3">
                                <div v-for="(e, idx) in safeArr(leadHistoryEvents)" :key="keyById(e, 'lhe', idx)" class="input -lg p-4">
                                    <div class="flex flex-wrap gap-3 items-center justify-between">
                                        <div class="flex items-center gap-2">
                                            <span class="text-xs px-2 py-1 rounded font-mono"
                                                :class="(e.score_value || 0) > 5 ? 'badge badge-warning' : ((e.score_value || 0) > 0 ? 'badge badge-default' : 'badge')"
                                            >{{ e.score_label || '-' }}{{ e.score_value !== null && e.score_value !== undefined ? (' (' + e.score_value + ')') : '' }}</span>
                                            <span style="font-size:0.75rem;color:var(--gray-500);font-family:monospace;">{{ e.created_at ? new Date(e.created_at).toLocaleString() : '-' }}</span>
                                        </div>
                                        <div style="font-size:0.75rem;color:var(--gray-500);font-family:monospace;" v-if="e.subject">{{ e.subject }}</div>
                                    </div>
                                    <div v-if="e.action" class="mt-3 rounded p-3 text-sm" style="background:var(--brand-50,#eef2ff);border:1px solid var(--brand-100,#e0e7ff);color:var(--brand-900,#1e1b4b);">
                                        <span class="font-bold">建議行動：</span>{{ e.action }}
                                    </div>
                                    <div v-if="e.reasoning" class="mt-3 rounded p-3 text-sm whitespace-pre-wrap" style="background:var(--gray-50);border:1px solid var(--gray-200);color:var(--gray-800);">{{ e.reasoning }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="showLeadHistoryModal = false"
                            class="btn btn-secondary">
                            關閉
                        </button>
                    </div>
                </div>
            </div>

            <!-- Follow-up Modal -->
            <div v-if="showAiFollowupModal"
                class="modal-overlay">
                <div class="modal-box w-full max-w-lg">
                    <div
                        class="flex justify-between items-center p-4 border-b cbi-header">
                        <div class="flex items-center gap-2">
                            <span>🏃</span>
                            <h3 class="font-bold text-lg" style="color:#fff;">AI 智慧跟進</h3>
                        </div>
                        <button @click="showAiFollowupModal = false"
                            class="btn btn-ghost btn-sm" style="color:#fff;opacity:0.8;">×</button>
                    </div>

                    <div class="p-6 overflow-y-auto space-y-4">
                        <!-- Step 1: Input -->
                        <div v-if="!aiFollowupResult && !aiLoading">
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">收件人 (Recipient)</label>
                                <input v-model="aiFollowupForm.recipient" class="input" style="background:var(--gray-50);">
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">語氣 (Tone)</label>
                                <select v-model="aiFollowupForm.tone" class="input w-full">
                                    <option value="professional">專業 (Professional)</option>
                                    <option value="polite">禮貌 (Polite)</option>
                                    <option value="urgent">急迫 (Urgent)</option>
                                    <option value="friendly">友善 (Friendly)</option>
                                </select>
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">語言 (Language)</label>
                                <select v-model="aiFollowupForm.language" class="input w-full">
                                    <option value="auto">自動 (跟原信同語言)</option>
                                    <option value="Traditional Chinese (繁體中文)">繁體中文</option>
                                    <option value="English">English</option>
                                    <option value="日本語">日本語</option>
                                </select>
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">長度 (Length)</label>
                                <select v-model="aiFollowupForm.length" class="input w-full">
                                    <option value="short">短 (一段 + CTA)</option>
                                    <option value="medium">中 (兩段 + CTA)</option>
                                    <option value="long">長 (2-3 段/可含條列)</option>
                                </select>
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">模板 (Template)</label>
                                <select v-model="aiFollowupForm.template" class="input w-full">
                                    <option value="gentle_nudge">溫和提醒 (Gentle Nudge)</option>
                                    <option value="value_add">補充價值 (Value Add)</option>
                                    <option value="schedule_call">約短會議 (Schedule Call)</option>
                                    <option value="close_loop">收尾確認 (Close Loop)</option>
                                </select>
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">額外指示 (選填)</label>
                                <input v-model="aiFollowupForm.instructions" placeholder="例如：請給對方兩個可選時段、語氣更直接一些..."
                                    class="input w-full">
                            </div>
                            <div class="flex items-center gap-2">
                                <input id="aiFollowupIncludeQuote" type="checkbox" v-model="aiFollowupForm.include_quote" class="h-4 w-4">
                                <label for="aiFollowupIncludeQuote" style="font-size:0.875rem;color:var(--gray-700);font-weight:500;">附上引用原信 (Quote Original)</label>
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">參考郵件內容 (Context)</label>
                                <textarea v-model="aiFollowupForm.original_text" rows="5"
                                    class="input" style="background:var(--gray-100);font-size:0.875rem;" readonly></textarea>
                            </div>
                        </div>

                        <!-- Loading -->
                        <div v-else-if="aiLoading" class="flex flex-col items-center justify-center py-10 space-y-4">
                            <span class="spinner spinner-lg"></span>
                            <p style="color:var(--gray-500);font-weight:500;">AI 正在撰寫跟進郵件...</p>
                        </div>

                        <!-- Result -->
                        <div v-else>
                            <div class="mb-3">
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">主旨 (Subject)</label>
                                <input v-model="aiFollowupSubject" class="input w-full font-mono" placeholder="(由 AI 生成或自行輸入)">
                            </div>
                            <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.5rem;color:var(--gray-700);">跟進郵件草稿</label>
                            <textarea v-model="aiFollowupResult" rows="10"
                                class="w-full border p-2 rounded focus:ring-2 focus:ring-orange-500 outline-none"></textarea>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="showAiFollowupModal = false"
                            class="btn btn-secondary">
                            取消
                        </button>
                        <button v-if="!aiFollowupResult && !aiLoading" @click="generateFollowup"
                            class="btn btn-warning">
                            生成草稿
                        </button>
                        <button v-else-if="aiFollowupResult" @click="useFollowup"
                            class="btn btn-primary">
                            使用此草稿
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="showJourneyEnrollmentsModal" class="modal-overlay">
                <div class="modal-box w-full max-w-4xl">
                    <div class="btn btn-dark justify-between p-4 border-b">
                        <h3 class="font-bold text-lg">參與者：{{ selectedJourneyForEnrollments?.name || '' }}</h3>
                        <button @click="showJourneyEnrollmentsModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>

                    <div class="p-4 overflow-y-auto">
                        <div v-if="journeyEnrollmentsLoading" class="flex items-center justify-center py-10">
                            <span class="spinner spinner-lg"></span>
                        </div>
                        <div v-else>
                            <div class="flex justify-end mb-3">
                                <button @click="fetchJourneyEnrollments(selectedJourneyForEnrollments?.id)" class="btn btn-secondary btn-sm">刷新</button>
                            </div>
                            <div class="overflow-x-auto border rounded">
                                <table class="data-table">
                                    <thead style="background:var(--gray-50);border-bottom:1px solid var(--gray-200);">
                                        <tr>
                                            <th class="text-left p-2">Email</th>
                                            <th class="text-left p-2">姓名</th>
                                            <th class="text-left p-2">狀態</th>
                                            <th class="text-left p-2">目前步驟</th>
                                            <th class="text-left p-2">下次執行</th>
                                            <th class="text-left p-2">上次執行</th>
                                            <th class="text-left p-2">最近寄送</th>
                                            <th class="text-left p-2">最近錯誤</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="safeArr(journeyEnrollments).length === 0">
                                            <td colspan="8" class="empty-state" style="padding:1.5rem;">尚無參與者</td>
                                        </tr>
                                        <tr v-for="(e, idx) in safeArr(journeyEnrollments)" :key="keyById(e, 'je', idx)" class="border-b">
                                            <td class="p-2 font-mono">{{ e.contact_email || '-' }}</td>
                                            <td class="p-2">{{ e.contact_name || '-' }}</td>
                                            <td class="p-2">{{ e.status }}</td>
                                            <td class="p-2">{{ e.current_step_order }}</td>
                                            <td class="p-2">{{ e.next_action_at ? new Date(e.next_action_at).toLocaleString() : '-' }}</td>
                                            <td class="p-2">{{ e.last_action_at ? new Date(e.last_action_at).toLocaleString() : '-' }}</td>
                                            <td class="p-2">{{ e.last_sent_at ? new Date(e.last_sent_at).toLocaleString() : '-' }}</td>
                                            <td class="p-2 text-xs" style="color:var(--color-danger);" :title="e.last_error || ''">{{ e.last_error ? (e.last_error.length > 40 ? e.last_error.slice(0, 40) + '…' : e.last_error) : '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showJourneyEditorModal" class="modal-overlay">
                <div class="modal-box w-full max-w-5xl">
                    <div class="btn btn-primary justify-between p-4 border-b">
                        <h3 class="font-bold text-lg">{{ journeyEditorForm?.id ? '編輯旅程' : '新增旅程' }}</h3>
                        <button @click="showJourneyEditorModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>

                    <div class="p-4 overflow-y-auto space-y-4">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">名稱</label>
                                <input v-model="journeyEditorForm.name" class="input w-full" placeholder="例如：新客 3 天培育旅程">
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">狀態</label>
                                <select v-model="journeyEditorForm.status" class="input w-full">
                                    <option value="draft">草稿</option>
                                    <option value="active">啟用</option>
                                    <option value="paused">暫停</option>
                                </select>
                            </div>
                            <div class="md:col-span-2">
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">描述</label>
                                <textarea v-model="journeyEditorForm.description" class="input w-full" rows="2" placeholder="可選填"></textarea>
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">觸發方式</label>
                                <select v-model="journeyEditorForm.trigger_type" class="input w-full">
                                    <option value="manual">手動執行</option>
                                    <option value="segment">分眾加入時</option>
                                    <option value="on_contact_created">新聯絡人加入時（自動）</option>
                                    <option value="on_tag_added">聯絡人加入特定標籤時（自動）</option>
                                    <option value="on_form_submit">推廣頁面表單提交時（自動）</option>
                                    <option value="on_survey_complete">問卷填寫完成時（自動）</option>
                                </select>
                                <div v-if="journeyEditorForm.trigger_type === 'on_tag_added'" class="mt-2">
                                    <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">觸發標籤名稱</label>
                                    <input v-model="journeyEditorForm.trigger_tag" class="input w-full" placeholder="例如：VIP、新客、試用期">
                                    <div class="text-xs mt-1" style="color:var(--gray-400);">當聯絡人的標籤包含此文字時，自動加入旅程</div>
                                </div>
                                <div v-if="journeyEditorForm.trigger_type === 'on_form_submit'" class="mt-2">
                                    <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">推廣頁面 Slug（留空=全部）</label>
                                    <input v-model="journeyEditorForm.trigger_tag" class="input w-full" placeholder="例如：summer-sale（空白表示任何表單）">
                                    <div class="text-xs mt-1" style="color:var(--gray-400);">當該頁面的表單被送出後，自動將填寫者（需為已知聯絡人）加入旅程</div>
                                </div>
                                <div v-if="journeyEditorForm.trigger_type === 'on_survey_complete'" class="mt-2">
                                    <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">問卷 ID（留空=全部）</label>
                                    <input v-model="journeyEditorForm.trigger_tag" class="input w-full" placeholder="例如：3（空白表示任何問卷）">
                                    <div class="text-xs mt-1" style="color:var(--gray-400);">當問卷回覆送出後，自動將填寫者（需填入 Email 且為已知聯絡人）加入旅程</div>
                                </div>
                            </div>
                            <div class="flex items-center gap-2 mt-6">
                                <input id="optSendTime" type="checkbox" v-model="journeyEditorForm.optimize_send_time" class="h-4 w-4">
                                <label for="optSendTime" style="font-size:0.875rem;color:var(--gray-700);">啟用最佳發送時間（若聯絡人有設定）</label>
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">寄件者帳號</label>
                                <input v-model="journeyEditorForm.sender" class="w-full border p-2 rounded" placeholder="sender@example.com">
                            </div>
                            <div>
                                <label style="display:block;font-size:0.875rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-700);">寄件者密碼</label>
                                <input v-model="journeyEditorForm.sender_password" class="w-full border p-2 rounded" type="password" placeholder="******">
                            </div>
                        </div>

                        <div class="flex justify-between items-center mt-2">
                            <h4 style="font-weight:700;color:var(--gray-800);">步驟</h4>
                            <button @click="addJourneyStep()" class="btn btn-primary">➕ 新增步驟</button>
                        </div>

                        <div class="space-y-3">
                            <div v-for="(s, idx) in journeyEditorForm.steps" :key="idx" class="input p-3">
                                <div class="flex justify-between items-center">
                                    <div style="font-weight:700;color:var(--gray-800);">Step {{ s.step_order }}</div>
                                    <div class="flex items-center gap-1">
                                        <button type="button" v-if="idx > 0"
                                            @click="journeyEditorForm.steps.splice(idx-1,0,journeyEditorForm.steps.splice(idx,1)[0]); normalizeJourneySteps()"
                                            class="btn btn-secondary btn-xs" title="上移">↑</button>
                                        <button type="button" v-if="idx < journeyEditorForm.steps.length - 1"
                                            @click="journeyEditorForm.steps.splice(idx,0,journeyEditorForm.steps.splice(idx+1,1)[0]); normalizeJourneySteps()"
                                            class="btn btn-secondary btn-xs" title="下移">↓</button>
                                        <button type="button" v-if="journeyEditorForm.steps.length > 1"
                                            @click="removeJourneyStep(idx)"
                                            class="btn btn-xs btn-outline" style="color:var(--color-danger);border-color:#fca5a5;">刪除</button>
                                    </div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
                                    <div>
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">延遲（小時）</label>
                                        <input v-model.number="s.delay_hours" type="number" min="0" class="input w-full">
                                    </div>
                                    <div>
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">動作</label>
                                        <select v-model="s.action_type" class="input w-full">
                                            <option value="email">寄送 Email</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">條件</label>
                                        <select v-model="s.condition_type" class="input w-full">
                                            <option value="always">永遠</option>
                                            <option value="opened">已開啟</option>
                                            <option value="not_opened">未開啟</option>
                                            <option value="clicked">已點擊</option>
                                            <option value="not_clicked">未點擊</option>
                                        </select>
                                    </div>
                                    <div class="md:col-span-3">
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">條件參數（可留空）</label>
                                        <input v-model="s.condition_arg" class="input w-full" placeholder="例如：step_1 或 step_1:pricing">
                                    </div>
                                    <div class="md:col-span-3">
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">主旨</label>
                                        <input v-model="s.subject_template" class="input w-full" placeholder="例如：歡迎加入！">
                                    </div>
                                    <div class="md:col-span-3">
                                        <label style="display:block;font-size:0.75rem;font-weight:700;margin-bottom:0.25rem;color:var(--gray-600);">內容（HTML / Text）</label>
                                        <textarea v-model="s.body_template" class="input w-full" rows="4" placeholder="輸入郵件內容"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="showJourneyEditorModal = false" class="btn btn-secondary">取消</button>
                        <button @click="saveJourneyEditor()" :disabled="journeyEditorSaving" class="btn btn-primary">
                            {{ journeyEditorSaving ? '儲存中...' : '儲存' }}
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="showJourneyFunnelModal" class="modal-overlay">
                <div class="modal-box w-full max-w-4xl">
                    <div class="btn btn-primary justify-between p-4 border-b">
                        <h3 class="font-bold text-lg">漏斗：{{ selectedJourneyForFunnel?.name || '' }}</h3>
                        <button @click="showJourneyFunnelModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>

                    <div class="p-4 overflow-y-auto">
                        <div v-if="journeyFunnelLoading" class="flex items-center justify-center py-10">
                            <span class="spinner spinner-lg"></span>
                        </div>
                        <div v-else>
                            <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-3">
                                <div style="font-size:0.875rem;color:var(--gray-600);">
                                    參與：{{ journeyFunnel?.enrollments_total ?? '-' }}，啟用中：{{ journeyFunnel?.enrollments_active ?? '-' }}，完成：{{ journeyFunnel?.enrollments_completed ?? '-' }}（{{ journeyFunnelFilters.days === 0 ? '不限時間' : `近 ${journeyFunnelFilters.days} 天` }}）
                                </div>
                                <div class="flex flex-col md:flex-row gap-2 md:items-center">
                                    <select v-model="journeyFunnelFilters.segment_id" class="input">
                                        <option value="">全部分眾</option>
                                        <option v-for="(seg, idx) in safeArr(aiMarketingState.segments)" :key="keyById(seg, 'segopt2', idx)" :value="seg.id">{{ seg.name }}</option>
                                    </select>
                                    <select v-model.number="journeyFunnelFilters.days" class="input">
                                        <option :value="7">近 7 天</option>
                                        <option :value="30">近 30 天</option>
                                        <option :value="90">近 90 天</option>
                                        <option :value="0">不限時間</option>
                                    </select>
                                    <button @click="fetchJourneyFunnel(selectedJourneyForFunnel?.id)" class="btn btn-primary">套用</button>
                                </div>
                            </div>

                            <!-- Funnel Bar Chart -->
                            <div v-if="journeyFunnel?.steps?.length" class="mb-4 space-y-2">
                                <div style="font-size:0.8rem;font-weight:700;color:var(--gray-600);margin-bottom:0.5rem;">漏斗視覺化</div>
                                <div v-for="s in journeyFunnel.steps" :key="'bar-' + s.step_order" class="flex items-center gap-3">
                                    <span class="text-xs font-bold w-14 text-right flex-shrink-0" style="color:var(--gray-500);">Step {{ s.step_order }}</span>
                                    <div class="flex-1 rounded-full h-6 relative overflow-hidden" style="background:var(--gray-100);">
                                        <!-- Sent bar (full width base) -->
                                        <div class="absolute inset-0 rounded-full" style="background:var(--brand-100,#e0e7ff);"></div>
                                        <!-- Opened bar -->
                                        <div class="absolute top-0 left-0 h-full rounded-full transition-all duration-500" style="background:#4ade80;"
                                            :style="{ width: (s.sent > 0 ? Math.round((s.opened / s.sent) * 100) : 0) + '%' }"></div>
                                        <!-- Clicked bar (overlay on opened) -->
                                        <div class="absolute top-0 left-0 h-full rounded-full transition-all duration-500" style="background:var(--brand-500,#6366f1);"
                                            :style="{ width: (s.sent > 0 ? Math.round((s.clicked / s.sent) * 100) : 0) + '%' }"></div>
                                        <span class="absolute inset-0 flex items-center justify-center text-xs font-bold" style="color:var(--gray-700);">
                                            {{ s.sent }} 發送 · {{ s.opened }} 開啟 · {{ s.clicked }} 點擊
                                        </span>
                                    </div>
                                    <span class="text-xs w-16 flex-shrink-0" style="color:var(--gray-500);">{{ Math.round((s.open_rate || 0) * 100) }}% 開啟</span>
                                </div>
                                <div class="flex items-center gap-3 mt-1 pl-17" style="padding-left:4.25rem;">
                                    <span class="flex items-center gap-1 text-xs" style="color:var(--gray-500);"><span class="inline-block w-3 h-3 rounded-full" style="background:#4ade80;"></span>已開啟</span>
                                    <span class="flex items-center gap-1 text-xs" style="color:var(--gray-500);"><span class="inline-block w-3 h-3 rounded-full" style="background:var(--brand-500,#6366f1);"></span>已點擊</span>
                                    <span class="flex items-center gap-1 text-xs" style="color:var(--gray-500);"><span class="inline-block w-3 h-3 rounded-full border" style="background:var(--brand-100,#e0e7ff);border-color:var(--brand-200,#c7d2fe);"></span>已發送</span>
                                </div>
                            </div>

                            <div class="overflow-x-auto border rounded">
                                <table class="data-table">
                                    <thead style="background:var(--gray-50);border-bottom:1px solid var(--gray-200);">
                                        <tr>
                                            <th class="text-left p-2">Step</th>
                                            <th class="text-left p-2">條件</th>
                                            <th class="text-left p-2">Sent</th>
                                            <th class="text-left p-2">Open</th>
                                            <th class="text-left p-2">Click</th>
                                            <th class="text-left p-2">Failed</th>
                                            <th class="text-left p-2">Open%</th>
                                            <th class="text-left p-2">Click%</th>
                                            <th class="text-left p-2">Fail%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!journeyFunnel?.steps || journeyFunnel.steps.length === 0">
                                            <td colspan="9" class="empty-state" style="padding:1.5rem;">尚無步驟</td>
                                        </tr>
                                        <tr v-for="s in journeyFunnel.steps" :key="s.step_order" class="border-b">
                                            <td class="p-2 font-bold">Step {{ s.step_order }}</td>
                                            <td class="p-2 text-xs" style="color:var(--gray-600);">{{ s.condition_type }}</td>
                                            <td class="p-2">{{ s.sent }}</td>
                                            <td class="p-2">{{ s.opened }}</td>
                                            <td class="p-2">{{ s.clicked }}</td>
                                            <td class="p-2" style="color:var(--color-danger);">{{ s.failed }}</td>
                                            <td class="p-2">{{ Math.round((s.open_rate || 0) * 100) }}%</td>
                                            <td class="p-2">{{ Math.round((s.click_rate || 0) * 100) }}%</td>
                                            <td class="p-2">{{ Math.round((s.fail_rate || 0) * 100) }}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

            <!-- Campaign HTML Preview Modal -->
            <div v-if="showCampaignPreviewModal" class="modal-overlay" style="z-index:9999;">
                <div class="modal-box w-full" style="max-width:900px;max-height:95vh;display:flex;flex-direction:column;">
                    <div class="flex justify-between items-center p-4 border-b rounded-t-lg" style="background:linear-gradient(to right,#374151,#111827);color:#fff;">
                        <h3 class="font-bold text-lg flex items-center gap-2">
                            👁️ 郵件預覽
                            <span class="text-xs opacity-75 font-normal">{{ aiMarketingState.fullResult?.subject || '（無主旨）' }}</span>
                        </h3>
                        <div class="flex items-center gap-2">
                            <span class="text-xs opacity-75">此為預覽，實際收信可能因郵件客戶端而略有差異</span>
                            <button @click="showCampaignPreviewModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                        </div>
                    </div>
                    <div class="flex-1 overflow-hidden p-4">
                        <iframe
                            :srcdoc="aiMarketingState.result || '<p style=\'text-align:center;color:#9ca3af;padding:2rem;\'>尚無內容，請先在 EDM 生成步驟產生郵件</p>'"
                            style="width:100%;height:100%;min-height:500px;border:1px solid #e5e7eb;border-radius:8px;background:#fff;"
                            sandbox="allow-same-origin"
                        ></iframe>
                    </div>
                    <div class="p-3 border-t flex justify-end gap-2">
                        <button @click="showCampaignPreviewModal = false; sendTestCampaign()"
                            class="btn btn-secondary"
                            :disabled="campaignTestSending">
                            {{ campaignTestSending ? '寄送中...' : '📧 測試寄送' }}
                        </button>
                        <button @click="showCampaignPreviewModal = false" class="btn btn-primary">確認，關閉預覽</button>
                    </div>
                </div>
            </div>

            <!-- Unsubscribe Manager Modal -->
            <div v-if="showUnsubscribeModal" class="modal-overlay" style="z-index:9999;">
                <div class="modal-box w-full max-w-xl" style="max-height:90vh;display:flex;flex-direction:column;">
                    <div class="flex justify-between items-center p-4 border-b rounded-t-lg" style="background:linear-gradient(to right,#dc2626,#e11d48);color:#fff;">
                        <h3 class="font-bold text-lg flex items-center gap-2">🚫 退訂名單管理</h3>
                        <button @click="showUnsubscribeModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>
                    <div class="flex-1 overflow-y-auto p-4 space-y-4">
                        <div class="text-xs p-3" style="background:var(--color-warning-bg);border:1px solid #fde68a;border-radius:var(--radius-md);color:#92400e;">
                            名單中的 Email 在發送行銷活動時會自動略過，郵件底部會自動附加退訂連結。
                        </div>
                        <!-- Add email -->
                        <div class="flex gap-2">
                            <input v-model="unsubscribeMgmt.addEmail" type="email" class="input flex-1"
                                placeholder="手動新增：user@example.com"
                                :disabled="unsubscribeMgmt.adding"
                                @keyup.enter="addUnsubscribeEmail()" />
                            <button @click="addUnsubscribeEmail()"
                                class="btn btn-primary flex items-center gap-1"
                                :disabled="unsubscribeMgmt.adding || !unsubscribeMgmt.addEmail.trim()">
                                <span v-if="unsubscribeMgmt.adding" class="spinner spinner-sm"></span>
                                新增
                            </button>
                        </div>
                        <!-- List -->
                        <div>
                            <div class="flex items-center justify-between mb-2">
                                <div class="text-sm font-bold" style="color:var(--gray-700);">已退訂（{{ unsubscribeMgmt.items.length }}）</div>
                                <button @click="fetchUnsubscribeList()" class="btn btn-xs btn-secondary" :disabled="unsubscribeMgmt.loading">重新整理</button>
                            </div>
                            <div v-if="unsubscribeMgmt.loading" class="flex justify-center py-6"><span class="spinner spinner-lg"></span></div>
                            <div v-else-if="unsubscribeMgmt.items.length === 0" class="text-center py-6 text-sm border rounded-lg" style="color:var(--gray-400);">尚無退訂記錄</div>
                            <div v-else class="space-y-1 max-h-64 overflow-y-auto custom-scrollbar">
                                <div v-for="(r, idx) in unsubscribeMgmt.items" :key="keyById(r, 'unsub', idx)"
                                    class="flex items-center justify-between p-2 rounded border" style="background:var(--surface);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background='var(--surface)'">
                                    <div>
                                        <div class="text-sm font-medium" style="color:var(--gray-800);">{{ r.email }}</div>
                                        <div class="text-xs mt-0.5" style="color:var(--gray-400);">
                                            來源：{{ r.source === 'link' ? '點擊退訂連結' : r.source === 'manual' ? '手動加入' : r.source }}
                                            <span v-if="r.created_at"> · {{ new Date(r.created_at).toLocaleDateString() }}</span>
                                        </div>
                                    </div>
                                    <button @click="removeUnsubscribeEmail(r.id)"
                                        class="btn btn-xs btn-outline"
                                        style="color:var(--color-danger);border-color:#fca5a5;">
                                        移除
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Template Manager Modal -->
            <div v-if="showTemplateManagerModal" class="modal-overlay" style="z-index:9999;">
                <div class="modal-box w-full max-w-2xl" style="max-height:90vh;display:flex;flex-direction:column;">
                    <div class="flex justify-between items-center p-4 border-b rounded-t-lg" style="background:linear-gradient(to right,#4f46e5,#9333ea);color:#fff;">
                        <h3 class="font-bold text-lg flex items-center gap-2">📋 我的行銷範本</h3>
                        <button @click="showTemplateManagerModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>
                    <div class="flex-1 overflow-y-auto p-4 space-y-4">
                        <!-- New / Edit Form -->
                        <div class="border rounded-lg p-4 space-y-3" style="background:var(--gray-50);">
                            <div class="text-sm font-bold" style="color:var(--gray-700);">{{ templateMgmt.editingId ? '✏ 編輯範本' : '+ 新增範本' }}</div>
                            <div class="text-xs" style="color:var(--gray-500);">儲存已生成的 EDM 內容，下次可快速載入使用。</div>
                            <div>
                                <label class="text-xs font-semibold mb-1 block" style="color:var(--gray-600);">範本名稱 *</label>
                                <input v-model="templateMgmt.form.name" type="text" class="input w-full"
                                    placeholder="例如：Q2 促銷活動範本" :disabled="templateMgmt.saving" />
                            </div>
                            <div>
                                <label class="text-xs font-semibold mb-1 block" style="color:var(--gray-600);">備註說明</label>
                                <input v-model="templateMgmt.form.description" type="text" class="input w-full"
                                    placeholder="例如：適合新客戶首購活動" :disabled="templateMgmt.saving" />
                            </div>
                            <div>
                                <label class="text-xs font-semibold mb-1 block" style="color:var(--gray-600);">郵件主旨 *</label>
                                <input v-model="templateMgmt.form.subject" type="text" class="input w-full"
                                    placeholder="例如：🎉 限時優惠，把握最後機會！" :disabled="templateMgmt.saving" />
                            </div>
                            <div>
                                <label class="text-xs font-semibold mb-1 block" style="color:var(--gray-600);">HTML 內容 *</label>
                                <textarea v-model="templateMgmt.form.content_html" class="input w-full font-mono text-xs"
                                    rows="6" placeholder="貼入生成的 HTML 郵件內容" :disabled="templateMgmt.saving"></textarea>
                                <div class="text-xs mt-1" style="color:var(--gray-400);">
                                    提示：可從 AI 行銷「EDM 生成」步驟的結果直接複製 HTML，或點「另存為範本」快速存入。
                                </div>
                            </div>
                            <div class="flex gap-2 justify-end">
                                <button v-if="templateMgmt.editingId"
                                    @click="templateMgmt.editingId = null; templateMgmt.form = { name:'', description:'', subject:'', content_html:'' }"
                                    class="btn btn-secondary" :disabled="templateMgmt.saving">
                                    取消
                                </button>
                                <button @click="saveCustomTemplate"
                                    class="btn btn-primary flex items-center gap-1"
                                    :disabled="templateMgmt.saving || !templateMgmt.form.name.trim()">
                                    <span v-if="templateMgmt.saving" class="spinner spinner-sm"></span>
                                    {{ templateMgmt.saving ? '儲存中...' : (templateMgmt.editingId ? '更新範本' : '新增範本') }}
                                </button>
                            </div>
                        </div>

                        <!-- Template List -->
                        <div>
                            <div class="text-sm font-bold mb-2" style="color:var(--gray-700);">已儲存範本（{{ templateMgmt.items.length }}）</div>
                            <div v-if="templateMgmt.loading" class="flex justify-center py-6">
                                <span class="spinner spinner-lg"></span>
                            </div>
                            <div v-else-if="templateMgmt.items.length === 0" class="text-center py-6 text-sm border rounded-lg" style="color:var(--gray-400);">
                                尚無自訂範本，請在上方新增
                            </div>
                            <div v-else class="space-y-2">
                                <div v-for="(t, idx) in templateMgmt.items" :key="keyById(t, 'tmgr', idx)"
                                    class="flex items-center justify-between border rounded-lg p-3 transition" style="background:var(--surface);" onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background='var(--surface)'">
                                    <div>
                                        <div class="font-semibold text-sm" style="color:var(--gray-800);">{{ t.name }}</div>
                                        <div class="text-xs mt-0.5" style="color:var(--gray-500);">
                                            <span v-if="t.product_name">{{ t.product_name }}</span>
                                            <span v-if="t.target_audience"> · {{ t.target_audience }}</span>
                                            <span v-if="t.tone"> · {{ t.tone }}</span>
                                        </div>
                                    </div>
                                    <div class="flex gap-2">
                                        <button @click="startEditCustomTemplate(t)"
                                            class="btn btn-xs btn-outline">
                                            ✏ 編輯
                                        </button>
                                        <button @click="deleteCustomTemplate(t.id)"
                                            class="btn btn-xs btn-outline"
                                            style="color:var(--color-danger);border-color:#fca5a5;"
                                            :disabled="templateMgmt.deleting === t.id">
                                            <span v-if="templateMgmt.deleting === t.id" class="spinner spinner-sm"></span>
                                            <span v-else>🗑</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 進階分群 Modal -->
            <div v-if="showAdvancedSegmentModal" class="modal-overlay" style="z-index:9999;">
                <div class="modal-box w-full max-w-lg">
                    <div class="flex justify-between items-center p-4 border-b rounded-t-lg" style="background:linear-gradient(to right,#7c3aed,#4f46e5);color:#fff;">
                        <h3 class="font-bold text-lg">🎯 進階分群匯入</h3>
                        <button @click="showAdvancedSegmentModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>
                    <div class="p-4 space-y-4">
                        <div>
                            <label class="text-xs font-bold mb-1 block" style="color:var(--gray-700);">分群名稱</label>
                            <input v-model="advancedSegmentForm.name" type="text" class="input w-full" placeholder="例如：2026Q2 開信者" />
                        </div>
                        <div>
                            <label class="text-xs font-bold mb-1 block" style="color:var(--gray-700);">篩選條件</label>
                            <select v-model="advancedSegmentForm.filter_type" class="input w-full">
                                <option value="opened_campaign">✅ 曾開信（指定活動）</option>
                                <option value="clicked_campaign">🖱 曾點擊（指定活動）</option>
                                <option value="inactive">💤 閒置聯絡人（N 天無互動）</option>
                                <option value="high_engage">🔥 高互動（開信次數 ≥ N）</option>
                            </select>
                        </div>
                        <div v-if="advancedSegmentForm.filter_type === 'opened_campaign' || advancedSegmentForm.filter_type === 'clicked_campaign'">
                            <label class="text-xs font-bold mb-1 block" style="color:var(--gray-700);">活動 ID</label>
                            <input v-model="advancedSegmentForm.campaign_id" type="number" class="input w-full" placeholder="輸入 Campaign ID（在活動列表中查看）" />
                        </div>
                        <div v-if="advancedSegmentForm.filter_type === 'inactive'">
                            <label class="text-xs font-bold mb-1 block" style="color:var(--gray-700);">閒置天數</label>
                            <select v-model="advancedSegmentForm.inactive_days" class="input w-full">
                                <option :value="30">30 天</option>
                                <option :value="60">60 天</option>
                                <option :value="90">90 天</option>
                                <option :value="180">180 天</option>
                            </select>
                        </div>
                        <div v-if="advancedSegmentForm.filter_type === 'high_engage'">
                            <label class="text-xs font-bold mb-1 block" style="color:var(--gray-700);">最低開信次數</label>
                            <select v-model="advancedSegmentForm.min_open_count" class="input w-full">
                                <option :value="2">≥ 2 次</option>
                                <option :value="3">≥ 3 次</option>
                                <option :value="5">≥ 5 次</option>
                                <option :value="10">≥ 10 次</option>
                            </select>
                        </div>
                        <div v-if="advancedSegmentResult" class="rounded-lg p-3 text-xs" style="background:#ede9fe;color:#5b21b6;">
                            ✓ 找到 {{ advancedSegmentResult.count }} 位符合條件，已匯入收件人列表
                        </div>
                        <div class="flex justify-end gap-2">
                            <button @click="showAdvancedSegmentModal = false" class="btn btn-secondary">取消</button>
                            <button @click="submitAdvancedSegment()" :disabled="advancedSegmentLoading || !advancedSegmentForm.name.trim()"
                                class="btn btn-primary">
                                <span v-if="advancedSegmentLoading" class="spinner spinner-sm"></span>
                                {{ advancedSegmentLoading ? '篩選中...' : '匯入收件人' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 訂閱表單產生器 Modal -->
            <div v-if="showSubscribeFormModal" class="modal-overlay" style="z-index:9999;">
                <div class="modal-box w-full max-w-2xl" style="max-height:90vh;display:flex;flex-direction:column;">
                    <div class="flex justify-between items-center p-4 border-b rounded-t-lg" style="background:linear-gradient(to right,#059669,#0d9488);color:#fff;">
                        <h3 class="font-bold text-lg">📋 訂閱表單產生器</h3>
                        <button @click="showSubscribeFormModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>
                    <div class="flex-1 overflow-y-auto p-4 space-y-4">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                                <label class="text-xs font-bold mb-1 block" style="color:var(--gray-700);">表單標題</label>
                                <input v-model="subscribeFormConfig.title" type="text" class="input w-full" placeholder="訂閱我們的電子報" />
                            </div>
                            <div>
                                <label class="text-xs font-bold mb-1 block" style="color:var(--gray-700);">按鈕文字</label>
                                <input v-model="subscribeFormConfig.button_text" type="text" class="input w-full" placeholder="立即訂閱" />
                            </div>
                            <div>
                                <label class="text-xs font-bold mb-1 block" style="color:var(--gray-700);">主色</label>
                                <div class="flex gap-2 items-center">
                                    <input v-model="subscribeFormConfig.accent_color" type="color" class="w-10 h-9 rounded cursor-pointer border" />
                                    <input v-model="subscribeFormConfig.accent_color" type="text" class="input flex-1" placeholder="#4f46e5" />
                                </div>
                            </div>
                        </div>
                        <button @click="generateSubscribeFormEmbed()" :disabled="subscribeFormLoading"
                            class="btn btn-primary">
                            {{ subscribeFormLoading ? '產生中...' : '⚙️ 產生嵌入碼' }}
                        </button>
                        <div v-if="subscribeFormEmbed" class="space-y-4">
                            <div>
                                <div class="text-xs font-bold mb-2" style="color:var(--gray-700);">表單預覽</div>
                                <iframe :srcdoc="subscribeFormEmbed.embed_html" style="width:100%;height:180px;border:1px solid var(--border);border-radius:8px;background:#f9fafb;" sandbox="allow-same-origin"></iframe>
                            </div>
                            <div>
                                <div class="flex items-center justify-between mb-1">
                                    <span class="text-xs font-bold" style="color:var(--gray-700);">HTML 嵌入碼</span>
                                    <button @click="() => { navigator.clipboard.writeText(subscribeFormEmbed.embed_html); $toast?.success('已複製嵌入碼') }"
                                        class="btn btn-xs btn-outline">複製</button>
                                </div>
                                <textarea :value="subscribeFormEmbed.embed_html" readonly rows="8"
                                    class="input w-full font-mono text-xs resize-none" style="background:var(--gray-50);"></textarea>
                            </div>
                            <div class="text-xs" style="color:var(--gray-500);">
                                訂閱端點：<code style="background:var(--gray-100);padding:2px 6px;border-radius:4px;">{{ subscribeFormEmbed.subscribe_url }}</code>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 收件匣預覽 Modal -->
            <div v-if="showInboxPreviewModal" class="modal-overlay" style="z-index:9999;">
                <div class="modal-box w-full" style="max-width:960px;max-height:95vh;display:flex;flex-direction:column;">
                    <div class="flex justify-between items-center p-4 border-b rounded-t-lg" style="background:linear-gradient(to right,#059669,#0891b2);color:#fff;">
                        <h3 class="font-bold text-lg flex items-center gap-2">📬 收件匣預覽</h3>
                        <button @click="showInboxPreviewModal = false" class="btn btn-ghost btn-sm" style="color:#fff;">×</button>
                    </div>
                    <div class="flex-1 overflow-hidden" style="display:flex;flex-direction:column;">
                        <!-- Tabs -->
                        <div class="flex border-b" style="background:var(--gray-50);">
                            <button v-for="tab in [{key:'desktop',label:'🖥 桌面版'},{key:'mobile',label:'📱 手機版'},{key:'dark',label:'🌙 深色模式'}]"
                                :key="tab.key"
                                @click="inboxPreviewTab = tab.key"
                                class="px-5 py-2.5 text-sm font-medium transition border-b-2"
                                :style="inboxPreviewTab === tab.key ? 'border-color:#059669;color:#059669;' : 'border-color:transparent;color:var(--gray-600);'">
                                {{ tab.label }}
                            </button>
                        </div>
                        <!-- Preview Frame -->
                        <div class="flex-1 overflow-hidden" style="background:#e5e7eb;padding:16px;display:flex;justify-content:center;align-items:flex-start;">
                            <!-- Desktop -->
                            <div v-if="inboxPreviewTab === 'desktop'" style="width:100%;max-width:700px;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,0.12);">
                                <div style="background:#f3f4f6;padding:8px 14px;font-size:12px;color:#6b7280;border-bottom:1px solid #e5e7eb;">
                                    收件匣 &gt; <strong style="color:#111827;">{{ aiMarketingState.fullResult?.subject || '(郵件主旨)' }}</strong>
                                </div>
                                <iframe :srcdoc="inboxPreviewHtml" style="width:100%;height:60vh;border:none;display:block;" sandbox="allow-same-origin"></iframe>
                            </div>
                            <!-- Mobile -->
                            <div v-if="inboxPreviewTab === 'mobile'" style="width:375px;background:#fff;border-radius:20px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,0.2);border:6px solid #1f2937;">
                                <div style="background:#f9fafb;padding:6px 12px;font-size:11px;color:#6b7280;border-bottom:1px solid #e5e7eb;text-align:center;">
                                    📧 {{ aiMarketingState.fullResult?.subject || '(郵件主旨)' }}
                                </div>
                                <iframe :srcdoc="inboxPreviewHtml" style="width:375px;height:60vh;border:none;display:block;" sandbox="allow-same-origin"></iframe>
                            </div>
                            <!-- Dark Mode -->
                            <div v-if="inboxPreviewTab === 'dark'" style="width:100%;max-width:700px;background:#1f2937;border-radius:8px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,0.4);">
                                <div style="background:#111827;padding:8px 14px;font-size:12px;color:#9ca3af;border-bottom:1px solid #374151;">
                                    🌙 {{ aiMarketingState.fullResult?.subject || '(郵件主旨)' }}
                                </div>
                                <iframe :srcdoc="inboxPreviewHtml"
                                    style="width:100%;height:60vh;border:none;display:block;filter:invert(1) hue-rotate(180deg);"
                                    sandbox="allow-same-origin"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    </div>

    <!-- Hover image preview popup -->
    <teleport to="body">
      <div v-if="hoverPreviewSrc"
        style="position:fixed;z-index:99999;pointer-events:none;padding:6px;background:#fff;border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,0.28);border:1px solid rgba(0,0,0,0.08);"
        :style="{ left: hoverPreviewPos.x + 'px', top: (hoverPreviewPos.y - 8) + 'px', transform: 'translate(-50%, -100%)' }">
        <img :src="hoverPreviewSrc"
          style="display:block;max-width:260px;max-height:260px;object-fit:contain;border-radius:8px;">
      </div>
    </teleport>

</template>

<script>
import { defineComponent, ref, watch, nextTick } from 'vue'
import { storeToRefs } from 'pinia'
import { useAppStore, ADMIN_API } from '../store/app.js'
import * as openpgp from 'openpgp'
import axios from 'axios'

export default defineComponent({
  name: 'WebmailView',
  setup() {
    const store = useAppStore()
    const refs = storeToRefs(store)
    const actions = {}
    for (const key of Object.keys(store)) {
      if (typeof store[key] === 'function') {
        actions[key] = store[key]
      }
    }

    // PGP compose state
    const pgpEncryptEnabled = ref(false)
    const pgpRecipientKey = ref(null)   // armored public key of recipient
    const pgpKeyInfo = ref(null)        // { fingerprint, email }

    // Watch recipient field — look up PGP key automatically
    const _lookupTimer = ref(null)
    const lookupRecipientPgpKey = async (email) => {
      pgpRecipientKey.value = null
      pgpKeyInfo.value = null
      pgpEncryptEnabled.value = false
      if (!email || !email.includes('@')) return
      try {
        const res = await axios.get(`${store.ADMIN_API}/users/pgp/lookup?email=${encodeURIComponent(email)}`)
        if (res.data.found && res.data.keys.length > 0) {
          pgpRecipientKey.value = res.data.keys[0].public_key
          pgpKeyInfo.value = res.data.keys[0]
        }
      } catch (e) {
        // ignore
      }
    }

    watch(() => refs.composeForm?.value?.to, (val) => {
      if (_lookupTimer.value) clearTimeout(_lookupTimer.value)
      _lookupTimer.value = setTimeout(() => {
        const firstEmail = (val || '').split(',')[0].trim().replace(/.*<(.+)>.*/, '$1')
        lookupRecipientPgpKey(firstEmail)
      }, 600)
    })

    const togglePgpEncrypt = () => {
      if (!pgpRecipientKey.value) return
      pgpEncryptEnabled.value = !pgpEncryptEnabled.value
    }

    // Hook: called by store's sendEmail BEFORE sending (injected via window)
    window.__pgpBeforeSend = async (subject, body) => {
      if (!pgpEncryptEnabled.value || !pgpRecipientKey.value) return { subject, body }
      try {
        const pubKey = await openpgp.readKey({ armoredKey: pgpRecipientKey.value })
        const encrypted = await openpgp.encrypt({
          message: await openpgp.createMessage({ text: `Subject: ${subject}\n\n${body}` }),
          encryptionKeys: pubKey,
        })
        return {
          subject: `[PGP 加密] ${subject}`,
          body: encrypted,
          pgp_encrypted: true,
        }
      } catch (e) {
        if (!confirm(`PGP 加密失敗：${e.message}\n\n是否改以明文傳送？`)) {
          throw new Error('PGP 加密取消')
        }
        return { subject, body }
      }
    }

    // PGP decrypt for reading
    const pgpDecryptModal = ref(false)
    const pgpPrivKeyInput = ref('')
    const pgpPassphrase = ref('')
    const pgpDecrypted = ref('')
    const pgpDecryptError = ref('')
    const pgpDecryptLoading = ref(false)
    const pgpCiphertext = ref('')

    const openPgpDecrypt = (ciphertext) => {
      pgpCiphertext.value = ciphertext
      pgpPrivKeyInput.value = ''
      pgpPassphrase.value = ''
      pgpDecrypted.value = ''
      pgpDecryptError.value = ''
      pgpDecryptModal.value = true
    }

    const doDecrypt = async () => {
      pgpDecryptError.value = ''
      pgpDecryptLoading.value = true
      try {
        const privKey = await openpgp.decryptKey({
          privateKey: await openpgp.readPrivateKey({ armoredKey: pgpPrivKeyInput.value }),
          passphrase: pgpPassphrase.value,
        })
        const message = await openpgp.readMessage({ armoredMessage: pgpCiphertext.value })
        const { data } = await openpgp.decrypt({ message, decryptionKeys: privKey })
        pgpDecrypted.value = data
      } catch (e) {
        pgpDecryptError.value = '解密失敗：' + (e.message || e)
      } finally {
        pgpDecryptLoading.value = false
      }
    }

    const filteredRefs = Object.fromEntries(
      Object.entries(refs).filter(([k]) => !k.startsWith('$') && !k.startsWith('_'))
    )
    const filteredActions = Object.fromEntries(
      Object.entries(actions).filter(([k]) => !k.startsWith('$') && !k.startsWith('_'))
    )

    // Recent uploads quick panel
    const composeRecentOpen = ref(false)

    // Hover image preview
    const hoverPreviewSrc = ref(null)
    const hoverPreviewPos = ref({ x: 0, y: 0 })
    function showHoverPreview(src, event) {
      if (!src) return
      hoverPreviewSrc.value = src
      hoverPreviewPos.value = { x: event.clientX, y: event.clientY }
    }
    function hideHoverPreview() {
      hoverPreviewSrc.value = null
    }

    const campaignListMaximized = ref(false)
    const aiMarketingMaximized = ref(false)

    // ── Rich text editor ──
    const _populateRichEditor = async () => {
      await nextTick()
      const el = document.getElementById('richEditor')
      if (!el) return
      const html = store.composeForm.html_body
      if (html && html.toString().trim()) {
        el.innerHTML = html
      } else if (store.composeForm.body) {
        el.innerHTML = store.composeForm.body.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\n/g,'<br>')
      } else {
        el.innerHTML = ''
      }
    }

    const switchComposeMode = async (newMode) => {
      const richEl = document.getElementById('richEditor')
      if (store.composeEditorMode === 'rich' && richEl) {
        store.composeForm.html_body = richEl.innerHTML
        store.composeForm.body = richEl.innerText
      }
      store.composeEditorMode = newMode
      if (newMode === 'rich') {
        await _populateRichEditor()
      }
    }

    // When store switches mode to 'rich' externally (reply, forward, open compose)
    watch(() => store.composeEditorMode, async (mode) => {
      if (mode === 'rich') await _populateRichEditor()
    })

    // When store sets html_body externally while already in rich mode
    // (e.g. AI draft inserted, modal reopened/cleared)
    // Skip if richEditor is the active element — that means the user is typing
    watch(() => store.composeForm?.html_body, async () => {
      if (store.composeEditorMode !== 'rich') return
      const el = document.getElementById('richEditor')
      if (!el || document.activeElement === el) return
      await _populateRichEditor()
    })

    // ── Rich toolbar commands (document is not accessible in Vue 3 templates) ──
    const _richSavedRange = { current: null }

    const saveRichSel = () => {
      const sel = window.getSelection()
      if (sel && sel.rangeCount > 0) _richSavedRange.current = sel.getRangeAt(0).cloneRange()
    }

    const _syncRich = () => {
      const el = document.getElementById('richEditor')
      if (el) { store.composeForm.html_body = el.innerHTML; store.composeForm.body = el.innerText }
    }

    // Always: refocus editor, restore selection, then execute command
    const richExec = (cmd, val) => {
      const el = document.getElementById('richEditor')
      if (!el) return
      el.focus()
      if (_richSavedRange.current) {
        try {
          const sel = window.getSelection()
          sel.removeAllRanges()
          sel.addRange(_richSavedRange.current)
        } catch (e) {}
      }
      document.execCommand(cmd, false, val !== undefined ? val : null)
      _syncRich()
    }

    const richSetFont = (e) => { const v = e.target.value; if (v) richExec('fontName', v) }
    const richSetSize = (e) => { const v = e.target.value; if (v) { e.target.value = ''; richExec('fontSize', v) } }
    const richSetForeColor = (e) => richExec('foreColor', e.target.value)
    const richSetHilite = (e) => richExec('hiliteColor', e.target.value)
    const richInsertLink = () => {
      saveRichSel()
      // eslint-disable-next-line no-alert
      const url = window.prompt('請輸入連結 URL：', 'https://')
      if (url) richExec('createLink', url)
    }

    // ── 內文插入圖片（貼上 / 按鈕 / 拖曳）──────────────────────────────────
    const composeImageInput = ref(null)
    const composeImgUploading = ref(false)

    const _uploadComposeImage = async (fileOrBlob) => {
      composeImgUploading.value = true
      try {
        const fd = new FormData()
        fd.append('file', fileOrBlob, fileOrBlob.name || 'image.png')
        const res = await axios.post(
          `${ADMIN_API}/ai/marketing/landing/upload-image`, fd,
          { headers: { ...authHdr(), 'Content-Type': 'multipart/form-data' } }
        )
        let url = res.data?.url || ''
        // 郵件 <img> 需絕對網址，否則收件者信箱無法顯示
        if (url.startsWith('/')) url = window.location.origin + url
        return url
      } catch (e) {
        window.$toast?.error('圖片上傳失敗', e.response?.data?.detail || e.message)
        return null
      } finally {
        composeImgUploading.value = false
      }
    }

    const insertComposeImage = async (fileOrBlob) => {
      if (!fileOrBlob || !(fileOrBlob.type || '').startsWith('image/')) return
      saveRichSel()
      const url = await _uploadComposeImage(fileOrBlob)
      if (!url) return
      richExec('insertHTML', `<img src="${url}" style="max-width:100%;height:auto;" alt="">`)
    }

    const triggerComposeImage = () => { saveRichSel(); composeImageInput.value?.click() }
    const onComposeImagePick = (e) => {
      const f = e.target.files?.[0]
      e.target.value = ''
      if (f) insertComposeImage(f)
    }

    // 貼上：剪貼簿有圖片 → 上傳插入；否則沿用原本貼上 HTML/純文字
    const onComposePaste = (e) => {
      const items = e.clipboardData?.items || []
      for (const it of items) {
        if (it.type && it.type.startsWith('image/')) {
          e.preventDefault()
          const file = it.getAsFile()
          if (file) insertComposeImage(file)
          return
        }
      }
      e.preventDefault()
      const html = e.clipboardData.getData('text/html') || e.clipboardData.getData('text/plain')
      richExec('insertHTML', html)
    }

    // 拖曳圖片進內文 → 在放下位置插入（與「拖曳=附件」區分）
    const onComposeEditorDrop = (e) => {
      const file = e.dataTransfer?.files?.[0]
      if (!file || !file.type.startsWith('image/')) return false
      try {
        const r = document.caretRangeFromPoint(e.clientX, e.clientY)
        if (r) { const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r) }
      } catch (_) {}
      saveRichSel()
      insertComposeImage(file)
      return true
    }

    // ── Tracking link insertion ──
    const trackingLinkForm = ref({ label: '', url: '', style: 'button' })
    const insertedLinkSnippets = ref([])

    // ── 插入行銷頁面 / 問卷 ──────────────────────────────────────────
    const insertPageTab = ref('landing')
    const insertPageList = ref([])
    const insertPageSelected = ref(null)
    const insertPageLabel = ref('')
    const insertPageStyle = ref('button')

    const authHdr = () => {
      const t = localStorage.getItem('token') || ''
      return { Authorization: `Bearer ${t}` }
    }

    const loadInsertPageList = async () => {
      insertPageSelected.value = null
      insertPageLabel.value = ''
      try {
        if (insertPageTab.value === 'landing') {
          const res = await axios.get(`${ADMIN_API}/ai/marketing/landing/`, { headers: authHdr() })
          insertPageList.value = res.data || []
        } else if (insertPageTab.value === 'survey') {
          const res = await axios.get(`${ADMIN_API}/ai/survey/`, { headers: authHdr() })
          insertPageList.value = res.data || []
        } else {
          const res = await axios.get(`${ADMIN_API}/ai/booking/pages`, { headers: authHdr() })
          insertPageList.value = res.data || []
        }
      } catch (e) {
        window.$toast?.error('載入失敗', e?.response?.data?.detail || e.message)
        insertPageList.value = []
      }
    }

    const pagePublicUrl = (p) => {
      if (!p) return ''
      const base = location.origin
      if (insertPageTab.value === 'landing') return `${base}/p/${p.slug}`
      if (insertPageTab.value === 'booking') return `${base}/book/${p.slug}`
      return `${base}/s/${p.slug}`
    }

    const autoFillInsertLabel = () => {
      if (insertPageSelected.value && !insertPageLabel.value.trim()) {
        if (insertPageTab.value === 'landing') insertPageLabel.value = '立即了解'
        else if (insertPageTab.value === 'booking') insertPageLabel.value = '立即預約'
        else insertPageLabel.value = '立即填寫問卷'
      }
    }

    const insertPageLink = () => {
      const p = insertPageSelected.value
      const label = insertPageLabel.value.trim()
      if (!p || !label) return
      const url = pagePublicUrl(p)
      const color = insertPageTab.value === 'landing' ? '#6366f1' : insertPageTab.value === 'booking' ? '#f59e0b' : '#10b981'
      const snippet = insertPageStyle.value === 'button'
        ? `\n<div style="text-align:center;margin:24px 0;padding:0 24px;"><a href="${url}" style="display:inline-block;padding:14px 36px;background:${color};color:#ffffff;text-decoration:none;border-radius:8px;font-weight:700;font-size:15px;">${label}</a></div>`
        : `\n<p style="text-align:center;margin:16px 0;font-size:14px;"><a href="${url}" style="color:${color};text-decoration:underline;font-weight:500;">${label}</a></p>`

      const html = store.aiMarketingState.result || ''
      const bodyIdx = html.toLowerCase().lastIndexOf('</body>')
      const newHtml = bodyIdx >= 0
        ? html.slice(0, bodyIdx) + snippet + '\n' + html.slice(bodyIdx)
        : html + snippet
      store.aiMarketingState.result = newHtml
      if (store.aiMarketingState.fullResult) {
        store.aiMarketingState.fullResult = { ...store.aiMarketingState.fullResult, body_html: newHtml }
      }
      insertedLinkSnippets.value.push({ label, url: url, snippet, style: insertPageStyle.value })
      insertPageLabel.value = ''
      window.$toast?.success('已插入', `「${label}」連結已加入 EDM`)
    }

    // Load landing page list on first open
    watch(() => store.showAiMarketingModal, (v) => { if (v) loadInsertPageList() })

    const insertTrackingLink = () => {
      const label = trackingLinkForm.value.label.trim()
      const url   = trackingLinkForm.value.url.trim()
      if (!label || !url) { window.$toast?.warning('欄位不完整', '請填寫按鈕文字和目標網址'); return }
      if (!/^https?:\/\//i.test(url)) { window.$toast?.error('格式錯誤', '網址必須以 http:// 或 https:// 開頭'); return }

      const snippet = trackingLinkForm.value.style === 'button'
        ? `\n<div style="text-align:center;margin:24px 0;padding:0 24px;"><a href="${url}" style="display:inline-block;padding:14px 36px;background:#6366f1;color:#ffffff;text-decoration:none;border-radius:8px;font-weight:700;font-size:15px;">${label}</a></div>`
        : `\n<p style="text-align:center;margin:16px 0;font-size:14px;"><a href="${url}" style="color:#6366f1;text-decoration:underline;font-weight:500;">${label}</a></p>`

      const html = store.aiMarketingState.result || ''
      const bodyIdx = html.toLowerCase().lastIndexOf('</body>')
      const newHtml = bodyIdx >= 0
        ? html.slice(0, bodyIdx) + snippet + '\n' + html.slice(bodyIdx)
        : html + snippet

      store.aiMarketingState.result = newHtml
      if (store.aiMarketingState.fullResult) {
        store.aiMarketingState.fullResult = { ...store.aiMarketingState.fullResult, body_html: newHtml }
      }
      insertedLinkSnippets.value.push({ label, url, snippet, style: trackingLinkForm.value.style })
      trackingLinkForm.value.label = ''
      trackingLinkForm.value.url   = ''
      window.$toast?.success('已插入', `「${label}」連結已加入 EDM，寄出後將自動追蹤點擊`)
    }

    const removeInsertedLink = (idx) => {
      const item = insertedLinkSnippets.value[idx]
      if (!item) return
      const html = store.aiMarketingState.result || ''
      if (!html.includes(item.snippet)) { window.$toast?.error('移除失敗', '找不到對應片段，可能內容已變更'); return }
      const newHtml = html.replace(item.snippet, '')
      store.aiMarketingState.result = newHtml
      if (store.aiMarketingState.fullResult) {
        store.aiMarketingState.fullResult = { ...store.aiMarketingState.fullResult, body_html: newHtml }
      }
      insertedLinkSnippets.value.splice(idx, 1)
    }

    // Clear inserted list when EDM is re-generated
    watch(() => store.aiMarketingState.loading, (loading, wasLoading) => {
      if (wasLoading && !loading) insertedLinkSnippets.value = []
    })

    function handleMarketingTabClick(tab) {
      if (tab.key === 'journey') {
        store.aiMarketingState.step = 'journey'
        store.fetchJourneys()
      } else if (tab.key === 'campaign' && !store.aiMarketingState.result && !store.aiMarketingState.fullResult) {
        window.$toast?.info('活動發送', '請先在「EDM 生成」tab 生成行銷內容，再建立活動')
        store.aiMarketingState.step = 'generate'
      } else {
        store.aiMarketingState.step = tab.key
      }
    }

    return {
      store, ...filteredRefs, ...filteredActions,
      handleMarketingTabClick,
      // Tracking link
      trackingLinkForm, insertedLinkSnippets, insertTrackingLink, removeInsertedLink,
      // Insert page/survey link
      insertPageTab, insertPageList, insertPageSelected, insertPageLabel, insertPageStyle,
      loadInsertPageList, pagePublicUrl, autoFillInsertLabel, insertPageLink,
      // PGP
      pgpEncryptEnabled, pgpRecipientKey, pgpKeyInfo,
      togglePgpEncrypt,
      pgpDecryptModal, pgpPrivKeyInput, pgpPassphrase,
      pgpDecrypted, pgpDecryptError, pgpDecryptLoading, pgpCiphertext,
      openPgpDecrypt, doDecrypt,
      // Recent uploads panel
      composeRecentOpen,
      // Hover preview
      hoverPreviewSrc, hoverPreviewPos, showHoverPreview, hideHoverPreview,
      // Campaign list modal
      campaignListMaximized,
      aiMarketingMaximized,
      // Rich text
      switchComposeMode, saveRichSel, richExec,
      richSetFont, richSetSize, richSetForeColor, richSetHilite, richInsertLink,
      composeImageInput, composeImgUploading, triggerComposeImage, onComposeImagePick,
      onComposePaste, onComposeEditorDrop,
    }
  }
})
</script>

<style scoped>
/* Rich editor placeholder */
#richEditor:empty::before {
  content: attr(data-placeholder);
  color: #adb5bd;
  pointer-events: none;
}

/* CBI Modal */
.cbi-modal { display:flex; flex-direction:column; max-height:90vh; }
.cbi-header { background:linear-gradient(135deg,#4f46e5 0%,#7c3aed 100%); flex-shrink:0; }

/* Loading */
.cbi-loading-body { padding:2.5rem 2rem; display:flex; flex-direction:column; align-items:center; }
.cbi-loading-icon {
  width:64px; height:64px; border-radius:50%;
  background:linear-gradient(135deg,#4f46e5,#7c3aed);
  display:flex; align-items:center; justify-content:center;
  font-size:1.75rem; margin-bottom:1.25rem;
  animation:cbi-pulse 1.5s ease-in-out infinite;
}
.cbi-loading-hint { margin-top:1.5rem; font-size:0.75rem; color:var(--gray-400); }
.cbi-steps { width:100%; max-width:320px; display:flex; flex-direction:column; gap:0.625rem; }
.cbi-step {
  display:flex; align-items:center; gap:0.75rem;
  padding:0.625rem 0.875rem; border-radius:0.5rem;
  background:var(--gray-50); opacity:0;
}
.cbi-step-done { opacity:1; }
.cbi-step-label { font-size:0.875rem; color:var(--gray-700); }
.cbi-step-icon { font-size:1rem; width:1.25rem; text-align:center; flex-shrink:0; }
.cbi-step-icon.done { color:#16a34a; font-weight:700; }
.cbi-step-icon.spin { color:#7c3aed; display:inline-block; animation:cbi-spin 1s linear infinite; }

/* Result */
.cbi-tag {
  padding:0.125rem 0.5rem; border-radius:9999px; font-size:0.75rem; font-weight:500;
  background:#e0e7ff; color:#4f46e5;
}
.cbi-tag-gray {
  padding:0.125rem 0.5rem; border-radius:9999px; font-size:0.75rem; font-weight:500;
  background:#f3f4f6; color:var(--gray-600);
}
.cbi-confidence {
  font-size:1.5rem; font-weight:700; line-height:1;
  width:3rem; height:3rem; border-radius:50%;
  display:flex; align-items:center; justify-content:center;
  font-size:1rem; font-weight:800;
}
.cbi-confidence.high { background:#dcfce7; color:#15803d; }
.cbi-confidence.mid  { background:#fef3c7; color:#b45309; }
.cbi-confidence.low  { background:#fee2e2; color:#b91c1c; }

.cbi-intent-badge {
  padding:0.25rem 0.75rem; border-radius:9999px; font-size:0.75rem; font-weight:700;
  background:#e0e7ff; color:#4f46e5;
}
.cbi-intent-badge[data-type="quote"]       { background:#dbeafe; color:#1d4ed8; }
.cbi-intent-badge[data-type="inquiry"]     { background:#f3e8ff; color:#7c3aed; }
.cbi-intent-badge[data-type="complaint"]   { background:#fee2e2; color:#dc2626; }
.cbi-intent-badge[data-type="partnership"] { background:#dcfce7; color:#16a34a; }
.cbi-intent-badge[data-type="other"]       { background:#f3f4f6; color:#6b7280; }

.cbi-req-card {
  padding:0.75rem; border-radius:0.5rem;
  background:var(--gray-50); border-left:3px solid #7c3aed;
}
.cbi-conf-badge {
  padding:0.125rem 0.5rem; border-radius:9999px; font-size:0.7rem; font-weight:700;
}
.cbi-conf-badge.high { background:#dcfce7; color:#15803d; }
.cbi-conf-badge.mid  { background:#fef3c7; color:#b45309; }
.cbi-conf-badge.low  { background:#fee2e2; color:#b91c1c; }

.cbi-step-num {
  flex-shrink:0; width:1.25rem; height:1.25rem; border-radius:50%;
  background:#4f46e5; color:#fff; font-size:0.7rem; font-weight:700;
  display:flex; align-items:center; justify-content:center; margin-top:1px;
}
.cbi-source-badge {
  padding:0.125rem 0.375rem; border-radius:0.25rem; font-weight:600;
  background:#e0e7ff; color:#4f46e5;
}

/* CBI List Table */
.cbi-list-table { border-collapse:collapse; width:100%; }
.cbi-th {
  padding:0.5rem 0.75rem; text-align:left;
  font-size:0.75rem; font-weight:700; color:var(--gray-600);
  white-space:nowrap;
}
.cbi-td { padding:0.625rem 0.75rem; vertical-align:middle; }
.cbi-list-row { border-bottom:1px solid var(--gray-100); transition:background 0.12s; }
.cbi-list-row:hover { background:var(--gray-50); }

.cbi-status-linked {
  padding:0.125rem 0.5rem; border-radius:9999px; font-size:0.7rem; font-weight:600;
  background:#dcfce7; color:#15803d;
}
.cbi-status-new {
  padding:0.125rem 0.5rem; border-radius:9999px; font-size:0.7rem; font-weight:600;
  background:#f3f4f6; color:var(--gray-500);
}

/* Animations */
@keyframes cbi-pulse {
  0%,100% { transform:scale(1); box-shadow:0 0 0 0 rgba(124,58,237,0.4); }
  50%      { transform:scale(1.08); box-shadow:0 0 0 12px rgba(124,58,237,0); }
}
@keyframes cbi-step-in {
  from { opacity:0; transform:translateX(-8px); }
  to   { opacity:1; transform:translateX(0); }
}
@keyframes cbi-spin {
  from { transform:rotate(0deg); }
  to   { transform:rotate(360deg); }
}
</style>


